// import { useState, useEffect, useContext, useCallback, useMemo, useRef } from "react";
// import { AuthContext } from "../context/AuthContext";
// import { useIncomingMode } from "../context/IncomingModeContext";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// import { motion, AnimatePresence } from "framer-motion";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // ─── Role helpers ────────────────────────────────────────────────────────────
// const ROLE = {
//   COMPANY: "COMPANY",
//   VICE_PRESIDENT: "VICE_PRESIDENT",
//   MANAGER: "MANAGER",
//   TEAM_LEAD: "TEAM_LEAD",
//   EXECUTIVE: "EXECUTIVE",
//   HR: "HR",
//   SUPER_SUPER_ADMIN: "SUPER_SUPER_ADMIN",
//   SUPER_ADMIN: "SUPER_ADMIN",
//   RESELLER: "RESELLER",
// };

// const isOwnerLevel = (t) =>
//   [ROLE.COMPANY, ROLE.SUPER_SUPER_ADMIN, ROLE.SUPER_ADMIN, ROLE.RESELLER].includes(t);

// const authHeader = () => ({
//   Authorization: `Bearer ${localStorage.getItem("token")}`,
// });

// // Returns true when the phone number is masked/hidden (contains mask characters
// // like * or x/X instead of the full set of digits), i.e. only the last 3-4
// // digits are visible. Used to lock inline editing for masked numbers.
// const isPhoneMasked = (phone) => {
//   if (!phone) return false;
//   return /[*xX]/.test(phone);
// };

// // ─── WhatsApp SVG Icon ────────────────────────────────────────────────────────
// const SGWhatsAppIcon = () => (
//   <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
//     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.888-.788-1.487-1.761-1.663-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
//   </svg>
// );

// // ──────────────────────────────────────────────────────────────────────────────
// //  SALES GOD — Sub components
// // ──────────────────────────────────────────────────────────────────────────────

// const SGAvatar = ({ name = "", size = 52 }) => {
//   const parts = name.trim().split(" ");
//   const initials = parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : (parts[0]?.[0] ?? "?");
//   return (
//     <div style={{
//       width: size, height: size, borderRadius: "50%",
//       background: "#e8f4f7", color: "#0C4550",
//       display: "flex", alignItems: "center", justifyContent: "center",
//       fontWeight: 700, fontSize: size * 0.35, flexShrink: 0,
//       border: "2px solid #c6e4ec", letterSpacing: "0.04em",
//     }}>
//       {initials.toUpperCase()}
//     </div>
//   );
// };

// // ─── Inline Editable Field ───────────────────────────────────────────────────
// const SGEditableField = ({ value, onSave, label, type = "text", className = "", options }) => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [tempVal, setTempVal] = useState(value || "");
//   const dropdownRef = useRef(null);

//   useEffect(() => { setTempVal(value || ""); }, [value]);

//   // Click-outside listener for custom dropdowns
//   useEffect(() => {
//     if (!isEditing) return;
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setIsEditing(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isEditing]);

//   const isToggle = type === "YES_NO" || type === "BOOLEAN" || type === "toggle";
//   const isDropdown = options && options.length > 0;

//   // Auto-scroll logic when dropdown opens near the bottom
//   useEffect(() => {
//     if (isEditing && isDropdown && dropdownRef.current) {
//       setTimeout(() => {
//         const listEl = dropdownRef.current.querySelector('.sg2-custom-dropdown-list');
//         if (listEl) {
//           listEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
//         }
//       }, 100);
//     }
//   }, [isEditing, isDropdown]);

//   // 1. BOOLEAN / TOGGLE FIELD
//   if (isToggle) {
//     const isYes = String(value).toLowerCase() === "yes" || value === true || String(value).toLowerCase() === "true";
//     return (
//       <div 
//         style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", height: "100%" }} 
//         onClick={(e) => {
//           e.preventDefault();
//           e.stopPropagation();
//           if (type === "BOOLEAN") {
//             onSave(!isYes);
//           } else {
//             onSave(isYes ? "No" : "Yes");
//           }
//         }}
//         title={`Click to switch to ${isYes ? "No" : "Yes"}`}
//       >
//         <label className="sg2-toggle-switch" style={{ pointerEvents: "none", margin: 0 }}>
//           <input type="checkbox" checked={isYes} readOnly />
//           <span className="sg2-toggle-slider"></span>
//         </label>
//         <span style={{ marginLeft: "8px", fontSize: "13px", fontWeight: "600", color: isYes ? "#0C4550" : "#9ca3af", transition: "color 0.2s" }}>
//           {isYes ? "Yes" : "No"}
//         </span>
//       </div>
//     );
//   }

//   const handleBlurOrSubmit = () => {
//     const raw = tempVal || "";
//     const trimmed = raw.trim();

//     if (raw.length > 0 && trimmed === "") {
//       toast.error(`${label} cannot contain only spaces.`);
//       setIsEditing(false);
//       setTempVal(value || "");
//       return;
//     }

//     setIsEditing(false);
//     setTempVal(trimmed);
//     if (trimmed !== (value || "")) {
//       onSave(trimmed);
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") handleBlurOrSubmit();
//     if (e.key === "Escape") { setIsEditing(false); setTempVal(value || ""); }
//   };

//   // 2. DROPDOWN FIELD
//   if (isDropdown) {
//     return (
//       <div style={{ position: "relative", display: "inline-block", width: "100%" }} ref={dropdownRef}>
//         <span
//           className={`sg2-editable-text ${className} ${!value ? "sg2-editable-empty" : ""}`}
//           onClick={(e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             setIsEditing(!isEditing);
//           }}
//           title={`Click to ${isEditing ? "close" : "select"} ${label}`}
//         >
//           {value || `Select ${label}`}
//           <span style={{ 
//             fontSize: "10px", 
//             marginLeft: "5px", 
//             color: "#0C4550", 
//             display: "inline-block",
//             transform: isEditing ? "rotate(180deg)" : "rotate(0deg)",
//             transition: "transform 0.2s"
//           }}>▼</span>
//         </span>

//         <AnimatePresence>
//           {isEditing && (
//             <motion.div
//               initial={{ opacity: 0, y: -5 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -5 }}
//               transition={{ duration: 0.15 }}
//               className="sg2-custom-dropdown-list"
//             >
//               <div 
//                 className="sg2-custom-dropdown-item" 
//                 onClick={(e) => { e.stopPropagation(); setTempVal(""); onSave(""); setIsEditing(false); }}
//               >
//                 — Select {label} —
//               </div>
//               {options.map((opt, i) => {
//                 const optVal = opt.name || opt.value || opt;
//                 return (
//                   <div
//                     key={i}
//                     className="sg2-custom-dropdown-item"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setTempVal(optVal);
//                       if (optVal !== (value || "")) onSave(optVal);
//                       setIsEditing(false);
//                     }}
//                   >
//                     {optVal}
//                   </div>
//                 );
//               })}
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </div>
//     );
//   }

//   // 3. TEXT FIELD (EDITING STATE)
//   if (isEditing) {
//     return (
//       <input
//         autoFocus
//         type={type}
//         className={`sg2-inline-edit-input ${className}`}
//         value={tempVal}
//         onChange={(e) => setTempVal(e.target.value)}
//         onBlur={handleBlurOrSubmit}
//         onKeyDown={handleKeyDown}
//       />
//     );
//   }

//   // 4. TEXT FIELD (VIEW STATE)
//   return (
//     <span
//       className={`sg2-editable-text ${className} ${!value ? "sg2-editable-empty" : ""}`}
//       onClick={() => setIsEditing(true)}
//       title={`Click to edit ${label}`}
//     >
//       {value || `Add ${label}`}
//       <span className="sg2-edit-icon">✎</span>
//     </span>
//   );
// };

// // ─── Updated SGInfoRow (with Edit support) ───────────────────────────────────
// const SGInfoRow = ({ icon, label, value, href, field, onSave, type = "text", options }) => {
//   return (
//     <div className="sg2-info-row">
//       <span className="sg2-info-icon">{icon}</span>
//       <div className="sg2-info-content">
//         <span className="sg2-info-label">{label}</span>
//         {field && onSave ? (
//           <SGEditableField value={value} onSave={(v) => onSave(field, v)} label={label} type={type} className="sg2-info-value" options={options} />
//         ) : href && value ? (
//           <a href={href} className="sg2-info-value sg2-link">{value}</a>
//         ) : (
//           <span className="sg2-info-value" title={value}>{value || "—"}</span>
//         )}
//       </div>
//     </div>
//   );
// };

// const SGCommentRow = ({ value, onClick }) => {
//   return (
//     <div
//       className="sg2-info-row sg2-info-row--comment"
//       onClick={onClick}
//       title="Click to edit comment"
//     >
//       <span className="sg2-info-icon">💬</span>
//       <div className="sg2-info-content">
//         <span className="sg2-info-label">Comment</span>
//         <span className={`sg2-info-value sg2-comment-value ${!value ? "sg2-editable-empty" : ""}`}>
//           {value || "Add Comment"}
//         </span>
//       </div>
//     </div>
//   );
// };

// const SGCommBtn = ({ icon, label, shortcut, onClick, color }) => (
//   <button className="sg2-comm-btn" style={{ "--comm-color": color }} onClick={onClick} title={label}>
//     {shortcut && <span className="sg2-comm-shortcut">{shortcut}</span>}
//     <span className="sg2-comm-icon">{icon}</span>
//     <span className="sg2-comm-label">{label}</span>
//   </button>
// );

// const SGActionBtn = ({ icon, label, onClick, variant = "default", disabled, shortcut }) => (
//   <button className={`sg2-action-btn sg2-action-btn--${variant}`} onClick={onClick} disabled={disabled} title={label}>
//     {shortcut && <span className="sg2-comm-shortcut">{shortcut}</span>}
//     <span className="sg2-action-icon">{icon}</span>
//     <span className="sg2-action-label">{label}</span>
//   </button>
// );

// const SGQueueCard = ({ lead, isActive, index, onClick }) => (
//   <button className={`sg2-queue-card ${isActive ? "sg2-queue-card--active" : ""}`} onClick={onClick}>
//     <div className="sg2-queue-num">#{index + 1}</div>
//     <div className="sg2-queue-name">{(lead.name || "Unknown").split(" ")[0]}</div>
//     <div className="sg2-queue-status">{lead.statusName || "—"}</div>
//   </button>
// );

// // ── Inline modals (not fixed-position) ───────────────────────────────────────
// const SGStatusModal = ({ open, statuses, currentStatus, onConfirm, onClose }) => {
//   const [selected, setSelected] = useState(currentStatus || "");
//   const [reason, setReason] = useState("");
//   useEffect(() => { setSelected(currentStatus || ""); setReason(""); }, [currentStatus, open]);
//   if (!open) return null;
//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal">
//         <div className="sg2-inline-header"><span>Change status</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
//         <div className="sg2-inline-body">
//           <label className="sg2-inline-label">New status</label>
//           <select className="sg2-inline-select" value={selected} onChange={(e) => setSelected(e.target.value)}>
//             <option value="">— select —</option>
//             {statuses.filter((s) => s.active !== false).map((s) => <option key={s.name} value={s.name}>{s.name}</option>)}
//           </select>
//           <label className="sg2-inline-label" style={{ marginTop: 12 }}>Reason</label>
//           <textarea className="sg2-inline-textarea" rows={3} placeholder="Enter reason…" value={reason} onChange={(e) => setReason(e.target.value)} />
//         </div>
//         <div className="sg2-inline-footer">
//           <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
//           <button className="sg2-primary-btn" disabled={!selected || !reason.trim()} onClick={() => onConfirm(selected, reason)}>Confirm</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const SGFollowUpModal = ({ open, users, onClose, onSubmit, loggedInUser }) => {
//   const [notes, setNotes] = useState("");
//   const [date, setDate] = useState("");
//   const [time, setTime] = useState("");
//   const [followedById, setFollowedById] = useState("");

//   const isExecutive = loggedInUser?.accountType === ROLE.EXECUTIVE;
//   const selfUser = users.find((u) => u.id === loggedInUser?.id);

//   useEffect(() => {
//     if (open) {
//       setFollowedById(isExecutive ? (loggedInUser?.id || "") : "");
//     }
//   }, [open, isExecutive, loggedInUser]);

//   if (!open) return null;
//   const handleSubmit = () => {
//     onSubmit({ notes, nextFollowUpDate: date, nextFollowUpTime: time, followedById });
//     setNotes(""); setDate(""); setTime("");
//     setFollowedById(isExecutive ? (loggedInUser?.id || "") : "");
//   };
//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal">
//         <div className="sg2-inline-header"><span>Add follow-up</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
//         <div className="sg2-inline-body">
//           <label className="sg2-inline-label">Notes</label>
//           <textarea className="sg2-inline-textarea" rows={3} placeholder="Enter notes…" value={notes} onChange={(e) => setNotes(e.target.value)} />
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 10 }}>
//             <div>
//               <label className="sg2-inline-label">Follow-up date</label>
//               <input className="sg2-inline-select" type="date" value={date} min={new Date().toISOString().split("T")[0]} onChange={(e) => setDate(e.target.value)} />
//             </div>
//             <div>
//               <label className="sg2-inline-label">Time</label>
//               <input className="sg2-inline-select" type="time" value={time} onChange={(e) => setTime(e.target.value)} />
//             </div>
//           </div>
//           <label className="sg2-inline-label" style={{ marginTop: 10 }}>Followed by</label>
//           <select className="sg2-inline-select" value={followedById} onChange={(e) => setFollowedById(e.target.value)} disabled={isExecutive}>
//             {isExecutive ? (
//               <option value={loggedInUser?.id || ""}>
//                 {selfUser ? `${selfUser.fname} ${selfUser.lname}` : "Me"}
//               </option>
//             ) : (
//               <>
//                 <option value="">— select user —</option>
//                 {users.map((u) => <option key={u.id} value={u.id}>{u.fname} {u.lname}</option>)}
//               </>
//             )}
//           </select>
//         </div>
//         <div className="sg2-inline-footer">
//           <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
//           <button className="sg2-primary-btn" onClick={handleSubmit}>Submit</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const SGLabelModal = ({ open, labels, onClose, onConfirm }) => {
//   const [labelId, setLabelId] = useState("");
//   if (!open) return null;
//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal">
//         <div className="sg2-inline-header"><span>Assign project</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
//         <div className="sg2-inline-body">
//           <label className="sg2-inline-label">Project name</label>
//           <select className="sg2-inline-select" value={labelId} onChange={(e) => setLabelId(e.target.value)}>
//             <option value="">— select project —</option>
//             {labels.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
//           </select>
//         </div>
//         <div className="sg2-inline-footer">
//           <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
//           <button className="sg2-primary-btn" disabled={!labelId} onClick={() => onConfirm(labelId)}>Assign</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Appointment wizard modal (with inline editing for history & SEARCH) ─────────────
// const SG_APT_PAGE_SIZE = 6;
// const SG_APT_STATUS_OPTIONS = ["SCHEDULED", "COMPLETED", "CANCELLED", "RESCHEDULED", "NO_SHOW"];

// const SGAppointmentModal = ({ open, lead, companyId, stableUser, users, onClose, onScheduled }) => {
//   const [phase, setPhase] = useState("loading");
//   const [appointments, setAppointments] = useState([]);

//   const [step, setStep] = useState(1);
//   const [departments, setDepartments] = useState([]);
//   const [loadingDepartments, setLoadingDepartments] = useState(false);
//   const [deptPage, setDeptPage] = useState(0);
//   const [selectedDept, setSelectedDept] = useState(null);

//   const [persons, setPersons] = useState([]);
//   const [allPersons, setAllPersons] = useState([]); 
//   const [loadingPersons, setLoadingPersons] = useState(false);
//   const [personPage, setPersonPage] = useState(0);
//   const [selectedPerson, setSelectedPerson] = useState(null);

//   const [preferredDate, setPreferredDate] = useState("");
//   const [preferredTime, setPreferredTime] = useState("");
//   const [notes, setNotes] = useState("");
//   const [status, setStatus] = useState("SCHEDULED");
//   const [submitting, setSubmitting] = useState(false);

//   // NEW: Search State
//   const [searchTerm, setSearchTerm] = useState("");

//   // NEW: "See All Departments/Persons" toggle
//   const [showAllDeptsDropdown, setShowAllDeptsDropdown] = useState(false);

//   useEffect(() => {
//     if (!open || !lead?.leadId) return;
//     setPhase("loading");
//     setAppointments([]);
//     setStep(1);
//     setSelectedDept(null);
//     setSelectedPerson(null);
//     setDeptPage(0);
//     setPersonPage(0);
//     setPreferredDate("");
//     setPreferredTime("");
//     setNotes("");
//     setStatus("SCHEDULED");
//     setPersons([]);
//     setSearchTerm(""); // Reset search on open
//     setShowAllDeptsDropdown(false);

//     const loadAppointments = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/api/appointments/lead/${lead.leadId}`, {
//           headers: authHeader(),
//         });
//         const list = Array.isArray(res.data) ? res.data : [];
//         setAppointments(list);
//         setPhase(list.length > 0 ? "history" : "wizard");
//       } catch (err) {
//         console.error("Failed to fetch appointment history", err);
//         toast.error("Failed to load appointment history.");
//         setAppointments([]);
//         setPhase("wizard");
//       }
//     };
//     loadAppointments();
//   }, [open, lead?.leadId]);

//   // Reset pagination when search term changes
//   useEffect(() => {
//     setDeptPage(0);
//     setPersonPage(0);
//   }, [searchTerm]);

//   useEffect(() => {
//     if (!open) return;
//     const loadDepartments = async () => {
//       setLoadingDepartments(true);
//       try {
//         const res = await axios.get(`${API_URL}/api/appointments/departments/company/${companyId}`, {
//           headers: authHeader(),
//           params: { activeOnly: true },
//         });
//         setDepartments(Array.isArray(res.data) ? res.data : []);
//       } catch (err) {
//         console.error("Failed to fetch departments", err);
//         toast.error("Failed to load departments.");
//         setDepartments([]);
//       } finally {
//         setLoadingDepartments(false);
//       }
//     };

//     const loadPersons = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/api/appointments/persons/company/${companyId}`, {
//           headers: authHeader(),
//           params: { activeOnly: true },
//         });
//         setAllPersons(Array.isArray(res.data) ? res.data : []);
//       } catch (err) {
//         console.error("Failed to fetch persons", err);
//         setAllPersons([]);
//       }
//     };

//     loadDepartments();
//     loadPersons();
//   }, [open, companyId]);

//   useEffect(() => {
//     if (!open || phase !== "wizard" || step !== 2 || !selectedDept) return;
//     const deptId = selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id;

//     const loadPersons = async () => {
//       setLoadingPersons(true);
//       setPersonPage(0);
//       try {
//         const res = await axios.get(`${API_URL}/api/appointments/persons/company/${companyId}`, {
//           headers: authHeader(),
//           params: { activeOnly: true, departmentId: deptId },
//         });
//         setPersons(Array.isArray(res.data) ? res.data : []);
//       } catch (err) {
//         console.error("Failed to fetch persons", err);
//         toast.error("Failed to load persons.");
//         setPersons([]);
//       } finally {
//         setLoadingPersons(false);
//       }
//     };
//     loadPersons();
//   }, [open, phase, step, selectedDept, companyId]);

//   const handleInlineAptUpdate = async (apt, field, value) => {
//     if (!value) return;

//     if (field === 'preferredTime' && apt.preferredTime) {
//       const newTime = value.length === 5 ? `${value}:00` : value;
//       if (apt.preferredTime === newTime) return;
//     } else if (apt[field] === value) {
//       return;
//     }

//     let payload = { ...apt, companyId, leadId: lead.leadId, leadName: lead.name, leadPhone: lead.phone, leadEmail: lead.email };

//     const creator = users.find((u) => String(u.id) === String(stableUser.id));
//     const creatorName = creator ? `${creator.fname} ${creator.lname}` : "";
//     payload.lastUpdatedById = stableUser.id;
//     payload.lastUpdatedByName = creatorName;

//     let successMessage = "Appointment updated";

//     if (field === 'departmentName') {
//       const dept = departments.find(d => d.name === value);
//       if (dept) {
//         payload.departmentId = dept.departmentId ?? dept.id ?? dept._id;
//         payload.departmentName = dept.name;
//         payload.departmentLocation = dept.location;
//         successMessage = "Department updated successfully";
//       }
//     } else if (field === 'personName') {
//       const person = allPersons.find(p => p.name === value);
//       if (person) {
//         payload.personId = person.personId ?? person.id ?? person._id;
//         payload.personName = person.name;
//         payload.personPosition = person.position;
//         successMessage = "Person updated successfully";
//       } else {
//         payload.personName = value;
//         successMessage = "Person updated successfully";
//       }
//     } else if (field === 'preferredDate') {
//       payload.preferredDate = value;
//       successMessage = "Date updated successfully";
//     } else if (field === 'preferredTime') {
//       payload.preferredTime = value.length === 5 ? `${value}:00` : value;
//       successMessage = "Time updated successfully";
//     } else if (field === 'status') {
//       payload.status = value;
//       successMessage = "Status updated successfully";
//     } else if (field === 'notes') {
//       payload.notes = value;
//       successMessage = "Notes updated successfully";
//     }

//     try {
//       const res = await axios.put(`${API_URL}/api/appointments/${apt.appointmentId}`, payload, { headers: authHeader() });
//       toast.success(successMessage);
//       setAppointments(prev => prev.map(a => a.appointmentId === apt.appointmentId ? { ...a, ...payload } : a));
//       onScheduled?.();
//     } catch (err) {
//       console.error("Failed to update appointment inline", err);
//       toast.error(err.response?.data?.message || "Failed to update appointment.");
//     }
//   };

//   if (!open) return null;

//   // NEW: Search Filter Logic for Departments
//   const filteredDepartments = departments.filter(d => 
//     (d.name || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
//     (d.location || "").toLowerCase().includes(searchTerm.toLowerCase())
//   );
//   const deptTotalPages = Math.max(1, Math.ceil(filteredDepartments.length / SG_APT_PAGE_SIZE));
//   const pagedDepartments = filteredDepartments.slice(deptPage * SG_APT_PAGE_SIZE, (deptPage + 1) * SG_APT_PAGE_SIZE);

//   // NEW: Search Filter Logic for Persons (for selected department)
//   const filteredPersons = persons.filter(p => 
//     (p.name || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
//     (p.position || "").toLowerCase().includes(searchTerm.toLowerCase())
//   );
//   const personTotalPages = Math.max(1, Math.ceil(filteredPersons.length / SG_APT_PAGE_SIZE));
//   const pagedPersons = filteredPersons.slice(personPage * SG_APT_PAGE_SIZE, (personPage + 1) * SG_APT_PAGE_SIZE);

//   const goToPersonsStep = () => { if (selectedDept) { setStep(2); setSearchTerm(""); setShowAllDeptsDropdown(false); } };
//   const goToDetailsStep = () => { if (selectedPerson) setStep(3); };
  
//   const goBack = () => {
//     setSearchTerm("");
//     setShowAllDeptsDropdown(false);
//     if (step > 1) { setStep((s) => s - 1); return; }
//     if (appointments.length > 0) setPhase("history");
//   };

//   const startNewAppointment = () => {
//     setSelectedDept(null);
//     setSelectedPerson(null);
//     setDeptPage(0);
//     setPersonPage(0);
//     setPreferredDate("");
//     setPreferredTime("");
//     setNotes("");
//     setStatus("SCHEDULED");
//     setSearchTerm("");
//     setShowAllDeptsDropdown(false);
//     setStep(1);
//     setPhase("wizard");
//   };

//   const handleSubmit = async () => {
//     if (!lead || !selectedDept || !selectedPerson) return;
//     if (!preferredDate || !preferredTime) {
//       toast.error("Please pick a preferred date and time.");
//       return;
//     }

//     const creator = users.find((u) => String(u.id) === String(stableUser.id));
//     const creatorName = creator ? `${creator.fname} ${creator.lname}` : "";

//     const deptId = selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id;
//     const personId = selectedPerson.personId ?? selectedPerson.id ?? selectedPerson._id;

//     const payload = {
//       companyId,
//       leadId: lead.leadId,
//       leadName: lead.name,
//       leadPhone: lead.phone,
//       leadEmail: lead.email,
//       preferredDate,
//       preferredTime: preferredTime.length === 5 ? `${preferredTime}:00` : preferredTime,
//       departmentId: deptId,
//       departmentName: selectedDept.name,
//       departmentLocation: selectedDept.location,
//       personId,
//       personName: selectedPerson.name,
//       personPosition: selectedPerson.position,
//       status,
//       notes,
//       createdById: stableUser.id,
//       createdByName: creatorName,
//       lastUpdatedById: stableUser.id,
//       lastUpdatedByName: creatorName,
//     };

//     setSubmitting(true);
//     try {
//       await axios.post(`${API_URL}/api/appointments`, payload, { headers: authHeader() });
//       toast.success("Appointment scheduled!");
//       onScheduled?.();
//       onClose();
//     } catch (err) {
//       console.error("Failed to save appointment", err);
//       toast.error(err.response?.data?.message || "Failed to save appointment.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal sg2-apt-modal-container">
        
//         {/* MODIFIED HEADER WITH SEARCH */}
//         <div className="sg2-inline-header" style={{ gap: '10px' }}>
//           <span style={{ flexShrink: 0 }}>
//             {phase === "loading" && "Loading Appointments"}
//             {phase === "history" && "Appointment History"}
//             {phase === "wizard" && step === 1 && "Select Department"}
//             {phase === "wizard" && step === 2 && "Select Person"}
//             {phase === "wizard" && step === 3 && "Schedule Appointment"}
//           </span>
          
//           {phase === "wizard" && (step === 1 || step === 2) && (
//             <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', paddingRight: '10px', flexWrap: 'nowrap' }}>
//               <div className="sg2-apt-search-wrap">
//                 <svg className="sg2-apt-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#673AB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                   <circle cx="11" cy="11" r="8"></circle>
//                   <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//                 </svg>
//                 <input
//                   type="text"
//                   placeholder={`Search ${step === 1 ? 'department' : 'person'}...`}
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="sg2-inline-select sg2-apt-search-input"
//                 />
//               </div>
//               <button
//                 type="button"
//                 className={`sg2-apt-alldept-btn ${showAllDeptsDropdown ? "sg2-apt-alldept-btn--active" : ""}`}
//                 onClick={() => setShowAllDeptsDropdown((v) => !v)}
//                 title={step === 1 ? "Browse every department" : "Browse every person"}
//               >
//                 {showAllDeptsDropdown ? "✕ Close List" : (step === 1 ? "See All Departments" : "See All Persons")}
//               </button>
//             </div>
//           )}
          
//           <button className="sg2-inline-close" onClick={onClose} style={{ flexShrink: 0 }}>✕</button>
//         </div>

//         {phase === "wizard" && (
//           <div className="sg2-apt-steps">
//             <span className={`sg2-apt-step ${step >= 1 ? "sg2-apt-step--active" : ""}`}>1. Department</span>
//             <span className="sg2-apt-step-sep">→</span>
//             <span className={`sg2-apt-step ${step >= 2 ? "sg2-apt-step--active" : ""}`}>2. Person</span>
//             <span className="sg2-apt-step-sep">→</span>
//             <span className={`sg2-apt-step ${step >= 3 ? "sg2-apt-step--active" : ""}`}>3. Details</span>
//           </div>
//         )}

//         <div className="sg2-inline-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
//           {phase === "loading" && (
//             <div className="sg2-centered" style={{ padding: "40px 0" }}><div className="sg2-spinner" /></div>
//           )}

//           {phase === "history" && (
//             <>
//               <button type="button" className="sg2-apt-new-btn" onClick={startNewAppointment}>
//                 + Make New Appointment
//               </button>
//               <div className="sg2-apt-hist-list">
//                 {appointments.map((apt) => {
//                   const deptPersons = allPersons.filter(p => {
//                     const pDeptId = p.departmentId?._id ?? p.departmentId;
//                     return pDeptId === apt.departmentId;
//                   });

//                   return (
//                     <div key={apt.appointmentId} className="sg2-apt-hist-card">
//                       <div className="sg2-apt-hist-top" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px', marginBottom: '8px' }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                           <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
//                             <span style={{ fontSize: '13px', fontWeight: 700, color: '#0C4550' }}>Department:</span>
//                             <SGEditableField
//                               className="sg2-apt-hist-dept"
//                               value={apt.departmentName}
//                               onSave={(v) => handleInlineAptUpdate(apt, 'departmentName', v)}
//                               label="Department"
//                               options={departments}
//                             />
//                           </div>

//                           <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
//                             <span style={{ fontSize: '13px', fontWeight: 600, color: '#0C4550' }}>Status:</span>
//                             <span className={`sg2-apt-status-badge sg2-apt-status-badge--${(apt.status || "").toLowerCase()}`}>
//                               <SGEditableField
//                                 value={apt.status}
//                                 onSave={(v) => handleInlineAptUpdate(apt, 'status', v)}
//                                 label="Status"
//                                 options={SG_APT_STATUS_OPTIONS.map(s => ({ name: s }))}
//                               />
//                             </span>
//                           </div>
//                         </div>

//                         <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
//                           <span style={{ fontSize: '13px', fontWeight: 700, color: '#0C4550' }}>Person:</span>
//                           <SGEditableField
//                             className="sg2-apt-hist-person"
//                             value={apt.personName}
//                             onSave={(v) => handleInlineAptUpdate(apt, 'personName', v)}
//                             label="Person"
//                             options={deptPersons.length > 0 ? deptPersons : allPersons}
//                           />
//                           {apt.personPosition && <span style={{ fontSize: '12px', color: '#6b7280' }}>• {apt.personPosition}</span>}
//                         </div>
//                       </div>

//                       <div className="sg2-apt-hist-meta" style={{ display: 'flex', gap: '20px', marginTop: '12px', fontSize: '12.5px', color: '#4b5563' }}>
//                         <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
//                           <span style={{ fontWeight: 600 }}>📅 Date:</span>
//                           <SGEditableField
//                             type="date"
//                             value={apt.preferredDate}
//                             onSave={(v) => handleInlineAptUpdate(apt, 'preferredDate', v)}
//                             label="Date"
//                           />
//                         </div>
//                         <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
//                           <span style={{ fontWeight: 600 }}>🕒 Time:</span>
//                           <SGEditableField
//                             type="time"
//                             value={apt.preferredTime ? apt.preferredTime.substring(0, 5) : ""}
//                             onSave={(v) => handleInlineAptUpdate(apt, 'preferredTime', v)}
//                             label="Time"
//                           />
//                         </div>
//                       </div>

//                       <div className="sg2-apt-hist-notes" style={{ display: 'flex', gap: '6px', alignItems: 'flex-start', background: 'transparent', border: 'none', padding: 0, marginTop: '14px' }}>
//                         <span style={{ fontSize: '13px', fontWeight: 700, color: '#0C4550', flexShrink: 0 }}>Notes:</span>
//                         <SGEditableField
//                           value={apt.notes}
//                           onSave={(v) => handleInlineAptUpdate(apt, 'notes', v)}
//                           label="Notes"
//                         />
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </>
//           )}

//           {phase === "wizard" && step === 1 && showAllDeptsDropdown && (
//             filteredDepartments.length === 0 ? (
//               <p className="sg2-history-empty">No departments match your search.</p>
//             ) : (
//               <div className="sg2-apt-alldept-list">
//                 {filteredDepartments.map((dept) => {
//                   const deptId = dept.departmentId ?? dept.id ?? dept._id;
//                   const isSelected = selectedDept && (selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id) === deptId;
//                   return (
//                     <div key={deptId} className="sg2-apt-alldept-group" style={{ padding: "12px 14px" }}>
//                       <button
//                         type="button"
//                         className="sg2-apt-alldept-dept-name"
//                         onClick={() => { setSelectedDept(dept); }}
//                         title="Select this department"
//                         style={{ borderBottom: "none", margin: 0, padding: 0 }}
//                       >
//                         {dept.name}
//                         {dept.location && <span className="sg2-apt-alldept-dept-loc"> · {dept.location}</span>}
//                         {isSelected && <span className="sg2-apt-check" style={{ position: "relative", display: "inline-flex", top: 0, right: 0, marginLeft: "10px" }}>✓</span>}
//                       </button>
//                     </div>
//                   );
//                 })}
//               </div>
//             )
//           )}

//           {phase === "wizard" && step === 1 && !showAllDeptsDropdown && (
//             loadingDepartments ? (
//               <div className="sg2-centered" style={{ padding: "30px 0" }}><div className="sg2-spinner" /></div>
//             ) : filteredDepartments.length === 0 ? (
//               <p className="sg2-history-empty">No departments found.</p>
//             ) : (
//               <>
//                 <div className="sg2-apt-grid">
//                   {pagedDepartments.map((d) => {
//                     const id = d.departmentId ?? d.id ?? d._id;
//                     const isSelected = selectedDept && (selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id) === id;
//                     return (
//                       <button
//                         key={id}
//                         type="button"
//                         className={`sg2-apt-card ${isSelected ? "sg2-apt-card--selected" : ""}`}
//                         onClick={() => setSelectedDept(d)}
//                       >
//                         {isSelected && <span className="sg2-apt-check">✓</span>}
//                         <div className="sg2-apt-card-title">{d.name}</div>
//                         <div className="sg2-apt-card-sub">{d.location || "No location set"}</div>
//                       </button>
//                     );
//                   })}
//                 </div>
//                 {deptTotalPages > 1 && (
//                   <div className="sg2-pagination sg2-apt-pagination">
//                     <span>Page {deptPage + 1} of {deptTotalPages}</span>
//                     <div className="sg2-apt-pagination-btns">
//                       <button disabled={deptPage === 0} onClick={() => setDeptPage((p) => p - 1)}>← Prev</button>
//                       <button disabled={deptPage === deptTotalPages - 1} onClick={() => setDeptPage((p) => p + 1)}>Next →</button>
//                     </div>
//                   </div>
//                 )}
//               </>
//             )
//           )}

//           {phase === "wizard" && step === 2 && showAllDeptsDropdown && (
//             filteredPersons.length === 0 ? (
//               <p className="sg2-history-empty">No persons match your search.</p>
//             ) : (
//               <div className="sg2-apt-alldept-list">
//                 {filteredPersons.map((p) => {
//                   const pId = p.personId ?? p.id ?? p._id;
//                   const isSelected = selectedPerson && (selectedPerson.personId ?? selectedPerson.id ?? selectedPerson._id) === pId;
//                   return (
//                     <div key={pId} className="sg2-apt-alldept-group" style={{ padding: "12px 14px" }}>
//                       <button
//                         type="button"
//                         className="sg2-apt-alldept-dept-name"
//                         onClick={() => {
//                           setSelectedPerson(p);
//                           setShowAllDeptsDropdown(false);
//                           setSearchTerm("");
//                           setStep(3);
//                         }}
//                         title="Select this person"
//                         style={{ borderBottom: "none", margin: 0, padding: 0 }}
//                       >
//                         {p.name}
//                         {p.position && <span className="sg2-apt-alldept-dept-loc"> · {p.position}</span>}
//                         {isSelected && <span className="sg2-apt-check" style={{ position: "relative", display: "inline-flex", top: 0, right: 0, marginLeft: "10px" }}>✓</span>}
//                       </button>
//                     </div>
//                   );
//                 })}
//               </div>
//             )
//           )}

//           {phase === "wizard" && step === 2 && !showAllDeptsDropdown && (
//             loadingPersons ? (
//               <div className="sg2-centered" style={{ padding: "30px 0" }}><div className="sg2-spinner" /></div>
//             ) : filteredPersons.length === 0 ? (
//               <p className="sg2-history-empty">No persons found in this department.</p>
//             ) : (
//               <>
//                 <div className="sg2-apt-grid">
//                   {pagedPersons.map((p) => {
//                     const id = p.personId ?? p.id ?? p._id;
//                     const isSelected = selectedPerson && (selectedPerson.personId ?? selectedPerson.id ?? selectedPerson._id) === id;
//                     return (
//                       <button
//                         key={id}
//                         type="button"
//                         className={`sg2-apt-card ${isSelected ? "sg2-apt-card--selected" : ""}`}
//                         onClick={() => setSelectedPerson(p)}
//                       >
//                         {isSelected && <span className="sg2-apt-check">✓</span>}
//                         <div className="sg2-apt-card-title">{p.name}</div>
//                         <div className="sg2-apt-card-sub">{p.position || "No position set"}</div>
//                       </button>
//                     );
//                   })}
//                 </div>
//                 {personTotalPages > 1 && (
//                   <div className="sg2-pagination sg2-apt-pagination">
//                     <span>Page {personPage + 1} of {personTotalPages}</span>
//                     <div className="sg2-apt-pagination-btns">
//                       <button disabled={personPage === 0} onClick={() => setPersonPage((p) => p - 1)}>← Prev</button>
//                       <button disabled={personPage === personTotalPages - 1} onClick={() => setPersonPage((p) => p + 1)}>Next →</button>
//                     </div>
//                   </div>
//                 )}
//               </>
//             )
//           )}

//           {phase === "wizard" && step === 3 && (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               <div className="sg2-apt-summary">
//                 <div><span className="sg2-apt-summary-label">Department:</span> {selectedDept?.name}</div>
//                 <div><span className="sg2-apt-summary-label">Person:</span> {selectedPerson?.name}{selectedPerson?.position ? ` (${selectedPerson.position})` : ""}</div>
//                 <div><span className="sg2-apt-summary-label">Lead:</span> {lead?.name}</div>
//               </div>
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
//                 <div>
//                   <label className="sg2-inline-label">Preferred date</label>
//                   <input className="sg2-inline-select" type="date" value={preferredDate} min={new Date().toISOString().split("T")[0]} onChange={(e) => setPreferredDate(e.target.value)} />
//                 </div>
//                 <div>
//                   <label className="sg2-inline-label">Preferred time</label>
//                   <input className="sg2-inline-select" type="time" value={preferredTime} onChange={(e) => setPreferredTime(e.target.value)} />
//                 </div>
//               </div>
//               <div>
//                 <label className="sg2-inline-label">Notes</label>
//                 <textarea className="sg2-inline-textarea" rows={3} placeholder="Enter notes…" value={notes} onChange={(e) => setNotes(e.target.value)} />
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="sg2-inline-footer">
//           {phase === "history" && (
//             <button className="sg2-ghost-btn" onClick={onClose}>Close</button>
//           )}
//           {phase === "wizard" && (
//             <>
//               {(step > 1 || appointments.length > 0) && (
//                 <button className="sg2-ghost-btn" onClick={goBack} disabled={submitting}>Back</button>
//               )}
//               <button className="sg2-ghost-btn" onClick={onClose} disabled={submitting}>Cancel</button>
//               {step === 1 && <button className="sg2-primary-btn" disabled={!selectedDept} onClick={goToPersonsStep}>Next</button>}
//               {step === 2 && <button className="sg2-primary-btn" disabled={!selectedPerson} onClick={goToDetailsStep}>Next</button>}
//               {step === 3 && (
//                 <button className="sg2-primary-btn" disabled={submitting} onClick={handleSubmit}>
//                   {submitting ? "Scheduling…" : "Schedule"}
//                 </button>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const SGConvertModal = ({ open, onClose, onConfirm }) => {
//   if (!open) return null;
//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal">
//         <div className="sg2-inline-header"><span>Convert to customer</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
//         <div className="sg2-inline-body">
//           <p style={{ fontSize: 14, color: "#4b5563", margin: 0 }}>Are you sure you want to convert this lead to a customer?</p>
//         </div>
//         <div className="sg2-inline-footer">
//           <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
//           <button className="sg2-primary-btn" style={{ background: "#16a34a" }} onClick={onConfirm}>Confirm</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const SGBanModal = ({ open, onClose, onConfirm }) => {
//   const [reason, setReason] = useState("");
//   if (!open) return null;
//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal">
//         <div className="sg2-inline-header"><span>Block lead</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
//         <div className="sg2-inline-body">
//           <label className="sg2-inline-label">Reason</label>
//           <input className="sg2-inline-select" type="text" placeholder="Enter reason…" value={reason} onChange={(e) => setReason(e.target.value)} />
//         </div>
//         <div className="sg2-inline-footer">
//           <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
//           <button className="sg2-primary-btn" style={{ background: "#dc2626" }} disabled={!reason.trim()} onClick={() => onConfirm(reason)}>Block</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const SGWhatsAppModal = ({ open, templates, onClose, onSend }) => {
//   const [selected, setSelected] = useState("");
//   const [templateDetails, setTemplateDetails] = useState(null);
//   const [variableValues, setVariableValues] = useState({});

//   const handleChange = (name) => {
//     setSelected(name);
//     const tpl = templates.find((t) => t.name === name);
//     setTemplateDetails(tpl || null);
//     setVariableValues({});
//   };

//   const handleVarChange = (key, val) => {
//     setVariableValues((prev) => ({ ...prev, [key]: val }));
//   };

//   const getPreviewText = (text) => {
//     if (!text) return "";
//     let updated = text;
//     Object.keys(variableValues).forEach((key) => {
//       const regex = new RegExp(`{{${key}}}`, "g");
//       updated = updated.replace(regex, variableValues[key] || `{{${key}}}`);
//     });
//     return updated;
//   };

//   const extractVariables = (text) => {
//     if (!text) return [];
//     const matches = text.match(/{{(\d+)}}/g);
//     return matches ? [...new Set(matches.map((m) => m.match(/\d+/)[0]))].sort() : [];
//   };

//   if (!open) return null;

//   const vars = extractVariables(templateDetails?.components?.find(c => c.type === 'BODY')?.text || templateDetails?.body);

//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal">
//         <div className="sg2-inline-header">
//           <span>Send WhatsApp</span>
//           <button className="sg2-inline-close" onClick={onClose}>✕</button>
//         </div>
//         <div className="sg2-inline-body">
//           <label className="sg2-inline-label">Template</label>
//           <select className="sg2-inline-select" value={selected} onChange={(e) => handleChange(e.target.value)}>
//             <option value="">— select template —</option>
//             {Array.isArray(templates) && templates.map((t) => (
//               <option key={t.id || t.name} value={t.name}>{t.name}</option>
//             ))}
//           </select>

//           {templateDetails && (
//             <div style={{ marginTop: 12 }}>
//               <div style={{ padding: "12px", background: "#f0fdf4", borderRadius: 8, fontSize: 13, border: "1px solid #bbf7d0", lineHeight: 1.5, marginBottom: 12 }}>
//                 <div style={{ whiteSpace: "pre-wrap", color: '#166534' }}>
//                   {getPreviewText(templateDetails.components?.find(c => c.type === 'BODY')?.text || templateDetails.body)}
//                 </div>
//               </div>

//               {vars.length > 0 && (
//                 <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: 10 }}>
//                   <label className="sg2-inline-label" style={{ marginBottom: 8 }}>Fill Variables</label>
//                   {vars.map((v) => (
//                     <div key={v} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//                       <span style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", minWidth: 30 }}>Var {v}:</span>
//                       <input
//                         className="sg2-inline-select"
//                         placeholder={`Value for {{${v}}}`}
//                         value={variableValues[v] || ""}
//                         onChange={(e) => handleVarChange(v, e.target.value)}
//                       />
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//         <div className="sg2-inline-footer">
//           <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
//           <button className="sg2-primary-btn" style={{ background: "#16a34a" }} disabled={!selected} onClick={() => onSend(selected, variableValues)}>Send</button>        </div>
//       </div>
//     </div>
//   );
// };

// const SGSmsModal = ({ open, templates, onClose, onSend }) => {
//   const [page, setPage] = useState(0);
//   const itemsPerPage = 12;

//   useEffect(() => { setPage(0); }, [open]);

//   if (!open) return null;

//   const totalPages = Math.ceil(templates.length / itemsPerPage);
//   const currentTemplates = templates.slice(page * itemsPerPage, (page + 1) * itemsPerPage);

//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal sg2-sms-modal-container" style={{ background: "linear-gradient(135deg, #e0e8f5, #c6e4ec)" }}>
//         <div className="sg2-inline-header" style={{ background: "transparent", borderBottom: "1px solid rgba(255,255,255,0.4)" }}>
//           <span>Select SMS Template</span>
//           <button className="sg2-inline-close" onClick={onClose}>✕</button>
//         </div>
//         <div className="sg2-inline-body" style={{ maxHeight: "75vh", overflowY: "auto", paddingBottom: "20px" }}>
//           <div className="sg2-sms-grid">
//             {currentTemplates.map((t) => (
//               <button
//                 key={t.messageId}
//                 className="sg2-sms-glass-card"
//                 onClick={() => onSend(t.messageId, [])}
//               >
//                 <div className="sg2-sms-card-title">{t.templateType || t.templateName || t.messageId}</div>
//                 <div className="sg2-sms-card-preview">{t.templateText}</div>
//               </button>
//             ))}
//           </div>

//           {totalPages > 1 && (
//             <div className="sg2-pagination">
//               <button disabled={page === 0} onClick={() => setPage((p) => p - 1)}>Prev</button>
//               <span>Page {page + 1} of {totalPages}</span>
//               <button disabled={page === totalPages - 1} onClick={() => setPage((p) => p + 1)}>Next</button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const SGEmailModal = ({ open, templates, onClose, onSend, sendingEmailId }) => {
//   const [page, setPage] = useState(0);
//   const itemsPerPage = 12;

//   useEffect(() => { setPage(0); }, [open]);

//   if (!open) return null;

//   const totalPages = Math.ceil(templates.length / itemsPerPage);
//   const currentTemplates = templates.slice(page * itemsPerPage, (page + 1) * itemsPerPage);

//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal sg2-sms-modal-container" style={{ background: "linear-gradient(135deg, #e0e8f5, #c6e4ec)" }}>
//         <div className="sg2-inline-header" style={{ background: "transparent", borderBottom: "1px solid rgba(255,255,255,0.4)" }}>
//           <span>Select Email Template</span>
//           <button className="sg2-inline-close" onClick={onClose} disabled={sendingEmailId !== null}>✕</button>
//         </div>
//         <div className="sg2-inline-body" style={{ maxHeight: "75vh", overflowY: "auto", paddingBottom: "20px" }}>
//           <div className="sg2-sms-grid">
//             {currentTemplates.map((t) => {
//               const tId = t.emailTemplateId || t.id;
//               const isSending = sendingEmailId === tId;

//               return (
//                 <button
//                   key={tId}
//                   className="sg2-sms-glass-card"
//                   onClick={() => !isSending && onSend(tId, [])}
//                   disabled={isSending}
//                   style={{ position: 'relative', cursor: isSending ? 'not-allowed' : 'pointer' }}
//                 >
//                   {isSending && (
//                     <div className="sg2-card-loader-overlay">
//                       <div className="sg2-spinner"></div>
//                     </div>
//                   )}
//                   <div style={{ opacity: isSending ? 0.3 : 1, transition: 'opacity 0.2s' }}>
//                     <div className="sg2-sms-card-title">{t.title || t.subject}</div>
//                     <div className="sg2-sms-card-preview">{t.subject || "No Subject"}</div>
//                   </div>
//                 </button>
//               );
//             })}
//           </div>

//           {totalPages > 1 && (
//             <div className="sg2-pagination">
//               <button disabled={page === 0} onClick={() => setPage((p) => p - 1)}>Prev</button>
//               <span>Page {page + 1} of {totalPages}</span>
//               <button disabled={page === totalPages - 1} onClick={() => setPage((p) => p + 1)}>Next</button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const SGHistoryModal = ({ open, lead, historyData, loading, onClose }) => {
//   if (!open) return null;

//   const formatDateTime = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr);
//     if (isNaN(d.getTime())) return "";
//     const day = String(d.getDate()).padStart(2, "0");
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const year = d.getFullYear();
//     let hours = d.getHours();
//     const minutes = String(d.getMinutes()).padStart(2, "0");
//     const ampm = hours >= 12 ? "PM" : "AM";
//     hours = hours % 12;
//     hours = hours ? hours : 12;
//     const strHours = String(hours).padStart(2, "0");
//     return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
//   };

//   const renderChange = (item, idx) => {
//     if (item.changeType === "lead created") {
//       return (
//         <div key={idx} className="sg2-history-row">
//           <span className="sg2-history-dot sg2-history-dot--green" />
//           <span className="sg2-history-created-text">Lead was created</span>
//         </div>
//       );
//     }

//     if (item.changeType && item.changeType.includes("UPDATED_FIELDS")) {
//       const changeText = item.changeType.replace("UPDATED_FIELDS: ", "");
//       const changes = [];
//       const fieldRegex = /([^:]+?)\s*\[From:\s*([^,]+),\s*To:\s*([^\]]+)\]/g;
//       let match;
//       while ((match = fieldRegex.exec(changeText)) !== null) {
//         const field = match[1].trim();
//         const from = match[2].trim() || "Empty";
//         const to = match[3].trim();
//         if (field.toLowerCase().includes("color")) continue;
//         changes.push({ field, from, to });
//       }

//       if (changes.length === 0) {
//         const filteredLines = changeText
//           .split(",")
//           .filter((line) => !line.toLowerCase().includes("color"));
//         return filteredLines.map((line, i) => (
//           <div key={i} className="sg2-history-row">
//             <span className="sg2-history-dot" />
//             <span className="sg2-history-created-text">{line.trim()}</span>
//           </div>
//         ));
//       }

//       return changes.map((c, i) => (
//         <div key={i} className="sg2-history-change">
//           <div className="sg2-history-change-field">{c.field}</div>
//           <div className="sg2-history-change-values">
//             <span className="sg2-history-from">{c.from}</span>
//             <span className="sg2-history-arrow">→</span>
//             <span className="sg2-history-to">{c.to}</span>
//           </div>
//         </div>
//       ));
//     }

//     return (
//       <div key={idx} className="sg2-history-row">
//         <span className="sg2-history-dot" />
//         <span className="sg2-history-created-text">{item.changeType}</span>
//       </div>
//     );
//   };

//   const sorted = [...(historyData || [])].sort(
//     (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//   );

//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal sg2-history-modal-container">
//         <div className="sg2-inline-header">
//           <span>Lead History</span>
//           <button className="sg2-inline-close" onClick={onClose}>✕</button>
//         </div>

//         <div className="sg2-history-lead-strip">
//           <SGAvatar name={lead?.name || "?"} size={36} />
//           <div className="sg2-history-lead-meta">
//             <span className="sg2-history-lead-name">{lead?.name}</span>
//             <div className="sg2-history-lead-sub">
//               {lead?.phone && <span>📞 {lead.phone}</span>}
//               {lead?.email && <span>✉️ {lead.email}</span>}
//               {lead?.companyName && <span>🏢 {lead.companyName}</span>}
//             </div>
//           </div>
//         </div>

//         <div className="sg2-inline-body sg2-history-body-wrap">
//           {loading ? (
//             <div className="sg2-centered" style={{ padding: "30px 0" }}>
//               <div className="sg2-spinner" />
//             </div>
//           ) : sorted.length === 0 ? (
//             <p className="sg2-history-empty">No history available for this lead.</p>
//           ) : (
//             sorted.map((item, idx) => (
//               <div key={item.historyId || idx} className="sg2-history-card">
//                 <div className="sg2-history-card-top">
//                   <div className="sg2-history-avatar">
//                     {(item.changedByName || "U").charAt(0).toUpperCase()}
//                   </div>
//                   <div>
//                     <div className="sg2-history-changer">{item.changedByName || "Unknown User"}</div>
//                     <div className="sg2-history-time">{formatDateTime(item.createdAt)}</div>
//                   </div>
//                 </div>
//                 <div className="sg2-history-card-body">{renderChange(item, idx)}</div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


// const SGCallHistoryModal = ({ open, lead, data, loading, onClose }) => {
//   if (!open) return null;

//   const formatDateTime = (dateStr) => {
//     if (!dateStr) return "—";
//     const d = new Date(dateStr);
//     return d.toLocaleString("en-IN", {
//       day: "2-digit", month: "2-digit", year: "numeric",
//       hour: "2-digit", minute: "2-digit", hour12: true
//     });
//   };

//   const formatDuration = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins}m ${secs}s`;
//   };

//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal sg2-history-modal-container">
//         <div className="sg2-inline-header">
//           <span>Call History</span>
//           <button className="sg2-inline-close" onClick={onClose}>✕</button>
//         </div>

//         <div className="sg2-history-lead-strip">
//           <SGAvatar name={lead?.name || "?"} size={36} />
//           <div className="sg2-history-lead-meta">
//             <span className="sg2-history-lead-name">{lead?.name}</span>
//             <div className="sg2-history-lead-sub">
//               {lead?.phone && <span>📞 {lead.phone}</span>}
//             </div>
//           </div>
//         </div>

//         <div className="sg2-inline-body sg2-history-body-wrap">
//           {loading ? (
//             <div className="sg2-centered" style={{ padding: "30px 0" }}>
//               <div className="sg2-spinner" />
//             </div>
//           ) : data.length === 0 ? (
//             <p className="sg2-history-empty">No call recordings found.</p>
//           ) : (
//             data.map((item, idx) => (
//               <div key={item.callSessionId || idx} className="sg2-history-card">
//                 <div className="sg2-history-card-top" style={{ justifyContent: "space-between" }}>
//                   <div>
//                     <div className="sg2-history-changer">Session: {item.callSessionId}</div>
//                     <div className="sg2-history-time">{formatDateTime(item.startTime)}</div>
//                   </div>
//                   <span className="sg2-status-pill" style={{ background: item.status === 'answered' ? '#16a34a' : '#F46653' }}>
//                     {item.status}
//                   </span>
//                 </div>
//                 <div className="sg2-history-card-body" style={{ borderLeftColor: "#0C4550" }}>
//                   <div className="sg2-history-row">
//                     <span className="sg2-history-created-text">Duration: <b>{formatDuration(item.callDuration)}</b></span>
//                   </div>
//                   {item.resourceURL && (
//                     <div style={{ marginTop: "10px" }}>
//                       <audio src={item.resourceURL} controls style={{ width: "100%", height: "35px" }} />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


// // ─── Call Transcription (Gemini) Modal ───────────────────────────────────────
// const isZeroDurationClip = (duration) => {
//   if (duration === null || duration === undefined || duration === "") return true;
//   const asNumber = Number(duration);
//   if (!Number.isNaN(asNumber)) return asNumber <= 0;
//   // clock-style fallback, e.g. "0:00" / "00:00:00"
//   return /^[0:.\s]+$/.test(String(duration));
// };

// const SGStarRating = ({ value = 0 }) => (
//   <span style={{ letterSpacing: "2px" }}>
//     {[1, 2, 3, 4, 5].map((n) => (
//       <span key={n} style={{ color: n <= value ? "#f5a623" : "#d8d8d8", fontSize: "16px" }}>★</span>
//     ))}
//   </span>
// );

// const SG_INTENT_CATEGORIES = [
//   { value: "INTERESTED", label: "Interested" },
//   { value: "PRICE_INQUIRY", label: "Price inquiry" },
//   { value: "INFORMATION_REQUEST", label: "Information request" },
//   { value: "CALLBACK_REQUESTED", label: "Callback requested" },
//   { value: "SITE_VISIT_OR_DEMO", label: "Site visit / demo" },
//   { value: "NOT_INTERESTED", label: "Not interested" },
//   { value: "WRONG_NUMBER", label: "Wrong number" },
//   { value: "OTHER", label: "Other" },
// ];

// const SG_EXTRACTION_FIELDS = [
//   { key: "name", label: "Name", placeholder: "Client name" },
//   { key: "email", label: "Email", placeholder: "client@example.com" },
//   { key: "phone", label: "Phone (saved as alt. contact)", placeholder: "10-digit mobile number" },
// ];

// const SG_EXTRACTION_STATUS = {
//   PENDING_REVIEW: { label: "Pending review", bg: "#f5a623" },
//   APPROVED: { label: "Approved", bg: "#16a34a" },
//   REJECTED: { label: "Rejected", bg: "#9a9a9a" },
// };

// const sgExtractionToDraft = (ex) => ({
//   name: ex?.reviewed?.name || "",
//   email: ex?.reviewed?.email || "",
//   phone: ex?.reviewed?.phone || "",
//   intent: ex?.reviewed?.intent || "",
//   intentCategory: ex?.reviewed?.intentCategory || "",
// });

// const SGTranscribeModal = ({ open, lead, companyId, onClose, onLeadUpdated }) => {
//   const [recordings, setRecordings] = useState([]);
//   const [loadingRecordings, setLoadingRecordings] = useState(false);
//   const [activeIdx, setActiveIdx] = useState(0);
//   const [results, setResults] = useState({});     // callSessionId -> transcription result
//   const [transcribingId, setTranscribingId] = useState(null);
//   const [extractions, setExtractions] = useState({});
//   const [drafts, setDrafts] = useState({});
//   const [extractionBusy, setExtractionBusy] = useState(null);

//   useEffect(() => {
//     if (!open || !lead?.leadId) return;

//     const load = async () => {
//       setLoadingRecordings(true);
//       setActiveIdx(0);
//       try {
//         const [recRes, existingRes, extractionRes] = await Promise.all([
//           axios.get(`${API_URL}/api/leads/${lead.leadId}/call-recordings`, { headers: authHeader() }),
//           axios.get(`${API_URL}/api/transcription/lead/${lead.leadId}`, { headers: authHeader() }).catch(() => ({ data: [] })),
//           axios.get(`${API_URL}/api/lead-extractions/lead/${lead.leadId}`, { headers: authHeader() }).catch(() => ({ data: [] })),
//         ]);

//         setRecordings(recRes.data || []);

//         const cacheMap = {};
//         (existingRes.data || []).forEach((t) => {
//           if (t.callSessionId) cacheMap[t.callSessionId] = t;
//         });
//         setResults(cacheMap);

//         const extractionMap = {};
//         const draftMap = {};
//         (extractionRes.data || []).forEach((ex) => {
//           if (ex.callSessionId) {
//             extractionMap[ex.callSessionId] = ex;
//             draftMap[ex.callSessionId] = sgExtractionToDraft(ex);
//           }
//         });
//         setExtractions(extractionMap);
//         setDrafts(draftMap);
//       } catch (err) {
//         console.error("Error fetching recordings for transcription", err);
//         toast.error("Failed to fetch call recordings");
//         setRecordings([]);
//       } finally {
//         setLoadingRecordings(false);
//       }
//     };
//     load();
//   }, [open, lead?.leadId]);

//   if (!open) return null;

//   const current = recordings[activeIdx] ?? null;
//   const currentResult = current ? results[current.callSessionId] : null;
//   const currentIsZero = current ? isZeroDurationClip(current.callDuration) : false;

//   const formatDuration = (seconds) => {
//     const n = Number(seconds) || 0;
//     const mins = Math.floor(n / 60);
//     const secs = Math.floor(n % 60);
//     return `${mins}m ${secs}s`;
//   };

//   const fetchExtraction = async (callSessionId) => {
//     try {
//       const res = await axios.get(`${API_URL}/api/lead-extractions/session/${callSessionId}`, { headers: authHeader() });
//       setExtractions((prev) => ({ ...prev, [callSessionId]: res.data }));
//       setDrafts((prev) => ({ ...prev, [callSessionId]: sgExtractionToDraft(res.data) }));
//     } catch (err) {
//       if (err?.response?.status !== 404) console.error("Error fetching extracted details", err);
//     }
//   };

//   const updateDraft = (callSessionId, field, value) => {
//     setDrafts((prev) => ({ ...prev, [callSessionId]: { ...(prev[callSessionId] || {}), [field]: value } }));
//   };

//   const buildLeadPatch = (fields) => {
//     const patch = {};
//     if (fields.name) patch.name = fields.name;
//     if (fields.email) patch.email = fields.email;
//     const leadDigits = String(lead?.phone || "").replace(/\D/g, "");
//     if (fields.phone && !leadDigits.endsWith(fields.phone)) patch.otherContactNo = fields.phone;
//     if (fields.intent || fields.intentCategory) {
//       patch.customFields = {
//         ...(lead?.customFields || {}),
//         ...(fields.intent ? { callIntent: fields.intent } : {}),
//         ...(fields.intentCategory ? { callIntentCategory: fields.intentCategory } : {}),
//       };
//     }
//     return patch;
//   };

//   const handleExtractionAction = async (callSessionId, action) => {
//     const ex = extractions[callSessionId];
//     if (!ex) return;
//     const draft = drafts[callSessionId] || sgExtractionToDraft(ex);
//     setExtractionBusy(ex.id);
//     try {
//       let res;
//       if (action === "save") {
//         res = await axios.put(`${API_URL}/api/lead-extractions/${ex.id}`, draft, { headers: authHeader() });
//         toast.success("Changes saved");
//       } else if (action === "approve") {
//         res = await axios.post(`${API_URL}/api/lead-extractions/${ex.id}/approve`, draft, { headers: authHeader() });
//         toast.success("Approved and saved to lead");
//         if (onLeadUpdated) onLeadUpdated(lead.leadId, buildLeadPatch(res.data.reviewed || {}));
//       } else {
//         res = await axios.post(`${API_URL}/api/lead-extractions/${ex.id}/reject`, null, { headers: authHeader() });
//         toast.success("Extraction rejected");
//       }
//       setExtractions((prev) => ({ ...prev, [callSessionId]: res.data }));
//       setDrafts((prev) => ({ ...prev, [callSessionId]: sgExtractionToDraft(res.data) }));
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Something went wrong. Please try again.");
//     } finally {
//       setExtractionBusy(null);
//     }
//   };

//   const renderExtractionPanel = (callSessionId) => {
//     const ex = extractions[callSessionId];
//     if (!ex) {
//       return (
//         <p style={{ fontSize: "12.5px", color: "#9a9a9a", fontStyle: "italic", margin: "14px 0 0" }}>
//           No lead details were extracted from this call.
//         </p>
//       );
//     }
//     const draft = drafts[callSessionId] || sgExtractionToDraft(ex);
//     const original = sgExtractionToDraft(ex);
//     const pending = ex.status === "PENDING_REVIEW";
//     const busy = extractionBusy === ex.id;
//     const dirty = Object.keys(original).some((k) => (original[k] || "") !== (draft[k] || ""));
//     const statusStyle = SG_EXTRACTION_STATUS[ex.status] || SG_EXTRACTION_STATUS.PENDING_REVIEW;

//     return (
//       <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #e5e5e5" }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
//           <span style={{ fontSize: "13px", fontWeight: 600 }}>Extracted Lead Details</span>
//           <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//             {ex.extractionConfidence && (
//               <span style={{ fontSize: "11px", color: "#666" }}>AI confidence: {ex.extractionConfidence}</span>
//             )}
//             <span className="sg2-status-pill" style={{ background: statusStyle.bg }}>{statusStyle.label}</span>
//           </span>
//         </div>

//         {SG_EXTRACTION_FIELDS.map((f) => (
//           <div key={f.key} style={{ marginBottom: "8px" }}>
//             <label className="sg2-inline-label">{f.label}</label>
//             <input
//               className="sg2-inline-select"
//               type="text"
//               placeholder={f.placeholder}
//               value={draft[f.key] || ""}
//               disabled={!pending || busy}
//               onChange={(e) => updateDraft(callSessionId, f.key, e.target.value)}
//             />
//             {pending && original[f.key] && ex.extracted?.[f.key] && ex.extracted[f.key] !== (draft[f.key] || "") && (
//               <div style={{ fontSize: "11px", color: "#9a9a9a", marginTop: "2px" }}>AI heard: {ex.extracted[f.key]}</div>
//             )}
//           </div>
//         ))}

//         <div style={{ marginBottom: "8px" }}>
//           <label className="sg2-inline-label">Intent category</label>
//           <select
//             className="sg2-inline-select"
//             value={draft.intentCategory || ""}
//             disabled={!pending || busy}
//             onChange={(e) => updateDraft(callSessionId, "intentCategory", e.target.value)}
//           >
//             <option value="">Not set</option>
//             {SG_INTENT_CATEGORIES.map((c) => (
//               <option key={c.value} value={c.value}>{c.label}</option>
//             ))}
//           </select>
//         </div>

//         <div style={{ marginBottom: "10px" }}>
//           <label className="sg2-inline-label">Call intent</label>
//           <textarea
//             className="sg2-inline-textarea"
//             rows={2}
//             placeholder="Why the client called"
//             value={draft.intent || ""}
//             disabled={!pending || busy}
//             onChange={(e) => updateDraft(callSessionId, "intent", e.target.value)}
//           />
//         </div>

//         {pending ? (
//           <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
//             <button className="sg2-ghost-btn" disabled={busy} onClick={() => handleExtractionAction(callSessionId, "reject")}>
//               Reject
//             </button>
//             <button className="sg2-ghost-btn" disabled={busy || !dirty} onClick={() => handleExtractionAction(callSessionId, "save")}>
//               Save edits
//             </button>
//             <button
//               className="sg2-primary-btn"
//               style={{ background: "#16a34a" }}
//               disabled={busy}
//               onClick={() => handleExtractionAction(callSessionId, "approve")}
//             >
//               {busy ? "Working…" : "Approve & save to lead"}
//             </button>
//           </div>
//         ) : (
//           ex.reviewedByName && (
//             <div style={{ fontSize: "12px", color: "#666" }}>
//               {ex.status === "APPROVED" ? "Approved" : "Rejected"} by {ex.reviewedByName}
//             </div>
//           )
//         )}
//       </div>
//     );
//   };

//   const handleTranscribe = async () => {
//     if (!current || currentIsZero) return;
//     setTranscribingId(current.callSessionId);
//     try {
//       const res = await axios.post(
//         `${API_URL}/api/transcription/lead/${lead.leadId}`,
//         { companyId, callSessionId: current.callSessionId },
//         { headers: authHeader() }
//       );
//       setResults((prev) => ({ ...prev, [current.callSessionId]: res.data }));
//       if (res.data?.status === "SUCCESS") await fetchExtraction(current.callSessionId);
//     } catch (err) {
//       const msg = err?.response?.data?.message || "Failed to transcribe this recording.";
//       toast.error(msg);
//     } finally {
//       setTranscribingId(null);
//     }
//   };

//   const goPrev = () => setActiveIdx((i) => Math.max(0, i - 1));
//   const goNext = () => setActiveIdx((i) => Math.min(recordings.length - 1, i + 1));

//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal sg2-history-modal-container">
//         <div className="sg2-inline-header">
//           <span>Call Transcription &amp; Rating</span>
//           <button className="sg2-inline-close" onClick={onClose}>✕</button>
//         </div>

//         <div className="sg2-history-lead-strip">
//           <SGAvatar name={lead?.name || "?"} size={36} />
//           <div className="sg2-history-lead-meta">
//             <span className="sg2-history-lead-name">{lead?.name}</span>
//             <div className="sg2-history-lead-sub">
//               {lead?.phone && <span>📞 {lead.phone}</span>}
//             </div>
//           </div>
//         </div>

//         <div className="sg2-inline-body sg2-history-body-wrap">
//           {loadingRecordings ? (
//             <div className="sg2-centered" style={{ padding: "30px 0" }}>
//               <div className="sg2-spinner" />
//             </div>
//           ) : recordings.length === 0 ? (
//             <p className="sg2-history-empty">No call recordings found.</p>
//           ) : (
//             <>
//               {/* Queue navigation */}
//               <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
//                 <button className="sg2-history-trigger-btn" onClick={goPrev} disabled={activeIdx === 0} style={{ opacity: activeIdx === 0 ? 0.4 : 1 }}>◀ Prev</button>
//                 <span style={{ fontSize: "13px", fontWeight: 600, color: "#0C4550" }}>
//                   Recording {activeIdx + 1} of {recordings.length}
//                 </span>
//                 <button className="sg2-history-trigger-btn" onClick={goNext} disabled={activeIdx === recordings.length - 1} style={{ opacity: activeIdx === recordings.length - 1 ? 0.4 : 1 }}>Next ▶</button>
//               </div>

//               {current && (
//                 <div className="sg2-history-card">
//                   <div className="sg2-history-card-top" style={{ justifyContent: "space-between" }}>
//                     <div>
//                       <div className="sg2-history-changer">Session: {current.callSessionId}</div>
//                       <div className="sg2-history-time">Duration: <b>{formatDuration(current.callDuration)}</b></div>
//                     </div>
//                     <span className="sg2-status-pill" style={{ background: current.status === "answered" ? "#16a34a" : "#F46653" }}>
//                       {current.status}
//                     </span>
//                   </div>

//                   <div className="sg2-history-card-body" style={{ borderLeftColor: "#0C4550" }}>
//                     {current.resourceURL && (
//                       <audio src={current.resourceURL} controls style={{ width: "100%", height: "35px", marginBottom: "10px" }} />
//                     )}

//                     {currentIsZero ? (
//                       <p style={{ fontSize: "13px", color: "#9a9a9a", fontStyle: "italic", margin: 0 }}>
//                         This recording is 0:00 - there's no audio to transcribe, so it's skipped automatically.
//                       </p>
//                     ) : currentResult ? (
//                       <div>
//                         {currentResult.status === "FAILED" ? (
//                           <p style={{ color: "#F46653", fontSize: "13px" }}>
//                             Transcription failed: {currentResult.errorMessage || "Unknown error"}
//                           </p>
//                         ) : (
//                           <>
//                             <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
//                               <span style={{ fontSize: "13px", fontWeight: 600 }}>Executive Rating:</span>
//                               <SGStarRating value={currentResult.executiveRating} />
//                               <span style={{ fontSize: "12px", color: "#666" }}>({currentResult.executiveRating}/5)</span>
//                             </div>

//                             {currentResult.ratingRemarks && (
//                               <p style={{ fontSize: "13px", color: "#333", margin: "0 0 10px" }}>{currentResult.ratingRemarks}</p>
//                             )}

//                             {Array.isArray(currentResult.improvementSuggestions) && currentResult.improvementSuggestions.length > 0 && (
//                               <div style={{ marginBottom: "12px" }}>
//                                 <span style={{ fontSize: "13px", fontWeight: 600 }}>Suggestions to improve:</span>
//                                 <ul style={{ margin: "6px 0 0", paddingLeft: "18px" }}>
//                                   {currentResult.improvementSuggestions.map((s, i) => (
//                                     <li key={i} style={{ fontSize: "12.5px", color: "#333", marginBottom: "4px" }}>{s}</li>
//                                   ))}
//                                 </ul>
//                               </div>
//                             )}

//                             {currentResult.overallSummary && (
//                               <p style={{ fontSize: "12.5px", color: "#555", fontStyle: "italic", marginBottom: "12px" }}>
//                                 {currentResult.overallSummary}
//                               </p>
//                             )}

//                             <div style={{ fontSize: "13px", fontWeight: 600, marginBottom: "6px" }}>Transcript:</div>
//                             <div style={{ maxHeight: "220px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "6px" }}>
//                               {(currentResult.transcript || []).map((line, i) => (
//                                 <div
//                                   key={i}
//                                   style={{
//                                     alignSelf: line.speaker === "EXECUTIVE" ? "flex-end" : "flex-start",
//                                     background: line.speaker === "EXECUTIVE" ? "#e8f4f7" : "#f2f2f2",
//                                     borderRadius: "10px",
//                                     padding: "6px 10px",
//                                     maxWidth: "85%",
//                                   }}
//                                 >
//                                   <div style={{ fontSize: "10.5px", fontWeight: 700, color: "#0C4550", marginBottom: "2px" }}>
//                                     {line.speaker === "EXECUTIVE" ? "Executive" : "Client"}
//                                   </div>
//                                   <div style={{ fontSize: "13px", color: "#222" }}>{line.text}</div>
//                                 </div>
//                               ))}
//                             </div>
//                             {renderExtractionPanel(current.callSessionId)}
//                           </>
//                         )}
//                       </div>
//                     ) : (
//                       <button
//                         className="sg2-history-trigger-btn"
//                         onClick={handleTranscribe}
//                         disabled={transcribingId === current.callSessionId}
//                         style={{ padding: "6px 14px" }}
//                       >
//                         {transcribingId === current.callSessionId ? "Transcribing…" : "🎧 Transcribe & Rate"}
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── NEW: Comment Modal ───────────────────────────────────────────────────────
// const SGCommentModal = ({ open, value, onChange, onSave, onClose }) => {
//   if (!open) return null;
//   return (
//     <div className="sg2-inline-overlay">
//       <div className="sg2-inline-modal">
//         <div className="sg2-inline-header">
//           <span>Edit Comment</span>
//           <button className="sg2-inline-close" onClick={onClose}>✕</button>
//         </div>
//         <div className="sg2-inline-body">
//           <label className="sg2-inline-label">Comment</label>
//           <textarea
//             autoFocus
//             className="sg2-inline-textarea"
//             rows={7}
//             placeholder="Enter comment…"
//             value={value}
//             onChange={(e) => onChange(e.target.value)}
//           />
//         </div>
//         <div className="sg2-inline-footer">
//           <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
//           <button className="sg2-primary-btn" onClick={onSave}>Save</button>
//         </div>
//       </div>
//     </div>
//   );
// };


// // ──────────────────────────────────────────────────────────────────────────────
// //  SALES GOD PAGE — Main component
// // ──────────────────────────────────────────────────────────────────────────────
// const SalesGod = () => {
//   const navigate = useNavigate();
//   const { isIncomingModeOn } = useIncomingMode();
//   const { user, isAuthenticated, loading: authLoading } = useContext(AuthContext);
//   const [showCallHistoryModal, setShowCallHistoryModal] = useState(false);
//   const [callHistoryData, setCallHistoryData] = useState([]);
//   const [callHistoryLoading, setCallHistoryLoading] = useState(false);
//   const [showTranscribeModal, setShowTranscribeModal] = useState(false);

//   const [apiPage, setApiPage] = useState(0);
//   const [hasMoreApiLeads, setHasMoreApiLeads] = useState(true);
//   const [fetchingMore, setFetchingMore] = useState(false);
//   const stableUser = useMemo(() => ({
//     id: user?.id,
//     accountType: user?.accountType,
//     companyId: user?.companyId,
//   }), [user?.id, user?.accountType, user?.companyId]);

//   const companyId = useMemo(() =>
//     isOwnerLevel(stableUser.accountType) ? stableUser.id : stableUser.companyId,
//     [stableUser]
//   );

//   const token = localStorage.getItem("token");

//   const [splash, setSplash] = useState(true);
//   useEffect(() => {
//     const t = setTimeout(() => setSplash(false), 2000);
//     return () => clearTimeout(t);
//   }, []);

//   const [statuses, setStatuses] = useState([]);
//   const [statusCounts, setStatusCounts] = useState({});
//   const [activeStatus, setActiveStatus] = useState("");
//   const [allLeads, setAllLeads] = useState([]);
//   const [filteredLeads, setFilteredLeads] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const leadsPerPage = 14;
//   const [leadPage, setLeadPage] = useState(0);

//   const [users, setUsers] = useState([]);
//   const [labels, setLabels] = useState([]);
//   const [whatsappTemplates, setWhatsappTemplates] = useState([]);
//   const [smsTemplates, setSmsTemplates] = useState([]);
//   const [emailTemplates, setEmailTemplates] = useState([]);
//   const [loginMobileNo, setLoginMobileNo] = useState("");

//   const [waApiKey, setWaApiKey] = useState("");

//   // NEW: Custom lead fields configured in "Lead Config" page (fetched from lead-fields API)
//   const [customFields, setCustomFields] = useState([]);

//   const [showStatus, setShowStatus] = useState(false);
//   const [showFollowUp, setShowFollowUp] = useState(false);
//   const [showAppointment, setShowAppointment] = useState(false);
//   const [showLabel, setShowLabel] = useState(false);
//   const [showConvert, setShowConvert] = useState(false);
//   const [showBan, setShowBan] = useState(false);
//   const [showWhatsApp, setShowWhatsApp] = useState(false);
//   const [showSms, setShowSms] = useState(false);
//   const [showEmail, setShowEmail] = useState(false);
//   const [sendingEmailId, setSendingEmailId] = useState(null);

//   const [showHistoryModal, setShowHistoryModal] = useState(false);
//   const [historyData, setHistoryData] = useState([]);
//   const [historyLoading, setHistoryLoading] = useState(false);

//   const [showComment, setShowComment] = useState(false);
//   const [commentDraft, setCommentDraft] = useState("");

//   const [showCommInfo, setShowCommInfo] = useState(false);
//   const [showLeadInfo, setShowLeadInfo] = useState(false);
//   const commInfoRef = useRef(null);
//   const leadInfoRef = useRef(null);

//   const [searchQuery, setSearchQuery] = useState("");
//   const [showSearchDropdown, setShowSearchDropdown] = useState(false);
//   const searchContainerRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
//         setShowSearchDropdown(false);
//       }
//       if (commInfoRef.current && !commInfoRef.current.contains(event.target)) {
//         setShowCommInfo(false);
//       }
//       if (leadInfoRef.current && !leadInfoRef.current.contains(event.target)) {
//         setShowLeadInfo(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (authLoading || !isAuthenticated) return;
//     const fetchAll = async () => {
//       setLoading(true);
//       try {
//         const usersUrl = isOwnerLevel(stableUser.accountType)
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${stableUser.id}&accountType=${stableUser.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${stableUser.id}&accountType=${stableUser.accountType}`;

//         const [statusRes, leadsRes, usersRes, labelsRes, waConfigRes, countsRes, customFieldsRes] = await Promise.all([
//           axios.get(`${API_URL}/api/leadStatus/company/${companyId}`, { headers: authHeader() }),
//           axios.get(
//             `${API_URL}/api/leads/company/${companyId}/status-wise?limit=200&userId=${stableUser.id}`,
//             { headers: authHeader() }
//           ),
//           axios.get(usersUrl, { headers: authHeader() }),
//           axios.get(`${API_URL}/api/projectName/company/${companyId}`, { headers: authHeader() }),
//           axios.get(`${API_URL}/api/whatsappConfig/${companyId}`, { headers: authHeader() }).catch(err => {
//             console.warn("WhatsApp config not found or error fetching:", err.message);
//             return null;
//           }),
//           axios.get(`${API_URL}/api/leads/status-wise-leads`, {
//             params: { companyId, userId: stableUser.id },
//             headers: authHeader()
//           }).catch(err => {
//             console.warn("Status counts fetch error", err.message);
//             return { data: [] };
//           }),
//           // NEW: fetch active custom lead fields configured on the "Lead Config" page
//           axios.get(`${API_URL}/api/lead-fields/company/${companyId}?activeOnly=true`, { headers: authHeader() }).catch(err => {
//             console.warn("Custom lead fields fetch error", err.message);
//             return { data: [] };
//           })
//         ]);
//         const active = (statusRes.data || [])
//           .filter((s) => s.active !== false)
//           .map((s) => ({ ...s, name: (s.name || "").trim() }));
//         setStatuses(active);

//         const countsMap = {};
//         if (countsRes && countsRes.data) {
//           countsRes.data.forEach(item => {
//             countsMap[(item.statusName || "").trim()] = item.totalLeads;
//           });
//         }
//         active.forEach((s) => {
//           if (!(s.name in countsMap)) countsMap[s.name] = 0;
//         });
//         setStatusCounts(countsMap);

//         const statusesData = leadsRes.data?.statuses || [];
//         const flattenedLeads = [];
//         statusesData.forEach((statusItem) => {
//           if (statusItem.leads) {
//             flattenedLeads.push(...statusItem.leads);
//           }
//         });
//         setAllLeads(flattenedLeads);

//         const anyStatusHasMore = statusesData.some((s) => s.hasMore);
//         setHasMoreApiLeads(anyStatusHasMore);
//         setApiPage(0);

//         setUsers(usersRes.data || []);
//         setLabels(labelsRes.data || []);

//         // NEW: keep only active custom fields (in case the endpoint ignores activeOnly)
//         const fetchedCustomFields = Array.isArray(customFieldsRes?.data) ? customFieldsRes.data : [];
//         setCustomFields(fetchedCustomFields.filter((f) => f.active !== false));

//         if (active.length > 0) {
//           const savedStatus = sessionStorage.getItem("sg_activeStatus");
//           const isValid = active.some(s => s.name === savedStatus);
//           setActiveStatus(isValid ? savedStatus : active[0].name);
//         }
//         const userData = (usersRes.data || []).find((u) => u.id === stableUser.id);
//         if (userData) setLoginMobileNo(userData.mobileNumber || "");

//         if (waConfigRes && waConfigRes.data && waConfigRes.data.status === "success") {
//           setWaApiKey(waConfigRes.data.data.apiKey);
//         }

//       } catch (err) {
//         console.error("Sales God fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAll();
//   }, [companyId, stableUser, authLoading, isAuthenticated]);

//   useEffect(() => {
//     if (activeStatus) {
//       const normalizedActiveStatus = (activeStatus || "").trim();
//       const newFiltered = allLeads.filter(
//         (l) => ((l.statusName || l.status || "").trim()) === normalizedActiveStatus
//       );

//       const uniqueMap = new Map();
//       newFiltered.forEach(l => {
//         if (l.leadId) uniqueMap.set(String(l.leadId), l);
//       });
//       const uniqueFiltered = Array.from(uniqueMap.values());

//       setFilteredLeads(uniqueFiltered);

//       const savedLeadId = sessionStorage.getItem("sg_activeLeadId");
//       let foundIndex = 0;

//       if (savedLeadId) {
//         const idx = uniqueFiltered.findIndex((l) => String(l.leadId) === String(savedLeadId));
//         if (idx !== -1) foundIndex = idx;
//       }

//       setActiveIndex(foundIndex);
//       setLeadPage(Math.floor(foundIndex / leadsPerPage));
//     }
//   }, [activeStatus, allLeads]);

//   useEffect(() => {
//     if (filteredLeads[activeIndex]) {
//       sessionStorage.setItem("sg_activeLeadId", filteredLeads[activeIndex].leadId);
//     }
//   }, [activeIndex, filteredLeads]);

//   useEffect(() => {
//     if (activeStatus) {
//       sessionStorage.setItem("sg_activeStatus", activeStatus);
//     }
//   }, [activeStatus]);

//   useEffect(() => {
//     setLeadPage(Math.floor(activeIndex / leadsPerPage));
//   }, [activeIndex]);

//   const anyModalOpen = showStatus || showFollowUp || showAppointment || showLabel || showConvert || showBan || showWhatsApp || showSms || showEmail || showSearchDropdown || showHistoryModal || showTranscribeModal || showComment;

//   const currentLead = filteredLeads[activeIndex] ?? null;

//   const handleOpenCallHistory = async () => {
//     if (!currentLead) return;
//     setCallHistoryLoading(true);
//     setShowCallHistoryModal(true);
//     try {
//       const res = await axios.get(`${API_URL}/api/leads/${currentLead.leadId}/call-recordings`, {
//         headers: authHeader(),
//       });
//       setCallHistoryData(res.data || []);
//     } catch (err) {
//       console.error("Error fetching call history", err);
//       toast.error("Failed to fetch call history");
//       setCallHistoryData([]);
//     } finally {
//       setCallHistoryLoading(false);
//     }
//   };

//   const handleCall = async () => {
//     if (!currentLead) return;

//     try {
//       let loginEmail = "";
//       let loginAccountType = stableUser.accountType;

//       if (token) {
//         try {
//           const payload = JSON.parse(atob(token.split('.')[1]));
//           loginEmail = payload.email || payload.sub || "";
//           if (payload.accountType) loginAccountType = payload.accountType;
//         } catch (e) {
//           console.error("Token payload extraction error:", e);
//         }
//       }

//       await axios.post(
//         `${API_URL}/api/leads/${currentLead.leadId}/click-to-call`,
//         {
//           loginAccountType: loginAccountType,
//           loginEmail: loginEmail,
//           loginMobileNo: loginMobileNo
//         },
//         { headers: { ...authHeader(), "Content-Type": "application/json" } }
//       );
//       toast.success("Call initiated!");
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to initiate call.");
//     }
//   };

//   const handleOpenSms = async () => {
//     try {
//       const res = await axios.get(`${API_URL}/api/smsTemplates/company/${companyId}`, { headers: authHeader() });
//       setSmsTemplates(res.data?.smsTemplates || res.data || []);
//     } catch (err) { console.error("Failed to fetch SMS templates:", err); }
//     setShowSms(true);
//   };

//   const handleOpenEmail = async () => {
//     try {
//       const res = await axios.get(`${API_URL}/api/emailTemplates/company/${companyId}`, { headers: authHeader() });
//       setEmailTemplates(res.data?.emailTemplates || res.data || []);
//     } catch (err) { console.error("Failed to fetch Email templates:", err); }
//     setShowEmail(true);
//   };

//   const handleOpenWhatsApp = async () => {
//     if (!waApiKey) {
//       toast.error("WhatsApp API Key is not configured for this company.");
//       return;
//     }

//     try {
//       const res = await axios.get(`https://waapi.deetyasoft.com/api/lms/whatsapp-config/getTemplate?apiKey=${waApiKey}`);
//       setWhatsappTemplates(res.data?.templates || res.data?.data || res.data || []);
//       setShowWhatsApp(true);
//     } catch (err) {
//       console.error("Failed to fetch WhatsApp templates:", err);
//       toast.error("Failed to load WhatsApp templates.");
//     }
//   };

//   const handleOpenHistory = async () => {
//     if (!currentLead) return;
//     setHistoryLoading(true);
//     setShowHistoryModal(true);
//     try {
//       const res = await axios.get(`${API_URL}/api/leadHistory/${currentLead.leadId}`, {
//         headers: authHeader(),
//       });
//       setHistoryData(res.data?.content || []);
//     } catch (err) {
//       console.error("Error fetching lead history", err);
//       toast.error("Failed to fetch lead history");
//       setHistoryData([]);
//     } finally {
//       setHistoryLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleKey = (e) => {
//       if (e.ctrlKey && e.key.toLowerCase() === "x") {
//         if (anyModalOpen) {
//           setShowStatus(false);
//           setShowFollowUp(false);
//           setShowAppointment(false);
//           setShowLabel(false);
//           setShowConvert(false);
//           setShowBan(false);
//           setShowWhatsApp(false);
//           setShowSms(false);
//           setShowEmail(false);
//           setShowSearchDropdown(false);
//           setShowHistoryModal(false);
//           return;
//         }
//       }

//       if (anyModalOpen) return;

//       const tag = e.target.tagName;
//       const isInput = tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";

//       if (isInput) return;

//       if (e.key === "ArrowRight") setActiveIndex((i) => Math.min(i + 1, filteredLeads.length - 1));
//       if (e.key === "ArrowLeft") setActiveIndex((i) => Math.max(i - 1, 0));
//       if (e.key === "1") handleCall();
//       if (e.key === "2") handleOpenSms();
//       if (e.key === "3") handleOpenWhatsApp();
//       if (e.key === "4") handleOpenEmail();

//       const key = e.key.toLowerCase();
//       if (key === "s") setShowStatus(true);
//       if (key === "f") setShowFollowUp(true);
//       if (key === "a") setShowAppointment(true);
//       if (key === "p") setShowLabel(true);
//       if (key === "c") {
//         if (!currentLead?.isConvertedLead) setShowConvert(true);
//       }
//       if (key === "b") setShowBan(true);
//     };

//     window.addEventListener("keydown", handleKey);
//     return () => {
//       window.removeEventListener("keydown", handleKey);
//     };
//   }, [filteredLeads.length, anyModalOpen, currentLead, loginMobileNo, stableUser, companyId]);

//   const handleStatusChange = async (statusName, reason) => {
//     if (!currentLead) return;
//     const status = statuses.find((s) => s.name === statusName);
//     try {
//       await axios.put(
//         `${API_URL}/api/leads/update/${currentLead.leadId}/changedBy/${stableUser.id}`,
//         { statusName, statusColor: status?.color, reason },
//         { headers: authHeader() }
//       );

//       setStatusCounts(prev => ({
//         ...prev,
//         [currentLead.statusName]: Math.max(0, (prev[currentLead.statusName] || 0) - 1),
//         [statusName]: (prev[statusName] || 0) + 1
//       }));

//       setAllLeads((prev) => prev.map((l) => String(l.leadId) === String(currentLead.leadId) ? { ...l, statusName, statusColor: status?.color } : l));
//       setShowStatus(false);
//     } catch (err) { console.error(err); }
//   };

//   const handleFollowUpSubmit = async (data) => {
//     if (!currentLead) return;
//     try {
//       await fetch(`${API_URL}/api/leads/${currentLead.leadId}/followups`, {
//         method: "POST",
//         headers: { ...authHeader(), "Content-Type": "application/json" },
//         body: JSON.stringify({ ...data, createdById: stableUser.id, companyId }),
//       });
//       setShowFollowUp(false);
//     } catch (err) { console.error(err); }
//   };

//   const handleAssign = async (userId) => {
//     if (!currentLead) return;
//     try {
//       await axios.put(`${API_URL}/api/leads/assign/${userId}/${stableUser.id}`, [currentLead.leadId], { headers: authHeader() });
//       const assignedUser = users.find((u) => String(u.id) === String(userId));
//       updateLeadInQueue(currentLead.leadId, {
//         assignedToId: userId,
//         assignedToName: assignedUser ? `${assignedUser.fname} ${assignedUser.lname}` : currentLead.assignedToName,
//       });
//       toast.success("Lead assigned successfully!");
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to assign lead.");
//     }
//   };

//   const handleLabel = async (labelId) => {
//     if (!currentLead) return;
//     try {
//       await axios.put(`${API_URL}/api/leads/assignProjectName/${labelId}/${stableUser.id}`, [currentLead.leadId], { headers: authHeader() });
//       setShowLabel(false);
//     } catch (err) { console.error(err); }
//   };

//   const handleConvert = async () => {
//     if (!currentLead) return;
//     try {
//       await axios.post(`${API_URL}/api/convertedLeads`, { ...currentLead, companyId, convertedById: stableUser.id }, { headers: authHeader() });
//       setShowConvert(false);
//     } catch (err) { console.error(err); }
//   };

//   const handleBan = async (reason) => {
//     if (!currentLead) return;
//     try {
//       await axios.post(`${API_URL}/api/blacklist`, { createdById: stableUser.id, leadId: currentLead.leadId, reason, companyId }, { headers: authHeader() });
//       setAllLeads((prev) => prev.filter((l) => String(l.leadId) !== String(currentLead.leadId)));

//       setStatusCounts(prev => ({
//         ...prev,
//         [currentLead.statusName]: Math.max(0, (prev[currentLead.statusName] || 0) - 1)
//       }));

//       setShowBan(false);
//     } catch (err) { console.error(err); }
//   };

//   const handleSendWhatsApp = async (templateName, variableValues = {}) => {
//     if (!waApiKey) {
//       toast.error("WhatsApp API Key is missing!");
//       return;
//     }

//     if (!currentLead?.phone) {
//       toast.error("Lead has no phone number");
//       return;
//     }
//     const cleaned = currentLead.phone.replace(/\D/g, "");
//     const phone = cleaned.startsWith("91") && cleaned.length === 12 ? cleaned : cleaned.length === 10 ? `91${cleaned}` : cleaned;

//     const fd = new FormData();
//     fd.append("apiKey", waApiKey);
//     fd.append("templateName", templateName);
//     fd.append("to", phone);

//     const varKeys = Object.keys(variableValues).sort((a, b) => parseInt(a) - parseInt(b));
//     if (varKeys.length > 0) {
//       const manualVars = varKeys.map(key => variableValues[key] || "").join(",");
//       fd.append("manualVars", manualVars);
//     }

//     try {
//       await axios.post(`https://waapi.deetyasoft.com/api/lms/whatsapp-config/sendVerifiedTemplates`, fd, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       toast.success("WhatsApp message sent!");
//       setShowWhatsApp(false);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to send WhatsApp message.");
//     }
//   };

//   const handleSendSms = async (messageId, variables) => {
//     if (!currentLead?.phone) return toast.error("Lead has no phone number");
//     try {
//       await axios.post(
//         `${API_URL}/api/smsConfig/send/${companyId}?createdById=${stableUser.id}`,
//         {
//           clientNumber: [currentLead.phone],
//           messageId: messageId,
//           variables: variables
//         },
//         { headers: { ...authHeader(), "Content-Type": "application/json" } }
//       );
//       toast.success("SMS sent successfully!");
//       setShowSms(false);
//     } catch (err) {
//       console.error(err);
//       toast.error(err.response?.data?.message || "Failed to send SMS message.");
//     }
//   };

//   const handleSendEmail = async (templateId, variables) => {
//     if (!currentLead?.email) return toast.error("Lead has no email address");

//     setSendingEmailId(templateId);

//     try {
//       const response = await fetch(`${API_URL}/api/leads/${templateId}/sendEmail/${companyId}/${stableUser.id}/${currentLead.email}`, {
//         method: "POST",
//         headers: { ...authHeader(), "Content-Type": "application/json" },
//         body: JSON.stringify(variables)
//       });

//       if (response.ok) {
//         toast.success("Email sent successfully!");
//         setShowEmail(false);
//       } else {
//         toast.error("Failed to send Email.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to send Email message.");
//     } finally {
//       setSendingEmailId(null);
//     }
//   };

//   const updateLeadInQueue = (leadId, updatedFields) => {
//     setAllLeads((prev) =>
//       prev.map((l) => (String(l.leadId) === String(leadId) ? { ...l, ...updatedFields } : l))
//     );
//   };

//   const handleInlineEdit = async (field, value) => {
//     if (!currentLead) return;
//     try {
//       await axios.put(
//         `${API_URL}/api/leads/update/${currentLead.leadId}/changedBy/${stableUser.id}`,
//         { [field]: value },
//         { headers: authHeader() }
//       );
//       updateLeadInQueue(currentLead.leadId, { [field]: value });

//       if (showHistoryModal) {
//         handleOpenHistory();
//       }
//     } catch (err) {
//       if (err.response?.status === 409) {
//         toast.error(err.response.data.message || "A lead with this number already exists");
//       } else {
//         toast.error("Failed to update lead details.");
//       }
//       console.error("Failed to update field", err);
//     }
//   };


//   const handleCustomFieldEdit = async (field, value) => {
//     if (!currentLead) return;
//     try {
//       // Backend ke hisaab se nested customFields object banayenge
//       const updatedCustomFields = {
//         ...(currentLead.customFields || {}),
//         [field]: value,
//       };

//       await axios.put(
//         `${API_URL}/api/leads/update/${currentLead.leadId}/changedBy/${stableUser.id}`,
//         { 
//           [field]: value, // Flat field mapping
//           customFields: updatedCustomFields // Nested object mapping
//         },
//         { headers: authHeader() }
//       );
      
//       // UI queue me state update karo
//       updateLeadInQueue(currentLead.leadId, { 
//         [field]: value,
//         customFields: updatedCustomFields
//       });

//       if (showHistoryModal) {
//         handleOpenHistory();
//       }
//     } catch (err) {
//       if (err.response?.status === 409) {
//         toast.error(err.response.data.message || "A lead with this number already exists");
//       } else {
//         toast.error("Failed to update custom field.");
//       }
//       console.error("Failed to update custom field", err);
//     }
//   };
//   const handleAssignedToChange = (field, value) => {
//     if (!value) return;
//     const matchedUser = users.find((u) => `${u.fname} ${u.lname}` === value);
//     if (matchedUser) handleAssign(matchedUser.id);
//   };

//   const openCommentModal = () => {
//     setCommentDraft(currentLead?.comment || "");
//     setShowComment(true);
//   };

//   const handleCommentSave = async () => {
//     const raw = commentDraft || "";
//     const trimmed = raw.trim();

//     if (raw.length > 0 && trimmed === "") {
//       toast.error("Comment cannot contain only spaces.");
//       return;
//     }

//     const original = (currentLead?.comment || "").trim();
//     if (trimmed !== original) {
//       await handleInlineEdit("comment", trimmed);
//     }
//     setShowComment(false);
//   };

//   const availableActions = [
//     { label: "Call", icon: "📞", onClick: handleCall },
//     { label: "SMS", icon: "💬", onClick: handleOpenSms },
//     { label: "WhatsApp", icon: <SGWhatsAppIcon />, onClick: handleOpenWhatsApp },
//     { label: "Email", icon: "✉️", onClick: handleOpenEmail },
//     { label: "Change Status", icon: "🔄", onClick: () => setShowStatus(true) },
//     { label: "Add Follow-up", icon: "📅", onClick: () => setShowFollowUp(true) },
//     { label: "Appointment", icon: "🗓️", onClick: () => setShowAppointment(true) },
//     { label: "Assign Project", icon: "🏷️", onClick: () => setShowLabel(true) },
//     { label: "Convert to Customer", icon: "✅", onClick: () => setShowConvert(true), disabled: currentLead?.isConvertedLead },
//     { label: "Block Lead", icon: "🚫", onClick: () => setShowBan(true) }
//   ];

//   const lowerQuery = searchQuery.toLowerCase();
//   const matchedLeads = searchQuery ? allLeads.filter(l =>
//     (l.name && l.name.toLowerCase().includes(lowerQuery)) ||
//     (l.phone && l.phone.includes(lowerQuery))
//   ).slice(0, 5) : [];

//   const matchedActions = searchQuery ? availableActions.filter(a =>
//     a.label.toLowerCase().includes(lowerQuery) && !a.disabled
//   ) : [];

//   const handleSearchSelectLead = (lead) => {
//     setActiveStatus((lead.statusName || "").trim());
//     const leadsInStatus = allLeads.filter((l) => l.statusName === lead.statusName);
//     const idx = leadsInStatus.findIndex((l) => String(l.leadId) === String(lead.leadId));
//     if (idx !== -1) setActiveIndex(idx);
//     setSearchQuery("");
//     setShowSearchDropdown(false);
//   };

//   const handleSearchSelectAction = (action) => {
//     action.onClick();
//     setSearchQuery("");
//     setShowSearchDropdown(false);
//   };

//   const handleSearchKeyDown = (e) => {
//     if (e.key === "Enter") {
//       if (matchedLeads.length > 0) handleSearchSelectLead(matchedLeads[0]);
//       else if (matchedActions.length > 0) handleSearchSelectAction(matchedActions[0]);
//     }
//   };

//   const fetchMoreLeads = useCallback(async () => {
//     if (!hasMoreApiLeads || fetchingMore) return;
//     setFetchingMore(true);
//     try {
//       const nextApiPage = apiPage + 1;
//       const url = isOwnerLevel(stableUser.accountType)
//         ? `${API_URL}/api/leads/company/${companyId}?pageNumber=${nextApiPage}&pageSize=200`
//         : `${API_URL}/api/leads/assigned/${stableUser.id}?pageNumber=${nextApiPage}&pageSize=200`;

//       const res = await axios.get(url, { headers: authHeader() });
//       const newLeads = res.data?.leads || [];

//       if (newLeads.length < 200) {
//         setHasMoreApiLeads(false);
//       }

//       setAllLeads((prev) => {
//         const existingIds = new Set(prev.map(l => String(l.leadId)));
//         const uniqueNewLeads = newLeads.filter(l => l.leadId && !existingIds.has(String(l.leadId)));
//         return [...prev, ...uniqueNewLeads];
//       });

//       setApiPage(nextApiPage);
//     } catch (err) {
//       console.error("Failed to auto fetch more leads.", err);
//     } finally {
//       setFetchingMore(false);
//     }
//   }, [apiPage, hasMoreApiLeads, fetchingMore, companyId, stableUser]);

//   const totalLeadPages = Math.ceil(filteredLeads.length / leadsPerPage);

//   useEffect(() => {
//     if (leadPage > 0 && totalLeadPages > 0 && leadPage >= totalLeadPages - 2 && hasMoreApiLeads && !fetchingMore) {
//       fetchMoreLeads();
//     }
//   }, [leadPage, totalLeadPages, hasMoreApiLeads, fetchingMore, fetchMoreLeads]);

//   if (authLoading || !isAuthenticated) return null;

//   if (splash) {
//     return (
//       <>
//         <style>{SG_CSS}</style>
//         <div className="sg2-splash">
//           <motion.div
//             initial={{ scale: 0.5, opacity: 0 }}
//             animate={{ scale: 1, opacity: 1 }}
//             transition={{ type: "spring", stiffness: 100, damping: 20 }}
//             className="sg2-splash-text"
//           >
//             Sales God
//           </motion.div>
//         </div>
//       </>
//     );
//   }

//   const nextFollowUp = currentLead?.followUps?.[0];
//   const paginatedLeads = filteredLeads.slice(leadPage * leadsPerPage, (leadPage + 1) * leadsPerPage);

//   const handleNextLeadPage = async () => {
//     const nextPage = leadPage + 1;
//     const currentTotalPages = Math.ceil(filteredLeads.length / leadsPerPage);

//     if (nextPage < currentTotalPages) {
//       setActiveIndex(nextPage * leadsPerPage);
//     } else if (hasMoreApiLeads && !fetchingMore) {
//       fetchMoreLeads();
//     }
//   };

//   const handlePrevLeadPage = () => {
//     const prevPage = leadPage - 1;
//     if (prevPage >= 0) {
//       setActiveIndex(prevPage * leadsPerPage);
//     }
//   };

//   return (
//     <>
//       <style>{SG_CSS}</style>
//       <div className="sg2-overlay">

//         {/* ── HEADER ─────────────────────────────────────────────────────────── */}
//         <div className="sg2-header">
//           {/* Left: Title + count */}
//           <div className="sg2-header-title">
//             <span className="sg2-header-brand">Sales God</span>
//             {currentLead && (
//               <span className="sg2-header-count">{activeIndex + 1} / {statusCounts[activeStatus] || filteredLeads.length}</span>
//             )}
//           </div>

//           {/* Center: Status bar */}
//           <div className="sg2-status-bar">
//             {statuses.map((s) => (
//               <button
//                 key={s.leadStatusId || s.name}
//                 onClick={() => setActiveStatus(s.name)}
//                 className={`sg2-status-btn ${activeStatus === s.name ? "sg2-status-btn--active" : "sg2-status-btn--inactive"}`}
//               >
//                 {s.name}
//                 <span className="sg2-status-count">{statusCounts[s.name] || 0}</span>
//               </button>
//             ))}
//           </div>

//           {/* Right: Search + close */}
//           <div className="sg2-header-right">

//             <div className="sg2-search-container" ref={searchContainerRef}>
//               <span className="sg2-search-icon">
//                 <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#673AB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                   <circle cx="11" cy="11" r="8"></circle>
//                   <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//                 </svg>
//               </span>
//               <input
//                 type="text"
//                 placeholder="Search leads or actions..."
//                 className="sg2-search-input"
//                 value={searchQuery}
//                 onChange={(e) => {
//                   setSearchQuery(e.target.value);
//                   setShowSearchDropdown(true);
//                 }}
//                 onKeyDown={handleSearchKeyDown}
//                 onFocus={() => setShowSearchDropdown(true)}
//               />
//               <AnimatePresence>
//                 {showSearchDropdown && searchQuery && (matchedLeads.length > 0 || matchedActions.length > 0) && (
//                   <motion.div
//                     initial={{ opacity: 0, y: -10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: -10 }}
//                     transition={{ duration: 0.15 }}
//                     className="sg2-search-dropdown"
//                   >
//                     {matchedLeads.length > 0 && (
//                       <div className="sg2-search-group">
//                         <div className="sg2-search-group-title">Leads</div>
//                         {matchedLeads.map((l) => (
//                           <div key={l.leadId} className="sg2-search-item" onClick={() => handleSearchSelectLead(l)}>
//                             <SGAvatar name={l.name || "?"} size={24} />
//                             <div className="sg2-search-item-info">
//                               <span className="sg2-search-item-name">{l.name}</span>
//                               <span className="sg2-search-item-phone">{l.phone}</span>
//                             </div>
//                             <span className="sg2-status-pill sg2-search-pill" style={{ background: l.statusColor || "#0C4550" }}>{l.statusName}</span>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                     {matchedActions.length > 0 && (
//                       <div className="sg2-search-group">
//                         <div className="sg2-search-group-title">Actions</div>
//                         {matchedActions.map((a) => (
//                           <div key={a.label} className="sg2-search-item" onClick={() => handleSearchSelectAction(a)}>
//                             <span className="sg2-search-item-icon">{a.icon}</span>
//                             <span className="sg2-search-item-name">{a.label}</span>
//                             <span className="sg2-search-hint">↵ Enter</span>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>

//             {isIncomingModeOn && (
//               <button
//                 onClick={() => navigate("/dashboard/incoming-mode")}
//                 className="sg2-incoming-btn"
//                 title="Open live incoming-call feed"
//               >
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                   <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
//                 </svg>
//                 Incoming Mode
//               </button>
//             )}

//             <button onClick={() => navigate(-1)} className="sg2-close-btn">✕</button>
//           </div>
//         </div>

//         {/* ── BODY ───────────────────────────────────────────────────────────── */}
//         <div className="sg2-body">
//           {loading ? (
//             <div className="sg2-centered"><div className="sg2-spinner sg2-spinner--lg" /></div>
//           ) : filteredLeads.length === 0 ? (
//             <div className="sg2-centered"><p className="sg2-empty">No leads in this status.</p></div>
//           ) : (
//             <>
//               {/* ── WORKSPACE ──────────────────────────────────────────────── */}
//               <div className="sg2-workspace">

//                 {/* LEFT: Lead detail */}
//                 <div className="sg2-detail-panel">
//                   <AnimatePresence mode="wait">
//                     {currentLead && (
//                       <motion.div
//                         key={currentLead.leadId}
//                         initial={{ opacity: 0, x: 20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         exit={{ opacity: 0, x: -20 }}
//                         transition={{ duration: 0.18 }}
//                         style={{ display: "flex", flexDirection: "column", gap: 20, height: "100%" }}
//                       >
//                         {/* Identity - Top Row Structure */}
//                         <div className="sg2-lead-identity-top">
//                           <SGAvatar name={currentLead.name || "?"} size={56} />
//                           <div className="sg2-lead-top-details" style={{ width: "100%" }}>
//                             <SGEditableField className="sg2-lead-name" value={currentLead.name} onSave={(v) => handleInlineEdit('name', v)} label="Name" />

//                             <div className="sg2-lead-top-row-info" style={{ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap", gap: "10px" }}>

//                               {/* LEFT SIDE: Contact Info */}
//                               <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//                                 <span className="sg2-contact-badge">
//                                   <span className="sg2-badge-icon">📞</span>
//                                   {isPhoneMasked(currentLead.phone) ? (
//                                     <span className="sg2-header-inline" title="Phone number is hidden">{currentLead.phone}</span>
//                                   ) : (
//                                     <SGEditableField className="sg2-header-inline" value={currentLead.phone} onSave={(v) => handleInlineEdit('phone', v)} label="Phone" />
//                                   )}
//                                 </span>
//                                 <span className="sg2-contact-badge">
//                                   <span className="sg2-badge-icon">✉️</span>
//                                   <SGEditableField className="sg2-header-inline" value={currentLead.email} onSave={(v) => handleInlineEdit('email', v)} label="Email" />
//                                 </span>
//                                 <span className="sg2-contact-badge">
//                                   <span className="sg2-badge-icon">🏢</span>
//                                   <SGEditableField className="sg2-header-inline" value={currentLead.companyName} onSave={(v) => handleInlineEdit('companyName', v)} label="Company" />
//                                 </span>
//                               </div>

//                               {/* RIGHT SIDE: Call History -> Lead History -> Status */}
//                               <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
//                                 <button
//                                   className="sg2-history-trigger-btn"
//                                   onClick={handleOpenCallHistory}
//                                   title="Call History"
//                                   style={{ padding: "4px 10px", marginLeft: 0 }}
//                                 >
//                                   <span className="sg2-badge-icon">🎙️</span>
//                                   <span>Call History</span>
//                                 </button>

//                                 <button
//                                   className="sg2-history-trigger-btn"
//                                   onClick={() => setShowTranscribeModal(true)}
//                                   title="Transcribe & Rate Calls"
//                                   style={{ padding: "4px 10px", marginLeft: 0 }}
//                                 >
//                                   <span className="sg2-badge-icon">📝</span>
//                                   <span>Transcribe</span>
//                                 </button>

//                                 <button
//                                   className="sg2-history-trigger-btn"
//                                   onClick={handleOpenHistory}
//                                   title="Lead History"
//                                   style={{ padding: "4px 10px", marginLeft: 0 }}
//                                 >
//                                   <span className="sg2-badge-icon">🕘</span>
//                                   <span>Lead History</span>
//                                 </button>

//                                 <span className="sg2-status-pill" style={{ background: currentLead.statusColor || "#0C4550", marginLeft: 0, padding: "4px 12px" }}>
//                                   {currentLead.statusName}
//                                 </span>
//                               </div>

//                             </div>
//                           </div>
//                         </div>

//                         {/* Info grid - Modernized Cards */}
//                         <div className="sg2-info-grid">
//                           <SGInfoRow icon="📋" label="Project" value={currentLead.projectName} field="projectName" onSave={handleInlineEdit} options={labels} />
//                           <SGInfoRow icon="🔗" label="Source" value={currentLead.sourceName} field="sourceName" onSave={handleInlineEdit} />
//                           <SGInfoRow
//                             icon="👤"
//                             label="Assigned to"
//                             value={currentLead.assignedToName}
//                             field="assignedToName"
//                             onSave={handleAssignedToChange}
//                             options={users.map((u) => ({ name: `${u.fname} ${u.lname}` }))}
//                           />
//                           <SGInfoRow icon="👤" label="Created by" value={currentLead.createdByName} />
//                           <SGInfoRow icon="📍" label="City" value={currentLead.city} field="city" onSave={handleInlineEdit} />
//                           <SGInfoRow icon="📍" label="State" value={currentLead.state} field="state" onSave={handleInlineEdit} />
//                           <SGInfoRow icon="🏠" label="Address" value={currentLead.address} field="address" onSave={handleInlineEdit} />
//                           {nextFollowUp?.nextFollowUpDate && (
//                             <SGInfoRow icon="⏰" label="Next follow-up" value={`${nextFollowUp.nextFollowUpDate}${nextFollowUp.nextFollowUpTime ? " " + nextFollowUp.nextFollowUpTime.substring(0, 5) : ""}`} />
//                           )}
//                           <SGInfoRow icon="📅" label="Added on" value={currentLead.createdAt ? new Date(currentLead.createdAt).toLocaleDateString("en-IN") : ""} />
//                           <SGInfoRow icon="📱" label="Alt. contact" value={currentLead.otherContactNo} field="otherContactNo" onSave={handleInlineEdit} />
//                           {currentLead.leadDate && (
//                             <SGInfoRow icon="📆" label="Lead date" value={new Date(currentLead.leadDate).toLocaleDateString("en-IN")} />
//                           )}
//                           {nextFollowUp?.lastFollowUpDate && (
//                             <SGInfoRow icon="🕓" label="Last follow-up" value={new Date(nextFollowUp.lastFollowUpDate).toLocaleDateString("en-IN")} />
//                           )}
//                           <SGInfoRow icon="✅" label="Converted" value={currentLead.isConvertedLead ? "Yes" : "No"} />

//                           <SGCommentRow value={currentLead.comment} onClick={openCommentModal} />
//                         </div>
// {/* Additional fields configured on the Lead Config page (fetched via GET API) */}
// {customFields.length > 0 && (
//   <div className="sg2-custom-fields-section">
//     <div className="sg2-section-title">Additional fields</div>
//     <div className="sg2-custom-fields-scroll">
//       <div className="sg2-info-grid">
//         {customFields.map((field) => {
//           const val = currentLead?.customFields?.[field.fieldKey] ?? currentLead?.[field.fieldKey];

//           let fieldOptions = undefined;
//           let inputType = "text";
          
//           if (field.fieldType === "DROPDOWN") {
//             inputType = "DROPDOWN";
//             fieldOptions = (typeof field.options === 'string' ? field.options.split(',') : (field.options || [])).map((o) => ({ name: typeof o === 'string' ? o.trim() : o }));
//           } else if (field.fieldType === "YES_NO" || field.fieldType === "BOOLEAN") {
//             inputType = field.fieldType;
//           }

//           return (
//             <SGInfoRow
//               key={field.id || field.fieldKey}
//               icon="🧩"
//               label={field.label}
//               value={val}
//               field={field.fieldKey}
//               type={inputType}
//               onSave={handleCustomFieldEdit} 
//               options={fieldOptions}
//             />
//           );
//         })}
//       </div>
//     </div>
//   </div>
// )}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>

//                 {/* RIGHT: Actions */}
//                 <div className="sg2-actions-panel">

//                   {/* Communication hub */}
//                   <div className="sg2-section">
//                     <div className="sg2-section-title-wrap">
//                       <div className="sg2-section-title">Communication</div>
//                       <div className="sg2-comm-info-container" ref={commInfoRef}>
//                         <button
//                           className="sg2-comm-info-btn"
//                           onClick={() => setShowCommInfo(!showCommInfo)}
//                           title="Shortcuts Info"
//                         >
//                           ⋮
//                         </button>
//                         <AnimatePresence>
//                           {showCommInfo && (
//                             <motion.div
//                               initial={{ opacity: 0, y: 5 }}
//                               animate={{ opacity: 1, y: 0 }}
//                               exit={{ opacity: 0, y: 5 }}
//                               transition={{ duration: 0.15 }}
//                               className="sg2-comm-info-popover"
//                             >
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">1</span> for Call</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">2</span> for SMS</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">3</span> for WhatsApp</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">4</span> for Email</div>
//                             </motion.div>
//                           )}
//                         </AnimatePresence>
//                       </div>
//                     </div>
//                     <div className="sg2-comm-grid">
//                       <SGCommBtn icon="📞" label="Call" shortcut="1" color="#16a34a" onClick={handleCall} />
//                       <SGCommBtn icon="💬" label="SMS" shortcut="2" color="#2563eb" onClick={handleOpenSms} />
//                       <SGCommBtn icon={<SGWhatsAppIcon />} label="WhatsApp" shortcut="3" color="#16a34a" onClick={handleOpenWhatsApp} />
//                       <SGCommBtn icon="✉️" label="Email" shortcut="4" color="#dc2626" onClick={handleOpenEmail} />
//                     </div>
//                   </div>

//                   {/* Lead management */}
//                   <div className="sg2-section">
//                     <div className="sg2-section-title-wrap">
//                       <div className="sg2-section-title">Lead management</div>
//                       <div className="sg2-comm-info-container" ref={leadInfoRef}>
//                         <button
//                           className="sg2-comm-info-btn"
//                           onClick={() => setShowLeadInfo(!showLeadInfo)}
//                           title="Shortcuts Info"
//                         >
//                           ⋮
//                         </button>
//                         <AnimatePresence>
//                           {showLeadInfo && (
//                             <motion.div
//                               initial={{ opacity: 0, y: 5 }}
//                               animate={{ opacity: 1, y: 0 }}
//                               exit={{ opacity: 0, y: 5 }}
//                               transition={{ duration: 0.15 }}
//                               className="sg2-comm-info-popover"
//                             >
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">S</span> for Status</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">F</span> for Follow-up</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">A</span> for Appointment</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">P</span> for Project</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">C</span> for Convert</div>
//                               <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">B</span> for Block</div>
//                             </motion.div>
//                           )}
//                         </AnimatePresence>
//                       </div>
//                     </div>
//                     <div className="sg2-actions-grid">
//                       <SGActionBtn icon="🔄" label="Status" shortcut="S" onClick={() => setShowStatus(true)} />
//                       <SGActionBtn icon="📅" label="Follow-up" shortcut="F" onClick={() => setShowFollowUp(true)} />
//                       <SGActionBtn icon="🗓️" label="Appointment" shortcut="A" onClick={() => setShowAppointment(true)} />
//                       <SGActionBtn icon="🏷️" label="Project" shortcut="P" onClick={() => setShowLabel(true)} />
//                       <SGActionBtn icon="✅" label="Convert" shortcut="C" onClick={() => setShowConvert(true)} variant="success" disabled={currentLead?.isConvertedLead} />
//                       <SGActionBtn icon="🚫" label="Block" shortcut="B" onClick={() => setShowBan(true)} variant="danger" />
//                     </div>
//                   </div>

//                   {/* Tags */}
//                   {currentLead?.tag && (
//                     <div className="sg2-section">
//                       <div className="sg2-section-title">Tags</div>
//                       <div className="sg2-tags">
//                         {(Array.isArray(currentLead.tag) ? currentLead.tag : [currentLead.tag]).map((t, i) => (
//                           <span key={i} className="sg2-tag">{t}</span>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* ── LEAD QUEUE ─────────────────────────────────────────────── */}
//               <div className="sg2-queue-wrap">
//                 <button className="sg2-queue-nav" disabled={leadPage === 0} onClick={handlePrevLeadPage}>←</button>
//                 <div className="sg2-queue-track">
//                   {paginatedLeads.map((lead, i) => {
//                     const actualIndex = leadPage * leadsPerPage + i;
//                     return (
//                       <SGQueueCard
//                         key={String(lead.leadId || actualIndex)}
//                         lead={lead}
//                         index={actualIndex}
//                         isActive={actualIndex === activeIndex}
//                         onClick={() => setActiveIndex(actualIndex)}
//                       />
//                     );
//                   })}
//                 </div>
//                 <button
//                   className="sg2-queue-nav"
//                   disabled={(leadPage >= Math.ceil(filteredLeads.length / leadsPerPage) - 1 && !hasMoreApiLeads) || fetchingMore}
//                   onClick={handleNextLeadPage}
//                 >
//                   {fetchingMore ? "..." : "→"}
//                 </button>
//               </div>
//             </>
//           )}
//         </div>

//         {/* ── INLINE SUB-MODALS ──────────────────────────────────────────────── */}
//         <SGStatusModal open={showStatus} statuses={statuses} currentStatus={currentLead?.statusName} onConfirm={handleStatusChange} onClose={() => setShowStatus(false)} />
//         <SGFollowUpModal open={showFollowUp} users={users} onClose={() => setShowFollowUp(false)} onSubmit={handleFollowUpSubmit} loggedInUser={stableUser} />
//         <SGAppointmentModal open={showAppointment} lead={currentLead} companyId={companyId} stableUser={stableUser} users={users} onClose={() => setShowAppointment(false)} onScheduled={() => { }} />
//         <SGLabelModal open={showLabel} labels={labels} onClose={() => setShowLabel(false)} onConfirm={handleLabel} />
//         <SGConvertModal open={showConvert} onClose={() => setShowConvert(false)} onConfirm={handleConvert} />
//         <SGBanModal open={showBan} onClose={() => setShowBan(false)} onConfirm={handleBan} />
//         <SGWhatsAppModal open={showWhatsApp} templates={whatsappTemplates} onClose={() => setShowWhatsApp(false)} onSend={handleSendWhatsApp} />
//         <SGSmsModal open={showSms} templates={smsTemplates} onClose={() => setShowSms(false)} onSend={handleSendSms} />
//         <SGEmailModal open={showEmail} templates={emailTemplates} onClose={() => setShowEmail(false)} onSend={handleSendEmail} sendingEmailId={sendingEmailId} />
//         <SGHistoryModal open={showHistoryModal} lead={currentLead} historyData={historyData} loading={historyLoading} onClose={() => setShowHistoryModal(false)} />
//         <SGCallHistoryModal open={showCallHistoryModal} lead={currentLead} data={callHistoryData} loading={callHistoryLoading} onClose={() => setShowCallHistoryModal(false)} />
//         <SGTranscribeModal open={showTranscribeModal} lead={currentLead} companyId={companyId} onClose={() => setShowTranscribeModal(false)} onLeadUpdated={updateLeadInQueue} />
//         <SGCommentModal open={showComment} value={commentDraft} onChange={setCommentDraft} onSave={handleCommentSave} onClose={() => setShowComment(false)} />
//       </div>
//     </>
//   );
// };

// // ──────────────────────────────────────────────────────────────────────────────
// //  CSS
// // ──────────────────────────────────────────────────────────────────────────────
// const SG_CSS = `
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

//   /* Loading Spinner for SG */
//   .sg2-spinner { width: 24px; height: 24px; border: 2.5px solid #e5e9f0; border-top-color: #0C4550; border-radius: 50%; animation: sg-spin .7s linear infinite; }
//   .sg2-spinner--lg { width: 40px; height: 40px; border-width: 3.5px; }
//   @keyframes sg-spin { to { transform: rotate(360deg); } }

//   .sg2-splash {
//     position: fixed; inset: 0; z-index: 9999;
//     background-color: #EEF2FC;
//     background-image:
//       radial-gradient(circle at 50% 50%, rgba(103,58,183,0.06) 0%, rgba(238,242,252,0) 60%),
//       url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='220' height='220' viewBox='0 0 220 220'%3E%3Cg fill='none' stroke='%23673AB7' stroke-width='1.4' opacity='0.09'%3E%3Cpath d='M30 40c0-4 3-7 7-7h10l4 8-5 5c2 6 6 10 12 12l5-5 8 4v10c0 4-3 7-7 7-19 0-34-15-34-34z'/%3E%3Crect x='120' y='20' width='26' height='20' rx='4'/%3E%3Cpath d='M120 40l13 8 13-8'/%3E%3Ccircle cx='180' cy='90' r='11'/%3E%3Cpath d='M172 106c0-6 5-10 11-10h6c6 0 11 4 11 10'/%3E%3Cpath d='M20 120h24M20 128h16M20 136h20'/%3E%3Cpath d='M60 150l6 6 12-13'/%3E%3Ccircle cx='60' cy='150' r='16'/%3E%3Cpath d='M140 130v30M130 150h20'/%3E%3Crect x='125' y='125' width='30' height='30' rx='6'/%3E%3Cpath d='M20 190h12l4-10 6 20 6-15 4 5h10'/%3E%3C/g%3E%3C/svg%3E");
//     background-repeat: repeat, repeat;
//     background-size: auto, 220px 220px;
//     display: flex; align-items: center; justify-content: center;
//     font-family: 'Plus Jakarta Sans', sans-serif;
//   }
  
//   .sg2-splash-text {
//     font-size: 64px; font-weight: 700;
//     color: #673AB7; letter-spacing: -1.5px;
//   }

//   .sg2-overlay {
//     position: fixed; inset: 0; z-index: 9998;
//     background: #f0f4f8;
//     display: flex; flex-direction: column;
//     font-family: 'Plus Jakarta Sans', sans-serif;
//     overflow: hidden;
//   }

//   /* Header */
//   .sg2-header {
//     background: #fff;
//     border-bottom: 1px solid #e5e9f0;
//     padding: 10px 24px;
//     min-height: 60px;
//     display: flex;
//     align-items: center;
//     flex-wrap: wrap;
//     justify-content: space-between;
//     gap: 10px 16px;
//     box-shadow: 0 1px 4px rgba(0,0,0,.05);
//     flex-shrink: 0;
//     z-index: 10;
//   }
//   .sg2-header-title {
//     display: flex; align-items: baseline; gap: 10px;
//     flex-shrink: 0; min-width: 140px;
//   }
//   .sg2-header-brand { font-size: 20px; font-weight: 700; color: #0C4550; letter-spacing: -0.4px; }
//   .sg2-header-count { font-size: 12px; color: #9ca3af; font-weight: 500; }

//   .sg2-status-bar {
//     display: flex; align-items: center; flex-wrap: wrap; gap: 8px;
//     flex: 1 1 320px; justify-content: center;
//     padding: 4px 8px;
//     max-height: 96px; overflow-y: auto;
//   }
//   .sg2-status-bar::-webkit-scrollbar { width: 4px; }
//   .sg2-status-bar::-webkit-scrollbar-thumb { background: #d8dee8; border-radius: 4px; }
//   .sg2-status-btn {
//     display: inline-flex; align-items: center; gap: 6px;
//     height: 34px; padding: 0 16px; border-radius: 20px;
//     font-size: 13px; font-weight: 600; white-space: nowrap;
//     cursor: pointer; border: none; transition: all .15s;
//     font-family: inherit; flex-shrink: 0;
//   }
//   .sg2-status-btn--active { background: #0C4550; color: #fff; }
//   .sg2-status-btn--inactive { background: #f1f5f9; color: #4b5563; }
//   .sg2-status-btn--inactive:hover { background: #e2e8f0; color: #1a1f36; }
//   .sg2-status-count {
//     background: rgba(255,255,255,0.25); font-size: 11px;
//     padding: 1px 6px; border-radius: 10px; font-weight: 700;
//   }
//   .sg2-status-btn--inactive .sg2-status-count { background: #e2e8f0; color: #6b7280; }

//   .sg2-header-right {
//     display: flex; align-items: center; gap: 14px;
//     flex-shrink: 0; justify-content: flex-end;
//   }

//   @media (max-width: 900px) {
//     .sg2-header { padding: 10px 16px; }
//     .sg2-status-bar { flex-basis: 100%; order: 3; max-height: 84px; }
//     .sg2-header-title { order: 1; }
//     .sg2-header-right { order: 2; }
//   }
//   @media (max-width: 520px) {
//     .sg2-header-brand { font-size: 17px; }
//     .sg2-status-btn { height: 30px; padding: 0 12px; font-size: 12px; }
//   }
  
//   /* NEW SEARCH BAR CSS */
//   .sg2-search-container {
//     position: relative;
//     display: flex;
//     align-items: center;
//     background: #f8fafc;
//     border: 1px solid #e5e9f0;
//     border-radius: 20px;
//     padding: 6px 14px;
//     transition: all 0.2s;
//   }
//   .sg2-search-container:focus-within {
//     background: #fff;
//     border-color: #673AB7;
//     box-shadow: 0 0 0 3px rgba(103, 58, 183, 0.15);
//   }
//   .sg2-search-icon {
//     display: flex; align-items: center; justify-content: center; margin-right: 8px;
//   }
//   .sg2-search-input {
//     border: none; background: transparent; outline: none;
//     font-size: 13px; font-family: inherit; color: #1a1f36; width: 220px;
//     transition: width 0.2s;
//   }
//   .sg2-search-input::placeholder { color: #9ca3af; font-weight: 500; }
  
//   .sg2-search-dropdown {
//     position: absolute; top: calc(100% + 10px); right: 0; width: 340px;
//     background: #fff; border: 1px solid #e5e9f0; border-radius: 12px;
//     box-shadow: 0 10px 25px rgba(0,0,0,0.1); overflow: hidden; z-index: 100;
//     display: flex; flex-direction: column; max-height: 400px; overflow-y: auto;
//   }
//   .sg2-search-group { display: flex; flex-direction: column; }
//   .sg2-search-group:not(:last-child) { border-bottom: 1px solid #f1f5f9; }
//   .sg2-search-group-title {
//     font-size: 10px; font-weight: 700; color: #9ca3af; text-transform: uppercase;
//     padding: 8px 14px; background: #f8fafc; letter-spacing: 0.05em;
//   }
//   .sg2-search-item {
//     display: flex; align-items: center; gap: 12px; padding: 10px 14px;
//     cursor: pointer; transition: background 0.15s;
//   }
//   .sg2-search-item:hover { background: #f1f5f9; }
//   .sg2-search-item-info { display: flex; flex-direction: column; flex: 1; min-width: 0; }
//   .sg2-search-item-name { font-size: 13px; font-weight: 600; color: #1a1f36; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
//   .sg2-search-item-phone { font-size: 11px; color: #6b7280; margin-top: 2px;}
//   .sg2-search-pill { font-size: 10px; padding: 3px 8px; margin-left: auto; border-radius: 10px;}
//   .sg2-search-item-icon { font-size: 16px; width: 24px; text-align: center; }
//   .sg2-search-hint { font-size: 10px; color: #9ca3af; margin-left: auto; font-weight: 600; background: #f1f5f9; padding: 2px 6px; border-radius: 4px;}

//   /* Incoming Mode button */
//   .sg2-incoming-btn {
//     display: flex; align-items: center; gap: 6px;
//     background: #0C4550; color: #fff; border: none;
//     height: 32px; padding: 0 14px; border-radius: 8px;
//     font-family: 'Plus Jakarta Sans', sans-serif; font-size: 12.5px; font-weight: 600;
//     cursor: pointer; white-space: nowrap; transition: background 0.15s ease;
//   }
//   .sg2-incoming-btn:hover { background: #0a3840; }

//   .sg2-close-btn {
//     background: none !important; border: none; font-size: 20px; color:black !important;
//     cursor: pointer; width: 32px; height: 32px; border-radius: 8px;
//     display: flex; align-items: center; justify-content: center;
//   }

//   .sg2-inline-close {
//     background: none !important; border: none; font-size: 16px; color: black !important;
//     cursor: pointer; width: 28px; height: 28px; border-radius: 6px;
//     display: flex; align-items: center; justify-content: center;
//   }

//   /* Body */
//   .sg2-body {
//     flex: 1; display: flex; flex-direction: column;
//     overflow: hidden; padding: 20px 24px 16px; gap: 16px;
//   }
//   .sg2-centered { flex: 1; display: flex; align-items: center; justify-content: center; }
//   .sg2-empty { color: #9ca3af; font-size: 15px; }

//   /* Workspace */
//   .sg2-workspace {
//     display: grid; grid-template-columns: 1fr 320px;
//     gap: 16px; flex: 1; min-height: 0; overflow: hidden;
//   }
//   @media (max-width: 900px) {
//     .sg2-workspace { grid-template-columns: 1fr; overflow-y: auto; }
//   }

//   /* Detail panel */
//   .sg2-detail-panel {
//     background: #fff; border: 1px solid #e5e9f0; border-radius: 16px;
//     padding: 24px; display: flex; flex-direction: column; gap: 20px;
//     overflow-y: auto; box-shadow: 0 1px 4px rgba(0,0,0,.04);
//   }

//   /* NEW: Top row identity styling */
//   .sg2-lead-identity-top {
//     display: flex; align-items: center; gap: 18px; flex-wrap: wrap;
//     padding-bottom: 20px; border-bottom: 1px solid #f1f5f9;
//   }
//   .sg2-lead-top-details {
//     display: flex; flex-direction: column; gap: 8px; flex: 1; min-width: 250px;
//   }
//   .sg2-lead-top-row-info {
//     display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
//   }
//   .sg2-contact-badge {
//     display: inline-flex; align-items: center; gap: 6px;
//     background: #f8fafc; border: 1px solid #e2e8f0; padding: 5px 12px; border-radius: 20px;
//     transition: background 0.15s;
//   }
//   .sg2-contact-badge:hover { background: #f1f5f9; }
//   .sg2-badge-icon { font-size: 14px; }
//   .sg2-status-pill {
//     color: #fff; font-size: 12px; font-weight: 600; padding: 6px 16px; 
//     border-radius: 20px; white-space: nowrap; flex-shrink: 0; margin-left: auto;
//   }

//   .sg2-history-trigger-btn {
//     display: inline-flex; align-items: center; gap: 6px;
//     margin-left: auto;
//     background: #f3e8ff; border: 1px solid #e4d3fb; color: #673AB7;
//     font-size: 12px; font-weight: 700; padding: 6px 14px; border-radius: 20px;
//     cursor: pointer; font-family: inherit; transition: all .15s;
//   }
//   .sg2-history-trigger-btn:hover { background: #ecdcff; border-color: #d9bffb; transform: translateY(-1px); }

//   /* Info Grid */
//   .sg2-info-grid {
//     display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 12px;
//   }
//   .sg2-info-row {
//     display: flex; align-items: center; gap: 12px;
//     background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px;
//     padding: 12px 16px; transition: all 0.2s;
//   }
//   .sg2-info-row:hover { background: #f1f5f9; border-color: #cbd5e1; }
  
//   .sg2-info-icon {
//     font-size: 18px; flex-shrink: 0; background: #fff;
//     width: 36px; height: 36px; border-radius: 8px; border: 1px solid #e2e8f0;
//     display: flex; align-items: center; justify-content: center;
//     box-shadow: 0 1px 2px rgba(0,0,0,0.03);
//   }
  
//   .sg2-info-content { display: flex; flex-direction: column; min-width: 0; flex: 1; }
//   .sg2-info-label {
//     font-size: 11px; color: #4b5563; font-weight: 700; text-transform: uppercase; 
//     letter-spacing: .05em; margin-bottom: 2px;
//   }
//   .sg2-info-value {
//     font-size: 14px; color: #111827; font-weight: 600; 
//     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//   }
//   .sg2-link { color: #0C4550; text-decoration: none; }
//   .sg2-link:hover { text-decoration: underline; }

//   /* Comment row now sits inline like every other field (small, single-line, click to open editor) */
//   .sg2-info-row--comment { cursor: pointer; }

//   /* Additional (custom) lead fields configured on the Lead Config page */
//   .sg2-custom-fields-section { margin-top: 4px; padding-bottom: 24px; }
//   .sg2-custom-fields-scroll {
//     /* Removed max-height and overflow-y to let the parent detail panel handle the scrolling properly */
//     padding-right: 6px;
//     margin-right: -6px;
//   }

//   /* Actions panel */
//   .sg2-actions-panel {
//     background: #fff; border: 1px solid #e5e9f0; border-radius: 16px;
//     padding: 20px; display: flex; flex-direction: column; gap: 20px;
//     overflow-y: auto; box-shadow: 0 1px 4px rgba(0,0,0,.04);
//   }
  
//   .sg2-section-title-wrap { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
//   .sg2-section-title-wrap .sg2-section-title { margin-bottom: 0; }
//   .sg2-section-title { font-size: 11px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: .06em; margin-bottom: 10px; }

//   .sg2-comm-info-container { position: relative; display: flex; align-items: center; }
//   .sg2-comm-info-btn { 
//     background: none; border: none; cursor: pointer; font-size: 18px; font-weight: 700;
//     color: #9ca3af; padding: 0 4px; line-height: 1; border-radius: 4px; transition: all 0.15s;
//   }
//   .sg2-comm-info-btn:hover { color: #4b5563; background: #f1f5f9; }
  
//   .sg2-comm-info-popover {
//     position: absolute; top: 100%; right: 0; margin-top: 6px; background: #fff;
//     border: 1px solid #e5e9f0; border-radius: 8px; padding: 12px 14px;
//     width: 170px; box-shadow: 0 10px 25px rgba(0,0,0,0.1); z-index: 50;
//   }
//   .sg2-comm-info-row { font-size: 11px; font-weight: 600; color: #4b5563; margin-bottom: 8px; display: flex; align-items: center; gap: 8px; }
//   .sg2-comm-info-row:last-child { margin-bottom: 0; }
  
//   .sg2-red-dotted-box {
//     border: 1.5px dotted #dc2626; color: #dc2626; font-weight: 700; font-size: 10px;
//     width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;
//     border-radius: 4px; flex-shrink: 0;
//   }

//   /* Communication hub */
//   .sg2-comm-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
//   .sg2-comm-btn {
//     position: relative;
//     display: flex; flex-direction: column; align-items: center; justify-content: center;
//     gap: 6px; padding: 14px 8px; border-radius: 12px;
//     border: 1.5px solid color-mix(in srgb, var(--comm-color) 30%, transparent);
//     background: color-mix(in srgb, var(--comm-color) 8%, #fff);
//     cursor: pointer; transition: background .15s, transform .1s; font-family: inherit;
//   }
//   .sg2-comm-btn:hover { background: color-mix(in srgb, var(--comm-color) 16%, #fff); transform: translateY(-1px); }
//   .sg2-comm-icon { font-size: 22px; display: flex; align-items: center; justify-content: center; }
//   .sg2-comm-label { font-size: 12px; font-weight: 600; color: #374151; }

//   .sg2-comm-shortcut {
//     position: absolute;
//     top: 4px;
//     left: 4px;
//     width: 18px;
//     height: 18px;
//     border: 1.5px dotted #dc2626;
//     border-radius: 50%;
//     font-size: 10px;
//     font-weight: 700;
//     color: #dc2626;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: rgba(255,255,255,0.7);
//   }

//   /* Management action buttons */
//   .sg2-actions-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
//   .sg2-action-btn {
//     position: relative;
//     display: flex; flex-direction: column; align-items: center; gap: 5px;
//     padding: 12px 8px; border-radius: 10px; border: 1px solid #e5e9f0;
//     background: #f8fafc; cursor: pointer; font-family: inherit;
//     transition: background .12s, border-color .12s, transform .1s;
//   }
//   .sg2-action-btn:hover:not(:disabled) { background: #eef2f9; border-color: #c7d2e8; transform: translateY(-1px); }
//   .sg2-action-btn:disabled { opacity: 0.4; cursor: not-allowed; }
//   .sg2-action-btn--success { border-color: #bbf7d0; background: #f0fdf4; }
//   .sg2-action-btn--success:hover:not(:disabled) { background: #dcfce7; }
//   .sg2-action-btn--danger { border-color: #fecaca; background: #fff5f5; }
//   .sg2-action-btn--danger:hover:not(:disabled) { background: #fee2e2; }
//   .sg2-action-icon { font-size: 18px; }
//   .sg2-action-label { font-size: 11px; font-weight: 600; color: #374151; text-align: center; }

//   /* Tags */
//   .sg2-tags { display: flex; flex-wrap: wrap; gap: 6px; }
//   .sg2-tag { background: #f3e8ff; color: #673AB7; font-size: 12px; font-weight: 600; padding: 4px 10px; border-radius: 20px; }

//   /* Lead queue carousel */
//   .sg2-queue-wrap {
//     display: flex; align-items: center; gap: 10px;
//     background: #fff; border: 1px solid #e5e9f0; border-radius: 14px;
//     padding: 10px 14px; flex-shrink: 0; box-shadow: 0 1px 3px rgba(0,0,0,.04);
//   }
//   .sg2-queue-track {
//     display: grid; 
//     grid-template-columns: repeat(14, minmax(0, 1fr)); 
//     gap: 8px; 
//     flex: 1; 
//     overflow: hidden; 
//     padding: 2px 0;
//   }
//   .sg2-queue-card {
//     display: flex; flex-direction: column; align-items: center; gap: 3px;
//     padding: 8px 14px; border-radius: 10px; border: 1.5px solid #e5e9f0;
//     background: #f8fafc; cursor: pointer; font-family: inherit;
//     width: 100%; min-width: 0; flex-shrink: 0; transition: all .15s;
//   }
//   .sg2-queue-card:hover { background: #eef2f9; border-color: #c7d2e8; }
//   .sg2-queue-card--active { background: #0C4550; border-color: #0C4550; box-shadow: 0 3px 10px rgba(12,69,80,.2); }
//   .sg2-queue-num { font-size: 10px; color: #9ca3af; font-weight: 600; }
//   .sg2-queue-card--active .sg2-queue-num { color: rgba(255,255,255,0.6); }
//   .sg2-queue-name { font-size: 13px; font-weight: 600; color: #1a1f36; white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }
//   .sg2-queue-card--active .sg2-queue-name { color: #fff; }
//   .sg2-queue-status { font-size: 10px; color: #6b7280; white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }
//   .sg2-queue-card--active .sg2-queue-status { color: rgba(255,255,255,0.7); }
//   .sg2-queue-nav {
//     background: none; border: 1px solid #e5e9f0; border-radius: 8px;
//     width: 34px; height: 34px; display: flex; align-items: center; justify-content: center;
//     font-size: 16px; cursor: pointer; color: #4b5563;
//     transition: background .1s; flex-shrink: 0;
//   }
//   .sg2-queue-nav:hover:not(:disabled) { background: #f1f5f9; }
//   .sg2-queue-nav:disabled { opacity: 0.3; cursor: not-allowed; }

//   /* Inline sub-modals */
//   .sg2-inline-overlay {
//     position: fixed; inset: 0; z-index: 9999;
//     background: rgba(0,0,0,.4);
//     display: flex; align-items: center; justify-content: center;
//     backdrop-filter: blur(2px);
//   }
//   .sg2-inline-modal {
//     background: #fff; border-radius: 16px; width: 100%; max-width: 420px;
//     box-shadow: 0 20px 60px rgba(0,0,0,.18); overflow: hidden; margin: 0 16px;
//     max-height: 90vh; overflow-y: auto;
//   }
//   .sg2-sms-modal-container {
//     max-width: 750px;
//   }
//   .sg2-inline-header {
//     padding: 16px 20px; border-bottom: 1px solid #f1f5f9;
//     display: flex; align-items: center; justify-content: space-between;
//     font-size: 15px; font-weight: 700; color: #0C4550;
//     position: sticky; top: 0; background: inherit; z-index: 1;
//   }
//   .sg2-inline-body { padding: 16px 20px; display: flex; flex-direction: column; gap: 2px; }
//   .sg2-inline-label { font-size: 12px; font-weight: 600; color: #4b5563; display: block; margin-bottom: 4px; }
//   .sg2-inline-select {
//     width: 100%; background: #f8fafc; border: 1px solid #e5e9f0; border-radius: 8px;
//     padding: 8px 12px; font-size: 13px; color: #1a1f36; font-family: inherit;
//     outline: none; transition: border-color .15s; box-sizing: border-box;
//   }
//   .sg2-inline-select:focus { border-color: #0C4550; background: #fff; }
//   .sg2-inline-textarea {
//     width: 100%; background: #f8fafc; border: 1px solid #e5e9f0; border-radius: 8px;
//     padding: 8px 12px; font-size: 13px; color: #1a1f36; font-family: inherit;
//     resize: vertical; outline: none; transition: border-color .15s; box-sizing: border-box;
//   }
//   .sg2-inline-textarea:focus { border-color: #0C4550; background: #fff; }
//   .sg2-inline-footer {
//     padding: 12px 20px; border-top: 1px solid #f1f5f9;
//     display: flex; gap: 8px; justify-content: flex-end;
//     position: sticky; bottom: 0; background: #fff;
//   }
//   .sg2-ghost-btn {
//     background: #f8fafc; color: #4b5563; border: 1px solid #e5e9f0;
//     border-radius: 8px; padding: 8px 16px; font-size: 13px; font-weight: 600;
//     cursor: pointer; font-family: inherit; transition: background .1s;
//   }
//   .sg2-ghost-btn:hover { background: #f1f5f9; }
//   .sg2-primary-btn {
//     background: #0C4550; color: #fff; border: none; border-radius: 8px;
//     padding: 8px 20px; font-size: 13px; font-weight: 600;
//     cursor: pointer; font-family: inherit; transition: opacity .15s;
//   }
//   .sg2-primary-btn:hover:not(:disabled) { opacity: 0.88; }
//   .sg2-primary-btn:disabled { opacity: 0.4; cursor: not-allowed; }

//   /* Inline Editing Styles - Updated with sleek highlights */
//   .sg2-editable-text { cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: color 0.15s; border-bottom: 1px dashed transparent; }
//   .sg2-editable-text:hover { color: #0C4550; border-bottom-color: #0C4550; }
//   .sg2-editable-empty { color: #9ca3af; font-style: italic; }
//   .sg2-edit-icon { font-size: 11px; opacity: 0; color: #0C4550; transition: opacity 0.2s; }
//   .sg2-editable-text:hover .sg2-edit-icon { opacity: 1; }
  
//   .sg2-inline-edit-input { 
//     background: #fff; 
//     border: 1px solid #0C4550; 
//     border-radius: 6px; 
//     padding: 4px 8px; 
//     font-family: inherit; 
//     font-size: inherit; 
//     color: #111827; 
//     width: 100%; 
//     box-shadow: 0 0 0 3px rgba(12,69,80,0.15); 
//     outline: none; 
//     transition: all 0.2s ease;
//   }
//   .sg2-inline-edit-input:focus {
//     border-color: #0C4550;
//     box-shadow: 0 0 0 4px rgba(12, 69, 80, 0.25);
//   }

//   /* Custom Instant Dropdown CSS */
//   .sg2-custom-dropdown-list {
//     position: absolute;
//     top: calc(100% + 4px);
//     left: 0;
//     min-width: 100%;
//     background: #fff;
//     border: 1px solid #e5e9f0;
//     border-radius: 8px;
//     box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//     z-index: 9999;
//     max-height: 220px;
//     overflow-y: auto;
//     padding: 4px 0;
//   }
//   .sg2-custom-dropdown-item {
//     padding: 8px 12px;
//     font-size: 13px;
//     color: #111827;
//     cursor: pointer;
//     transition: background 0.15s;
//     white-space: nowrap;
//   }
//   .sg2-custom-dropdown-item:hover {
//     background: #f1f5f9;
//   }

//   /* Lead info box (left panel) only: black professional edit state */
//   .sg2-detail-panel .sg2-inline-edit-input {
//     background: #111111;
//     border: 1px solid #111111;
//     color: #ffffff;
//     box-shadow: 0 0 0 3px rgba(0,0,0,0.18);
//   }
//   .sg2-detail-panel .sg2-inline-edit-input:focus {
//     border-color: #000000;
//     box-shadow: 0 0 0 4px rgba(0,0,0,0.28);
//   }
//   .sg2-detail-panel .sg2-inline-edit-input::placeholder {
//     color: #bbbbbb;
//   }
//   /* Dark mode support for instant dropdown */
//   .sg2-detail-panel .sg2-custom-dropdown-list {
//     background: #111111;
//     border-color: #000;
//   }
//   .sg2-detail-panel .sg2-custom-dropdown-item {
//     color: #fff;
//   }
//   .sg2-detail-panel .sg2-custom-dropdown-item:hover {
//     background: #222;
//   }
//   /* Keep native dropdown options readable on black background (for backwards compatibility if any native selects remain) */
//   .sg2-detail-panel select.sg2-inline-edit-input option {
//     background: #111111;
//     color: #ffffff;
//   }
  
//   .sg2-header-inline { font-size: 13px; font-weight: 600; color: #111827; }
//   .sg2-editable-text.sg2-lead-name { font-size: 22px; font-weight: 700; color: #1a1f36; line-height: 1.2; display: inline-flex; }

//   /* SMS Glassmorphism Grid and Pagination */
//   .sg2-sms-grid {
//     display: grid;
//     grid-template-columns: repeat(4, 1fr);
//     grid-template-rows: auto;
//     gap: 12px;
//     padding: 8px 0;
//   }
//   .sg2-sms-glass-card {
//     aspect-ratio: 1;
//     background: rgba(255, 255, 255, 0.35);
//     backdrop-filter: blur(10px);
//     -webkit-backdrop-filter: blur(10px);
//     border: 1px solid rgba(255, 255, 255, 0.5);
//     border-radius: 12px;
//     padding: 12px;
//     display: flex;
//     flex-direction: column;
//     cursor: pointer;
//     transition: all 0.2s;
//     text-align: left;
//     overflow: hidden;
//     box-shadow: 0 4px 15px rgba(0,0,0,0.05);
//     font-family: inherit;
//   }
//   .sg2-sms-glass-card:hover {
//     transform: translateY(-3px);
//     background: rgba(255, 255, 255, 0.5);
//     box-shadow: 0 6px 20px rgba(0,0,0,0.1);
//   }
//   .sg2-sms-card-title {
//     font-size: 13px;
//     font-weight: 700;
//     color: #0C4550;
//     margin-bottom: 6px;
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//   }
//   .sg2-sms-card-preview {
//     font-size: 11px;
//     color: #4b5563;
//     line-height: 1.4;
//     display: -webkit-box;
//     -webkit-line-clamp: 4;
//     -webkit-box-orient: vertical;
//     overflow: hidden;
//   }

//   .sg2-pagination {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin-top: 16px;
//     padding: 4px 8px;
//     font-size: 13px;
//     font-weight: 600;
//     color: #0C4550;
//   }
//   .sg2-pagination button {
//     background: #0C4550;
//     color: #fff;
//     border: none;
//     padding: 6px 16px;
//     border-radius: 8px;
//     cursor: pointer;
//     font-family: inherit;
//     font-size: 12px;
//     font-weight: 600;
//     transition: opacity 0.2s;
//   }
//   .sg2-pagination button:disabled {
//     opacity: 0.4;
//     cursor: not-allowed;
//   }

//   /* Appointment modal pagination — Prev/Next kept close to the "Page X of Y" text */
//   .sg2-apt-pagination {
//     justify-content: center;
//     gap: 16px;
//     background: #f8fafc;
//     border: 1px solid #e5e9f0;
//     border-radius: 10px;
//     padding: 8px 14px;
//   }
//   .sg2-apt-pagination-btns {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//   }
//   .sg2-apt-pagination-btns button {
//     padding: 5px 12px;
//     font-size: 11.5px;
//   }

//   /* Email/SMS Card Loader Overlay */
//   .sg2-card-loader-overlay {
//     position: absolute;
//     inset: 0;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: rgba(255, 255, 255, 0.4);
//     backdrop-filter: blur(2px);
//     -webkit-backdrop-filter: blur(2px);
//     border-radius: 12px;
//     z-index: 10;
//   }

//   /* ── Chat History Modal ─────────────────────────────────────────── */
//   .sg2-history-modal-container {
//     max-width: 560px;
//   }
//   .sg2-history-lead-strip {
//     display: flex; align-items: center; gap: 12px;
//     padding: 14px 20px; border-bottom: 1px solid #f1f5f9;
//     background: #f8fafc;
//   }
//   .sg2-history-lead-meta { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
//   .sg2-history-lead-name { font-size: 14px; font-weight: 700; color: #1a1f36; }
//   .sg2-history-lead-sub {
//     display: flex; flex-wrap: wrap; gap: 10px;
//     font-size: 12px; color: #6b7280; font-weight: 500;
//   }
//   .sg2-history-body-wrap {
//     max-height: 60vh; overflow-y: auto; gap: 12px;
//   }
//   .sg2-history-empty {
//     text-align: center; color: #9ca3af; font-size: 13px; padding: 24px 0; margin: 0;
//   }
//   .sg2-history-card {
//     background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px;
//     padding: 14px 16px; margin-bottom: 10px;
//   }
//   .sg2-history-card-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; margin-bottom: 10px; }
//   .sg2-history-avatar {
//     width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
//     background: #e0e8f5; color: #0C4550; font-weight: 700; font-size: 13px;
//     display: flex; align-items: center; justify-content: center;
//   }
//   .sg2-history-changer { font-size: 13px; font-weight: 700; color: #1a1f36; }
//   .sg2-history-time { font-size: 11px; color: #9ca3af; font-weight: 500; }
//   .sg2-history-card-body { border-left: 2px solid #673AB7; padding-left: 12px; margin-left: 3px; }
//   .sg2-history-row { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
//   .sg2-history-row:last-child { margin-bottom: 0; }
//   .sg2-history-dot { width: 6px; height: 6px; border-radius: 50%; background: #673AB7; flex-shrink: 0; }
//   .sg2-history-dot--green { background: #16a34a; }
//   .sg2-history-created-text { font-size: 12.5px; color: #374151; font-weight: 500; }
//   .sg2-history-change { margin-bottom: 10px; }
//   .sg2-history-change:last-child { margin-bottom: 0; }
//   .sg2-history-change-field {
//     font-size: 11px; font-weight: 700; color: #4b5563; text-transform: uppercase;
//     letter-spacing: .03em; margin-bottom: 4px;
//   }
//   .sg2-history-change-values { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
//   .sg2-history-from {
//     font-size: 11.5px; padding: 2px 8px; border-radius: 6px;
//     background: #fef2f2; color: #dc2626; font-weight: 600;
//   }
//   .sg2-history-to {
//     font-size: 11.5px; padding: 2px 8px; border-radius: 6px;
//     background: #f0fdf4; color: #16a34a; font-weight: 600;
//   }
//   .sg2-history-arrow { color: #9ca3af; font-size: 12px; }

//   /* ── Appointment wizard modal ───────────────────────────────────── */
//   .sg2-apt-modal-container { max-width: 640px; }
//   .sg2-apt-steps {
//     display: flex; align-items: center; gap: 8px;
//     padding: 12px 20px 0; font-size: 12px; font-weight: 600; color: #9ca3af;
//   }
//   .sg2-apt-step { padding: 4px 10px; border-radius: 20px; background: #f1f5f9; }
//   .sg2-apt-step--active { background: #0C4550; color: #fff; }
//   .sg2-apt-step-sep { color: #cbd5e1; }
//   .sg2-apt-grid {
//     display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;
//     padding: 6px 0 8px;
//   }
//   .sg2-apt-card {
//     position: relative; text-align: left; cursor: pointer; font-family: inherit;
//     background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 12px;
//     padding: 14px 14px 12px; transition: all .15s;
//   }
//   .sg2-apt-card:hover { background: #f1f5f9; border-color: #c7d2e8; transform: translateY(-1px); }
//   .sg2-apt-card--selected { background: #e8f4f7; border-color: #0C4550; box-shadow: 0 0 0 2px rgba(12,69,80,.12); }
//   .sg2-apt-card-title { font-size: 13px; font-weight: 700; color: #1a1f36; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
//   .sg2-apt-card-sub { font-size: 11.5px; color: #6b7280; margin-top: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
//   .sg2-apt-check {
//     position: absolute; top: 8px; right: 8px; width: 18px; height: 18px; border-radius: 50%;
//     background: #0C4550; color: #fff; font-size: 11px; font-weight: 700;
//     display: flex; align-items: center; justify-content: center;
//   }
//   .sg2-apt-summary {
//     background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px;
//     padding: 10px 14px; font-size: 12.5px; color: #374151;
//     display: flex; flex-direction: column; gap: 4px;
//   }
//   .sg2-apt-summary-label { font-weight: 700; color: #0C4550; margin-right: 4px; }
//   @media (max-width: 640px) {
//     .sg2-apt-grid { grid-template-columns: repeat(2, 1fr); }
//   }

//   /* ── Appointment search bar + "See All Departments" ──────────────── */
//   .sg2-apt-search-wrap {
//     position: relative;
//     display: flex;
//     align-items: center;
//   }
//   .sg2-apt-search-icon {
//     position: absolute;
//     left: 10px;
//     pointer-events: none;
//   }
//   .sg2-apt-search-input {
//     width: 260px !important;
//     padding: 7px 12px 7px 32px !important;
//     font-size: 12.5px !important;
//     margin: 0 !important;
//     min-height: auto !important;
//     border-radius: 20px !important;
//   }
//   @media (max-width: 640px) {
//     .sg2-apt-search-input { width: 160px !important; }
//   }
//   .sg2-apt-alldept-btn {
//     white-space: nowrap;
//     background: #f3e8ff;
//     border: 1px solid #e4d3fb;
//     color: #673AB7;
//     font-size: 12px;
//     font-weight: 700;
//     padding: 7px 14px;
//     border-radius: 20px;
//     cursor: pointer;
//     font-family: inherit;
//     transition: all .15s;
//   }
//   .sg2-apt-alldept-btn:hover { background: #ecdcff; border-color: #d9bffb; }
//   .sg2-apt-alldept-btn--active { background: #0C4550; border-color: #0C4550; color: #fff; }

//   /* ── "See All Departments" combined browsable list ────────────────── */
//   .sg2-apt-alldept-list {
//     display: flex;
//     flex-direction: column;
//     gap: 14px;
//     padding: 4px 0 8px;
//   }
//   .sg2-apt-alldept-group {
//     background: #f8fafc;
//     border: 1px solid #e2e8f0;
//     border-radius: 12px;
//     padding: 12px 14px;
//   }
//   .sg2-apt-alldept-dept-name {
//     display: block;
//     width: 100%;
//     text-align: left;
//     background: none;
//     border: none;
//     cursor: pointer;
//     font-family: inherit;
//     font-size: 13px;
//     font-weight: 700;
//     color: #0C4550;
//     margin-bottom: 8px;
//     padding: 0 0 6px;
//     border-bottom: 1px solid #e5e9f0;
//   }
//   .sg2-apt-alldept-dept-name--static {
//     cursor: default;
//   }
//   .sg2-apt-alldept-dept-loc {
//     font-size: 11.5px;
//     font-weight: 600;
//     color: #6b7280;
//   }
//   .sg2-apt-alldept-empty {
//     font-size: 12px;
//     color: #9ca3af;
//     margin: 0;
//     font-style: italic;
//   }
//   .sg2-apt-alldept-persons {
//     display: grid;
//     grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
//     gap: 8px;
//   }
//   .sg2-apt-alldept-person-btn {
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 2px;
//     text-align: left;
//     background: #fff;
//     border: 1.5px solid #e2e8f0;
//     border-radius: 10px;
//     padding: 8px 10px;
//     cursor: pointer;
//     font-family: inherit;
//     transition: all .15s;
//   }
//   .sg2-apt-alldept-person-btn:hover {
//     border-color: #c7d2e8;
//     background: #f1f5f9;
//     transform: translateY(-1px);
//   }
//   .sg2-apt-alldept-person-btn--selected {
//     background: #e8f4f7;
//     border-color: #0C4550;
//     box-shadow: 0 0 0 2px rgba(12,69,80,.12);
//   }
//   .sg2-apt-alldept-person-name {
//     font-size: 12.5px;
//     font-weight: 700;
//     color: #1a1f36;
//   }
//   .sg2-apt-alldept-person-pos {
//     font-size: 11px;
//     color: #6b7280;
//   }

//   /* ── Appointment history list ──────────────────────── */
//   .sg2-apt-new-btn {
//     display: inline-flex; align-items: center; gap: 6px;
//     background: #0C4550; color: #fff; border: none; border-radius: 8px;
//     padding: 9px 16px; font-size: 13px; font-weight: 600; cursor: pointer;
//     font-family: inherit; margin-bottom: 14px; transition: opacity .15s;
//   }
//   .sg2-apt-new-btn:hover { opacity: .9; }
//   .sg2-apt-hist-list { display: flex; flex-direction: column; gap: 10px; }
//   .sg2-apt-hist-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 14px 16px; }
//   .sg2-apt-hist-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
//   .sg2-apt-hist-dept { font-size: 13px; font-weight: 700; color: #1a1f36; }
//   .sg2-apt-hist-person { font-size: 12px; color: #6b7280; margin-top: 2px; }
//   .sg2-apt-hist-meta { display: flex; gap: 14px; font-size: 12px; color: #4b5563; margin-top: 8px; font-weight: 500; }
//   .sg2-apt-hist-notes { font-size: 12px; color: #374151; margin-top: 8px; background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 10px; }
//   .sg2-apt-status-badge {
//     font-size: 10.5px; font-weight: 700; padding: 3px 10px; border-radius: 20px;
//     text-transform: uppercase; letter-spacing: .03em; white-space: nowrap; flex-shrink: 0;
//     background: #e2e8f0; color: #475569;
//   }
//   .sg2-apt-status-badge--scheduled { background: #dbeafe; color: #1d4ed8; }
//   .sg2-apt-status-badge--completed { background: #dcfce7; color: #16a34a; }
//   .sg2-apt-status-badge--cancelled { background: #fee2e2; color: #dc2626; }
//   .sg2-apt-status-badge--rescheduled { background: #fef3c7; color: #b45309; }
//   .sg2-apt-status-badge--no_show { background: #f1f5f9; color: #64748b; }

//   /* Toggle Switch for Boolean Fields */
//   .sg2-toggle-switch {
//     position: relative;
//     display: inline-block;
//     width: 34px;
//     height: 18px;
//     flex-shrink: 0;
//   }
//   .sg2-toggle-switch input { opacity: 0; width: 0; height: 0; }
//   .sg2-toggle-slider {
//     position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;
//     background-color: #cbd5e1; transition: .3s; border-radius: 20px;
//   }
//   .sg2-toggle-slider:before {
//     position: absolute; content: ""; height: 12px; width: 12px; left: 3px; bottom: 3px;
//     background-color: white; transition: .3s; border-radius: 50%;
//     box-shadow: 0 1px 2px rgba(0,0,0,0.2);
//   }
//   .sg2-toggle-switch input:checked + .sg2-toggle-slider { background-color: #0C4550; }
//   .sg2-toggle-switch input:checked + .sg2-toggle-slider:before { transform: translateX(16px); }

// `;

// export default SalesGod;












import { useState, useEffect, useContext, useCallback, useMemo, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import { useIncomingMode } from "../context/IncomingModeContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../Constants";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ─── Role helpers ────────────────────────────────────────────────────────────
const ROLE = {
  COMPANY: "COMPANY",
  VICE_PRESIDENT: "VICE_PRESIDENT",
  MANAGER: "MANAGER",
  TEAM_LEAD: "TEAM_LEAD",
  EXECUTIVE: "EXECUTIVE",
  HR: "HR",
  SUPER_SUPER_ADMIN: "SUPER_SUPER_ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  RESELLER: "RESELLER",
};

const isOwnerLevel = (t) =>
  [ROLE.COMPANY, ROLE.SUPER_SUPER_ADMIN, ROLE.SUPER_ADMIN, ROLE.RESELLER].includes(t);

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// Returns true when the phone number is masked/hidden (contains mask characters
// like * or x/X instead of the full set of digits), i.e. only the last 3-4
// digits are visible. Used to lock inline editing for masked numbers.
const isPhoneMasked = (phone) => {
  if (!phone) return false;
  return /[*xX]/.test(phone);
};

// ─── WhatsApp SVG Icon ────────────────────────────────────────────────────────
const SGWhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.888-.788-1.487-1.761-1.663-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

// ──────────────────────────────────────────────────────────────────────────────
//  SALES GOD — Sub components
// ──────────────────────────────────────────────────────────────────────────────

const SGAvatar = ({ name = "", size = 52 }) => {
  const parts = name.trim().split(" ");
  const initials = parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : (parts[0]?.[0] ?? "?");
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: "#e8f4f7", color: "#0C4550",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontWeight: 700, fontSize: size * 0.35, flexShrink: 0,
      border: "2px solid #c6e4ec", letterSpacing: "0.04em",
    }}>
      {initials.toUpperCase()}
    </div>
  );
};

// ─── Inline Editable Field ───────────────────────────────────────────────────
const SGEditableField = ({ value, onSave, label, type = "text", className = "", options }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempVal, setTempVal] = useState(value || "");
  const dropdownRef = useRef(null);

  useEffect(() => { setTempVal(value || ""); }, [value]);

  // Click-outside listener for custom dropdowns
  useEffect(() => {
    if (!isEditing) return;
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsEditing(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isEditing]);

  const isToggle = type === "YES_NO" || type === "BOOLEAN" || type === "toggle";
  const isDropdown = options && options.length > 0;

  // Auto-scroll logic when dropdown opens near the bottom
  useEffect(() => {
    if (isEditing && isDropdown && dropdownRef.current) {
      setTimeout(() => {
        const listEl = dropdownRef.current.querySelector('.sg2-custom-dropdown-list');
        if (listEl) {
          listEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 100);
    }
  }, [isEditing, isDropdown]);

  // 1. BOOLEAN / TOGGLE FIELD
  if (isToggle) {
    const isYes = String(value).toLowerCase() === "yes" || value === true || String(value).toLowerCase() === "true";
    return (
      <div 
        style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", height: "100%" }} 
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (type === "BOOLEAN") {
            onSave(!isYes);
          } else {
            onSave(isYes ? "No" : "Yes");
          }
        }}
        title={`Click to switch to ${isYes ? "No" : "Yes"}`}
      >
        <label className="sg2-toggle-switch" style={{ pointerEvents: "none", margin: 0 }}>
          <input type="checkbox" checked={isYes} readOnly />
          <span className="sg2-toggle-slider"></span>
        </label>
        <span style={{ marginLeft: "8px", fontSize: "13px", fontWeight: "600", color: isYes ? "#0C4550" : "#9ca3af", transition: "color 0.2s" }}>
          {isYes ? "Yes" : "No"}
        </span>
      </div>
    );
  }

  const handleBlurOrSubmit = () => {
    const raw = tempVal || "";
    const trimmed = raw.trim();

    if (raw.length > 0 && trimmed === "") {
      toast.error(`${label} cannot contain only spaces.`);
      setIsEditing(false);
      setTempVal(value || "");
      return;
    }

    setIsEditing(false);
    setTempVal(trimmed);
    if (trimmed !== (value || "")) {
      onSave(trimmed);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleBlurOrSubmit();
    if (e.key === "Escape") { setIsEditing(false); setTempVal(value || ""); }
  };

  // 2. DROPDOWN FIELD
  if (isDropdown) {
    return (
      <div style={{ position: "relative", display: "inline-block", width: "100%" }} ref={dropdownRef}>
        <span
          className={`sg2-editable-text ${className} ${!value ? "sg2-editable-empty" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsEditing(!isEditing);
          }}
          title={`Click to ${isEditing ? "close" : "select"} ${label}`}
        >
          {value || `Select ${label}`}
          <span style={{ 
            fontSize: "10px", 
            marginLeft: "5px", 
            color: "#0C4550", 
            display: "inline-block",
            transform: isEditing ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s"
          }}>▼</span>
        </span>

        <AnimatePresence>
          {isEditing && (
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.15 }}
              className="sg2-custom-dropdown-list"
            >
              <div 
                className="sg2-custom-dropdown-item" 
                onClick={(e) => { e.stopPropagation(); setTempVal(""); onSave(""); setIsEditing(false); }}
              >
                — Select {label} —
              </div>
              {options.map((opt, i) => {
                const optVal = opt.name || opt.value || opt;
                return (
                  <div
                    key={i}
                    className="sg2-custom-dropdown-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTempVal(optVal);
                      if (optVal !== (value || "")) onSave(optVal);
                      setIsEditing(false);
                    }}
                  >
                    {optVal}
                  </div>
                );
              })}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  }

  // 3. TEXT FIELD (EDITING STATE)
  if (isEditing) {
    return (
      <input
        autoFocus
        type={type}
        className={`sg2-inline-edit-input ${className}`}
        value={tempVal}
        onChange={(e) => setTempVal(e.target.value)}
        onBlur={handleBlurOrSubmit}
        onKeyDown={handleKeyDown}
      />
    );
  }

  // 4. TEXT FIELD (VIEW STATE)
  return (
    <span
      className={`sg2-editable-text ${className} ${!value ? "sg2-editable-empty" : ""}`}
      onClick={() => setIsEditing(true)}
      title={`Click to edit ${label}`}
    >
      {value || `Add ${label}`}
      <span className="sg2-edit-icon">✎</span>
    </span>
  );
};

// ─── Updated SGInfoRow (with Edit support) ───────────────────────────────────
const SGInfoRow = ({ icon, label, value, href, field, onSave, type = "text", options }) => {
  return (
    <div className="sg2-info-row">
      <span className="sg2-info-icon">{icon}</span>
      <div className="sg2-info-content">
        <span className="sg2-info-label">{label}</span>
        {field && onSave ? (
          <SGEditableField value={value} onSave={(v) => onSave(field, v)} label={label} type={type} className="sg2-info-value" options={options} />
        ) : href && value ? (
          <a href={href} className="sg2-info-value sg2-link">{value}</a>
        ) : (
          <span className="sg2-info-value" title={value}>{value || "—"}</span>
        )}
      </div>
    </div>
  );
};

const SGCommentRow = ({ value, onClick }) => {
  return (
    <div
      className="sg2-info-row sg2-info-row--comment"
      onClick={onClick}
      title="Click to edit comment"
    >
      <span className="sg2-info-icon">💬</span>
      <div className="sg2-info-content">
        <span className="sg2-info-label">Comment</span>
        <span className={`sg2-info-value sg2-comment-value ${!value ? "sg2-editable-empty" : ""}`}>
          {value || "Add Comment"}
        </span>
      </div>
    </div>
  );
};

const SGCommBtn = ({ icon, label, shortcut, onClick, color }) => (
  <button className="sg2-comm-btn" style={{ "--comm-color": color }} onClick={onClick} title={label}>
    {shortcut && <span className="sg2-comm-shortcut">{shortcut}</span>}
    <span className="sg2-comm-icon">{icon}</span>
    <span className="sg2-comm-label">{label}</span>
  </button>
);

const SGActionBtn = ({ icon, label, onClick, variant = "default", disabled, shortcut }) => (
  <button className={`sg2-action-btn sg2-action-btn--${variant}`} onClick={onClick} disabled={disabled} title={label}>
    {shortcut && <span className="sg2-comm-shortcut">{shortcut}</span>}
    <span className="sg2-action-icon">{icon}</span>
    <span className="sg2-action-label">{label}</span>
  </button>
);

const SGQueueCard = ({ lead, isActive, index, onClick }) => (
  <button className={`sg2-queue-card ${isActive ? "sg2-queue-card--active" : ""}`} onClick={onClick}>
    <div className="sg2-queue-num">#{index + 1}</div>
    <div className="sg2-queue-name">{(lead.name || "Unknown").split(" ")[0]}</div>
    <div className="sg2-queue-status">{lead.statusName || "—"}</div>
  </button>
);

// ── Inline modals (not fixed-position) ───────────────────────────────────────
const SGStatusModal = ({ open, statuses, currentStatus, onConfirm, onClose }) => {
  const [selected, setSelected] = useState(currentStatus || "");
  const [reason, setReason] = useState("");
  useEffect(() => { setSelected(currentStatus || ""); setReason(""); }, [currentStatus, open]);
  if (!open) return null;
  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal">
        <div className="sg2-inline-header"><span>Change status</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
        <div className="sg2-inline-body">
          <label className="sg2-inline-label">New status</label>
          <select className="sg2-inline-select" value={selected} onChange={(e) => setSelected(e.target.value)}>
            <option value="">— select —</option>
            {statuses.filter((s) => s.active !== false).map((s) => <option key={s.name} value={s.name}>{s.name}</option>)}
          </select>
          <label className="sg2-inline-label" style={{ marginTop: 12 }}>Reason</label>
          <textarea className="sg2-inline-textarea" rows={3} placeholder="Enter reason…" value={reason} onChange={(e) => setReason(e.target.value)} />
        </div>
        <div className="sg2-inline-footer">
          <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
          <button className="sg2-primary-btn" disabled={!selected || !reason.trim()} onClick={() => onConfirm(selected, reason)}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

const SGFollowUpModal = ({ open, users, onClose, onSubmit, loggedInUser }) => {
  const [notes, setNotes] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [followedById, setFollowedById] = useState("");

  const isExecutive = loggedInUser?.accountType === ROLE.EXECUTIVE;
  const selfUser = users.find((u) => u.id === loggedInUser?.id);

  useEffect(() => {
    if (open) {
      setFollowedById(isExecutive ? (loggedInUser?.id || "") : "");
    }
  }, [open, isExecutive, loggedInUser]);

  if (!open) return null;
  const handleSubmit = () => {
    onSubmit({ notes, nextFollowUpDate: date, nextFollowUpTime: time, followedById });
    setNotes(""); setDate(""); setTime("");
    setFollowedById(isExecutive ? (loggedInUser?.id || "") : "");
  };
  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal">
        <div className="sg2-inline-header"><span>Add follow-up</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
        <div className="sg2-inline-body">
          <label className="sg2-inline-label">Notes</label>
          <textarea className="sg2-inline-textarea" rows={3} placeholder="Enter notes…" value={notes} onChange={(e) => setNotes(e.target.value)} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 10 }}>
            <div>
              <label className="sg2-inline-label">Follow-up date</label>
              <input className="sg2-inline-select" type="date" value={date} min={new Date().toISOString().split("T")[0]} onChange={(e) => setDate(e.target.value)} />
            </div>
            <div>
              <label className="sg2-inline-label">Time</label>
              <input className="sg2-inline-select" type="time" value={time} onChange={(e) => setTime(e.target.value)} />
            </div>
          </div>
          <label className="sg2-inline-label" style={{ marginTop: 10 }}>Followed by</label>
          <select className="sg2-inline-select" value={followedById} onChange={(e) => setFollowedById(e.target.value)} disabled={isExecutive}>
            {isExecutive ? (
              <option value={loggedInUser?.id || ""}>
                {selfUser ? `${selfUser.fname} ${selfUser.lname}` : "Me"}
              </option>
            ) : (
              <>
                <option value="">— select user —</option>
                {users.map((u) => <option key={u.id} value={u.id}>{u.fname} {u.lname}</option>)}
              </>
            )}
          </select>
        </div>
        <div className="sg2-inline-footer">
          <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
          <button className="sg2-primary-btn" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
};

const SGLabelModal = ({ open, labels, onClose, onConfirm }) => {
  const [labelId, setLabelId] = useState("");
  if (!open) return null;
  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal">
        <div className="sg2-inline-header"><span>Assign project</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
        <div className="sg2-inline-body">
          <label className="sg2-inline-label">Project name</label>
          <select className="sg2-inline-select" value={labelId} onChange={(e) => setLabelId(e.target.value)}>
            <option value="">— select project —</option>
            {labels.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
          </select>
        </div>
        <div className="sg2-inline-footer">
          <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
          <button className="sg2-primary-btn" disabled={!labelId} onClick={() => onConfirm(labelId)}>Assign</button>
        </div>
      </div>
    </div>
  );
};

// ─── Appointment wizard modal (with inline editing for history & SEARCH) ─────────────
const SG_APT_PAGE_SIZE = 6;
const SG_APT_STATUS_OPTIONS = ["SCHEDULED", "COMPLETED", "CANCELLED", "RESCHEDULED", "NO_SHOW"];

const SGAppointmentModal = ({ open, lead, companyId, stableUser, users, onClose, onScheduled }) => {
  const [phase, setPhase] = useState("loading");
  const [appointments, setAppointments] = useState([]);

  const [step, setStep] = useState(1);
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [deptPage, setDeptPage] = useState(0);
  const [selectedDept, setSelectedDept] = useState(null);

  const [persons, setPersons] = useState([]);
  const [allPersons, setAllPersons] = useState([]); 
  const [loadingPersons, setLoadingPersons] = useState(false);
  const [personPage, setPersonPage] = useState(0);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const [preferredDate, setPreferredDate] = useState("");
  const [preferredTime, setPreferredTime] = useState("");
  const [notes, setNotes] = useState("");
  const [status, setStatus] = useState("SCHEDULED");
  const [submitting, setSubmitting] = useState(false);

  // NEW: Search State
  const [searchTerm, setSearchTerm] = useState("");

  // NEW: "See All Departments/Persons" toggle
  const [showAllDeptsDropdown, setShowAllDeptsDropdown] = useState(false);

  useEffect(() => {
    if (!open || !lead?.leadId) return;
    setPhase("loading");
    setAppointments([]);
    setStep(1);
    setSelectedDept(null);
    setSelectedPerson(null);
    setDeptPage(0);
    setPersonPage(0);
    setPreferredDate("");
    setPreferredTime("");
    setNotes("");
    setStatus("SCHEDULED");
    setPersons([]);
    setSearchTerm(""); // Reset search on open
    setShowAllDeptsDropdown(false);

    const loadAppointments = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/appointments/lead/${lead.leadId}`, {
          headers: authHeader(),
        });
        const list = Array.isArray(res.data) ? res.data : [];
        setAppointments(list);
        setPhase(list.length > 0 ? "history" : "wizard");
      } catch (err) {
        console.error("Failed to fetch appointment history", err);
        toast.error("Failed to load appointment history.");
        setAppointments([]);
        setPhase("wizard");
      }
    };
    loadAppointments();
  }, [open, lead?.leadId]);

  // Reset pagination when search term changes
  useEffect(() => {
    setDeptPage(0);
    setPersonPage(0);
  }, [searchTerm]);

  useEffect(() => {
    if (!open) return;
    const loadDepartments = async () => {
      setLoadingDepartments(true);
      try {
        const res = await axios.get(`${API_URL}/api/appointments/departments/company/${companyId}`, {
          headers: authHeader(),
          params: { activeOnly: true },
        });
        setDepartments(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch departments", err);
        toast.error("Failed to load departments.");
        setDepartments([]);
      } finally {
        setLoadingDepartments(false);
      }
    };

    const loadPersons = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/appointments/persons/company/${companyId}`, {
          headers: authHeader(),
          params: { activeOnly: true },
        });
        setAllPersons(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch persons", err);
        setAllPersons([]);
      }
    };

    loadDepartments();
    loadPersons();
  }, [open, companyId]);

  useEffect(() => {
    if (!open || phase !== "wizard" || step !== 2 || !selectedDept) return;
    const deptId = selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id;

    const loadPersons = async () => {
      setLoadingPersons(true);
      setPersonPage(0);
      try {
        const res = await axios.get(`${API_URL}/api/appointments/persons/company/${companyId}`, {
          headers: authHeader(),
          params: { activeOnly: true, departmentId: deptId },
        });
        setPersons(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch persons", err);
        toast.error("Failed to load persons.");
        setPersons([]);
      } finally {
        setLoadingPersons(false);
      }
    };
    loadPersons();
  }, [open, phase, step, selectedDept, companyId]);

  const handleInlineAptUpdate = async (apt, field, value) => {
    if (!value) return;

    if (field === 'preferredTime' && apt.preferredTime) {
      const newTime = value.length === 5 ? `${value}:00` : value;
      if (apt.preferredTime === newTime) return;
    } else if (apt[field] === value) {
      return;
    }

    let payload = { ...apt, companyId, leadId: lead.leadId, leadName: lead.name, leadPhone: lead.phone, leadEmail: lead.email };

    const creator = users.find((u) => String(u.id) === String(stableUser.id));
    const creatorName = creator ? `${creator.fname} ${creator.lname}` : "";
    payload.lastUpdatedById = stableUser.id;
    payload.lastUpdatedByName = creatorName;

    let successMessage = "Appointment updated";

    if (field === 'departmentName') {
      const dept = departments.find(d => d.name === value);
      if (dept) {
        payload.departmentId = dept.departmentId ?? dept.id ?? dept._id;
        payload.departmentName = dept.name;
        payload.departmentLocation = dept.location;
        successMessage = "Department updated successfully";
      }
    } else if (field === 'personName') {
      const person = allPersons.find(p => p.name === value);
      if (person) {
        payload.personId = person.personId ?? person.id ?? person._id;
        payload.personName = person.name;
        payload.personPosition = person.position;
        successMessage = "Person updated successfully";
      } else {
        payload.personName = value;
        successMessage = "Person updated successfully";
      }
    } else if (field === 'preferredDate') {
      payload.preferredDate = value;
      successMessage = "Date updated successfully";
    } else if (field === 'preferredTime') {
      payload.preferredTime = value.length === 5 ? `${value}:00` : value;
      successMessage = "Time updated successfully";
    } else if (field === 'status') {
      payload.status = value;
      successMessage = "Status updated successfully";
    } else if (field === 'notes') {
      payload.notes = value;
      successMessage = "Notes updated successfully";
    }

    try {
      const res = await axios.put(`${API_URL}/api/appointments/${apt.appointmentId}`, payload, { headers: authHeader() });
      toast.success(successMessage);
      setAppointments(prev => prev.map(a => a.appointmentId === apt.appointmentId ? { ...a, ...payload } : a));
      onScheduled?.();
    } catch (err) {
      console.error("Failed to update appointment inline", err);
      toast.error(err.response?.data?.message || "Failed to update appointment.");
    }
  };

  if (!open) return null;

  // NEW: Search Filter Logic for Departments
  const filteredDepartments = departments.filter(d => 
    (d.name || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
    (d.location || "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  const deptTotalPages = Math.max(1, Math.ceil(filteredDepartments.length / SG_APT_PAGE_SIZE));
  const pagedDepartments = filteredDepartments.slice(deptPage * SG_APT_PAGE_SIZE, (deptPage + 1) * SG_APT_PAGE_SIZE);

  // NEW: Search Filter Logic for Persons (for selected department)
  const filteredPersons = persons.filter(p => 
    (p.name || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
    (p.position || "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  const personTotalPages = Math.max(1, Math.ceil(filteredPersons.length / SG_APT_PAGE_SIZE));
  const pagedPersons = filteredPersons.slice(personPage * SG_APT_PAGE_SIZE, (personPage + 1) * SG_APT_PAGE_SIZE);

  const goToPersonsStep = () => { if (selectedDept) { setStep(2); setSearchTerm(""); setShowAllDeptsDropdown(false); } };
  const goToDetailsStep = () => { if (selectedPerson) setStep(3); };
  
  const goBack = () => {
    setSearchTerm("");
    setShowAllDeptsDropdown(false);
    if (step > 1) { setStep((s) => s - 1); return; }
    if (appointments.length > 0) setPhase("history");
  };

  const startNewAppointment = () => {
    setSelectedDept(null);
    setSelectedPerson(null);
    setDeptPage(0);
    setPersonPage(0);
    setPreferredDate("");
    setPreferredTime("");
    setNotes("");
    setStatus("SCHEDULED");
    setSearchTerm("");
    setShowAllDeptsDropdown(false);
    setStep(1);
    setPhase("wizard");
  };

  const handleSubmit = async () => {
    if (!lead || !selectedDept || !selectedPerson) return;
    if (!preferredDate || !preferredTime) {
      toast.error("Please pick a preferred date and time.");
      return;
    }

    const creator = users.find((u) => String(u.id) === String(stableUser.id));
    const creatorName = creator ? `${creator.fname} ${creator.lname}` : "";

    const deptId = selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id;
    const personId = selectedPerson.personId ?? selectedPerson.id ?? selectedPerson._id;

    const payload = {
      companyId,
      leadId: lead.leadId,
      leadName: lead.name,
      leadPhone: lead.phone,
      leadEmail: lead.email,
      preferredDate,
      preferredTime: preferredTime.length === 5 ? `${preferredTime}:00` : preferredTime,
      departmentId: deptId,
      departmentName: selectedDept.name,
      departmentLocation: selectedDept.location,
      personId,
      personName: selectedPerson.name,
      personPosition: selectedPerson.position,
      status,
      notes,
      createdById: stableUser.id,
      createdByName: creatorName,
      lastUpdatedById: stableUser.id,
      lastUpdatedByName: creatorName,
    };

    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/appointments`, payload, { headers: authHeader() });
      toast.success("Appointment scheduled!");
      onScheduled?.();
      onClose();
    } catch (err) {
      console.error("Failed to save appointment", err);
      toast.error(err.response?.data?.message || "Failed to save appointment.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal sg2-apt-modal-container">
        
        {/* MODIFIED HEADER WITH SEARCH */}
        <div className="sg2-inline-header" style={{ gap: '10px' }}>
          <span style={{ flexShrink: 0 }}>
            {phase === "loading" && "Loading Appointments"}
            {phase === "history" && "Appointment History"}
            {phase === "wizard" && step === 1 && "Select Department"}
            {phase === "wizard" && step === 2 && "Select Person"}
            {phase === "wizard" && step === 3 && "Schedule Appointment"}
          </span>
          
          {phase === "wizard" && (step === 1 || step === 2) && (
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', paddingRight: '10px', flexWrap: 'nowrap' }}>
              <div className="sg2-apt-search-wrap">
                <svg className="sg2-apt-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#673AB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <input
                  type="text"
                  placeholder={`Search ${step === 1 ? 'department' : 'person'}...`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="sg2-inline-select sg2-apt-search-input"
                />
              </div>
              <button
                type="button"
                className={`sg2-apt-alldept-btn ${showAllDeptsDropdown ? "sg2-apt-alldept-btn--active" : ""}`}
                onClick={() => setShowAllDeptsDropdown((v) => !v)}
                title={step === 1 ? "Browse every department" : "Browse every person"}
              >
                {showAllDeptsDropdown ? "✕ Close List" : (step === 1 ? "See All Departments" : "See All Persons")}
              </button>
            </div>
          )}
          
          <button className="sg2-inline-close" onClick={onClose} style={{ flexShrink: 0 }}>✕</button>
        </div>

        {phase === "wizard" && (
          <div className="sg2-apt-steps">
            <span className={`sg2-apt-step ${step >= 1 ? "sg2-apt-step--active" : ""}`}>1. Department</span>
            <span className="sg2-apt-step-sep">→</span>
            <span className={`sg2-apt-step ${step >= 2 ? "sg2-apt-step--active" : ""}`}>2. Person</span>
            <span className="sg2-apt-step-sep">→</span>
            <span className={`sg2-apt-step ${step >= 3 ? "sg2-apt-step--active" : ""}`}>3. Details</span>
          </div>
        )}

        <div className="sg2-inline-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {phase === "loading" && (
            <div className="sg2-centered" style={{ padding: "40px 0" }}><div className="sg2-spinner" /></div>
          )}

          {phase === "history" && (
            <>
              <button type="button" className="sg2-apt-new-btn" onClick={startNewAppointment}>
                + Make New Appointment
              </button>
              <div className="sg2-apt-hist-list">
                {appointments.map((apt) => {
                  const deptPersons = allPersons.filter(p => {
                    const pDeptId = p.departmentId?._id ?? p.departmentId;
                    return pDeptId === apt.departmentId;
                  });

                  return (
                    <div key={apt.appointmentId} className="sg2-apt-hist-card">
                      <div className="sg2-apt-hist-top" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px', marginBottom: '8px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            <span style={{ fontSize: '13px', fontWeight: 700, color: '#0C4550' }}>Department:</span>
                            <SGEditableField
                              className="sg2-apt-hist-dept"
                              value={apt.departmentName}
                              onSave={(v) => handleInlineAptUpdate(apt, 'departmentName', v)}
                              label="Department"
                              options={departments}
                            />
                          </div>

                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            <span style={{ fontSize: '13px', fontWeight: 600, color: '#0C4550' }}>Status:</span>
                            <span className={`sg2-apt-status-badge sg2-apt-status-badge--${(apt.status || "").toLowerCase()}`}>
                              <SGEditableField
                                value={apt.status}
                                onSave={(v) => handleInlineAptUpdate(apt, 'status', v)}
                                label="Status"
                                options={SG_APT_STATUS_OPTIONS.map(s => ({ name: s }))}
                              />
                            </span>
                          </div>
                        </div>

                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                          <span style={{ fontSize: '13px', fontWeight: 700, color: '#0C4550' }}>Person:</span>
                          <SGEditableField
                            className="sg2-apt-hist-person"
                            value={apt.personName}
                            onSave={(v) => handleInlineAptUpdate(apt, 'personName', v)}
                            label="Person"
                            options={deptPersons.length > 0 ? deptPersons : allPersons}
                          />
                          {apt.personPosition && <span style={{ fontSize: '12px', color: '#6b7280' }}>• {apt.personPosition}</span>}
                        </div>
                      </div>

                      <div className="sg2-apt-hist-meta" style={{ display: 'flex', gap: '20px', marginTop: '12px', fontSize: '12.5px', color: '#4b5563' }}>
                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                          <span style={{ fontWeight: 600 }}>📅 Date:</span>
                          <SGEditableField
                            type="date"
                            value={apt.preferredDate}
                            onSave={(v) => handleInlineAptUpdate(apt, 'preferredDate', v)}
                            label="Date"
                          />
                        </div>
                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                          <span style={{ fontWeight: 600 }}>🕒 Time:</span>
                          <SGEditableField
                            type="time"
                            value={apt.preferredTime ? apt.preferredTime.substring(0, 5) : ""}
                            onSave={(v) => handleInlineAptUpdate(apt, 'preferredTime', v)}
                            label="Time"
                          />
                        </div>
                      </div>

                      <div className="sg2-apt-hist-notes" style={{ display: 'flex', gap: '6px', alignItems: 'flex-start', background: 'transparent', border: 'none', padding: 0, marginTop: '14px' }}>
                        <span style={{ fontSize: '13px', fontWeight: 700, color: '#0C4550', flexShrink: 0 }}>Notes:</span>
                        <SGEditableField
                          value={apt.notes}
                          onSave={(v) => handleInlineAptUpdate(apt, 'notes', v)}
                          label="Notes"
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {phase === "wizard" && step === 1 && showAllDeptsDropdown && (
            filteredDepartments.length === 0 ? (
              <p className="sg2-history-empty">No departments match your search.</p>
            ) : (
              <div className="sg2-apt-alldept-list">
                {filteredDepartments.map((dept) => {
                  const deptId = dept.departmentId ?? dept.id ?? dept._id;
                  const isSelected = selectedDept && (selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id) === deptId;
                  return (
                    <div key={deptId} className="sg2-apt-alldept-group" style={{ padding: "12px 14px" }}>
                      <button
                        type="button"
                        className="sg2-apt-alldept-dept-name"
                        onClick={() => { setSelectedDept(dept); }}
                        title="Select this department"
                        style={{ borderBottom: "none", margin: 0, padding: 0 }}
                      >
                        {dept.name}
                        {dept.location && <span className="sg2-apt-alldept-dept-loc"> · {dept.location}</span>}
                        {isSelected && <span className="sg2-apt-check" style={{ position: "relative", display: "inline-flex", top: 0, right: 0, marginLeft: "10px" }}>✓</span>}
                      </button>
                    </div>
                  );
                })}
              </div>
            )
          )}

          {phase === "wizard" && step === 1 && !showAllDeptsDropdown && (
            loadingDepartments ? (
              <div className="sg2-centered" style={{ padding: "30px 0" }}><div className="sg2-spinner" /></div>
            ) : filteredDepartments.length === 0 ? (
              <p className="sg2-history-empty">No departments found.</p>
            ) : (
              <>
                <div className="sg2-apt-grid">
                  {pagedDepartments.map((d) => {
                    const id = d.departmentId ?? d.id ?? d._id;
                    const isSelected = selectedDept && (selectedDept.departmentId ?? selectedDept.id ?? selectedDept._id) === id;
                    return (
                      <button
                        key={id}
                        type="button"
                        className={`sg2-apt-card ${isSelected ? "sg2-apt-card--selected" : ""}`}
                        onClick={() => setSelectedDept(d)}
                      >
                        {isSelected && <span className="sg2-apt-check">✓</span>}
                        <div className="sg2-apt-card-title">{d.name}</div>
                        <div className="sg2-apt-card-sub">{d.location || "No location set"}</div>
                      </button>
                    );
                  })}
                </div>
                {deptTotalPages > 1 && (
                  <div className="sg2-pagination sg2-apt-pagination">
                    <span>Page {deptPage + 1} of {deptTotalPages}</span>
                    <div className="sg2-apt-pagination-btns">
                      <button disabled={deptPage === 0} onClick={() => setDeptPage((p) => p - 1)}>← Prev</button>
                      <button disabled={deptPage === deptTotalPages - 1} onClick={() => setDeptPage((p) => p + 1)}>Next →</button>
                    </div>
                  </div>
                )}
              </>
            )
          )}

          {phase === "wizard" && step === 2 && showAllDeptsDropdown && (
            filteredPersons.length === 0 ? (
              <p className="sg2-history-empty">No persons match your search.</p>
            ) : (
              <div className="sg2-apt-alldept-list">
                {filteredPersons.map((p) => {
                  const pId = p.personId ?? p.id ?? p._id;
                  const isSelected = selectedPerson && (selectedPerson.personId ?? selectedPerson.id ?? selectedPerson._id) === pId;
                  return (
                    <div key={pId} className="sg2-apt-alldept-group" style={{ padding: "12px 14px" }}>
                      <button
                        type="button"
                        className="sg2-apt-alldept-dept-name"
                        onClick={() => {
                          setSelectedPerson(p);
                          setShowAllDeptsDropdown(false);
                          setSearchTerm("");
                          setStep(3);
                        }}
                        title="Select this person"
                        style={{ borderBottom: "none", margin: 0, padding: 0 }}
                      >
                        {p.name}
                        {p.position && <span className="sg2-apt-alldept-dept-loc"> · {p.position}</span>}
                        {isSelected && <span className="sg2-apt-check" style={{ position: "relative", display: "inline-flex", top: 0, right: 0, marginLeft: "10px" }}>✓</span>}
                      </button>
                    </div>
                  );
                })}
              </div>
            )
          )}

          {phase === "wizard" && step === 2 && !showAllDeptsDropdown && (
            loadingPersons ? (
              <div className="sg2-centered" style={{ padding: "30px 0" }}><div className="sg2-spinner" /></div>
            ) : filteredPersons.length === 0 ? (
              <p className="sg2-history-empty">No persons found in this department.</p>
            ) : (
              <>
                <div className="sg2-apt-grid">
                  {pagedPersons.map((p) => {
                    const id = p.personId ?? p.id ?? p._id;
                    const isSelected = selectedPerson && (selectedPerson.personId ?? selectedPerson.id ?? selectedPerson._id) === id;
                    return (
                      <button
                        key={id}
                        type="button"
                        className={`sg2-apt-card ${isSelected ? "sg2-apt-card--selected" : ""}`}
                        onClick={() => setSelectedPerson(p)}
                      >
                        {isSelected && <span className="sg2-apt-check">✓</span>}
                        <div className="sg2-apt-card-title">{p.name}</div>
                        <div className="sg2-apt-card-sub">{p.position || "No position set"}</div>
                      </button>
                    );
                  })}
                </div>
                {personTotalPages > 1 && (
                  <div className="sg2-pagination sg2-apt-pagination">
                    <span>Page {personPage + 1} of {personTotalPages}</span>
                    <div className="sg2-apt-pagination-btns">
                      <button disabled={personPage === 0} onClick={() => setPersonPage((p) => p - 1)}>← Prev</button>
                      <button disabled={personPage === personTotalPages - 1} onClick={() => setPersonPage((p) => p + 1)}>Next →</button>
                    </div>
                  </div>
                )}
              </>
            )
          )}

          {phase === "wizard" && step === 3 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <div className="sg2-apt-summary">
                <div><span className="sg2-apt-summary-label">Department:</span> {selectedDept?.name}</div>
                <div><span className="sg2-apt-summary-label">Person:</span> {selectedPerson?.name}{selectedPerson?.position ? ` (${selectedPerson.position})` : ""}</div>
                <div><span className="sg2-apt-summary-label">Lead:</span> {lead?.name}</div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div>
                  <label className="sg2-inline-label">Preferred date</label>
                  <input className="sg2-inline-select" type="date" value={preferredDate} min={new Date().toISOString().split("T")[0]} onChange={(e) => setPreferredDate(e.target.value)} />
                </div>
                <div>
                  <label className="sg2-inline-label">Preferred time</label>
                  <input className="sg2-inline-select" type="time" value={preferredTime} onChange={(e) => setPreferredTime(e.target.value)} />
                </div>
              </div>
              <div>
                <label className="sg2-inline-label">Notes</label>
                <textarea className="sg2-inline-textarea" rows={3} placeholder="Enter notes…" value={notes} onChange={(e) => setNotes(e.target.value)} />
              </div>
            </div>
          )}
        </div>

        <div className="sg2-inline-footer">
          {phase === "history" && (
            <button className="sg2-ghost-btn" onClick={onClose}>Close</button>
          )}
          {phase === "wizard" && (
            <>
              {(step > 1 || appointments.length > 0) && (
                <button className="sg2-ghost-btn" onClick={goBack} disabled={submitting}>Back</button>
              )}
              <button className="sg2-ghost-btn" onClick={onClose} disabled={submitting}>Cancel</button>
              {step === 1 && <button className="sg2-primary-btn" disabled={!selectedDept} onClick={goToPersonsStep}>Next</button>}
              {step === 2 && <button className="sg2-primary-btn" disabled={!selectedPerson} onClick={goToDetailsStep}>Next</button>}
              {step === 3 && (
                <button className="sg2-primary-btn" disabled={submitting} onClick={handleSubmit}>
                  {submitting ? "Scheduling…" : "Schedule"}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const SGConvertModal = ({ open, onClose, onConfirm }) => {
  if (!open) return null;
  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal">
        <div className="sg2-inline-header"><span>Convert to customer</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
        <div className="sg2-inline-body">
          <p style={{ fontSize: 14, color: "#4b5563", margin: 0 }}>Are you sure you want to convert this lead to a customer?</p>
        </div>
        <div className="sg2-inline-footer">
          <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
          <button className="sg2-primary-btn" style={{ background: "#16a34a" }} onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

const SGBanModal = ({ open, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  if (!open) return null;
  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal">
        <div className="sg2-inline-header"><span>Block lead</span><button className="sg2-inline-close" onClick={onClose}>✕</button></div>
        <div className="sg2-inline-body">
          <label className="sg2-inline-label">Reason</label>
          <input className="sg2-inline-select" type="text" placeholder="Enter reason…" value={reason} onChange={(e) => setReason(e.target.value)} />
        </div>
        <div className="sg2-inline-footer">
          <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
          <button className="sg2-primary-btn" style={{ background: "#dc2626" }} disabled={!reason.trim()} onClick={() => onConfirm(reason)}>Block</button>
        </div>
      </div>
    </div>
  );
};

const SGWhatsAppModal = ({ open, templates, onClose, onSend }) => {
  const [selected, setSelected] = useState("");
  const [templateDetails, setTemplateDetails] = useState(null);
  const [variableValues, setVariableValues] = useState({});

  const handleChange = (name) => {
    setSelected(name);
    const tpl = templates.find((t) => t.name === name);
    setTemplateDetails(tpl || null);
    setVariableValues({});
  };

  const handleVarChange = (key, val) => {
    setVariableValues((prev) => ({ ...prev, [key]: val }));
  };

  const getPreviewText = (text) => {
    if (!text) return "";
    let updated = text;
    Object.keys(variableValues).forEach((key) => {
      const regex = new RegExp(`{{${key}}}`, "g");
      updated = updated.replace(regex, variableValues[key] || `{{${key}}}`);
    });
    return updated;
  };

  const extractVariables = (text) => {
    if (!text) return [];
    const matches = text.match(/{{(\d+)}}/g);
    return matches ? [...new Set(matches.map((m) => m.match(/\d+/)[0]))].sort() : [];
  };

  if (!open) return null;

  const vars = extractVariables(templateDetails?.components?.find(c => c.type === 'BODY')?.text || templateDetails?.body);

  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal">
        <div className="sg2-inline-header">
          <span>Send WhatsApp</span>
          <button className="sg2-inline-close" onClick={onClose}>✕</button>
        </div>
        <div className="sg2-inline-body">
          <label className="sg2-inline-label">Template</label>
          <select className="sg2-inline-select" value={selected} onChange={(e) => handleChange(e.target.value)}>
            <option value="">— select template —</option>
            {Array.isArray(templates) && templates.map((t) => (
              <option key={t.id || t.name} value={t.name}>{t.name}</option>
            ))}
          </select>

          {templateDetails && (
            <div style={{ marginTop: 12 }}>
              <div style={{ padding: "12px", background: "#f0fdf4", borderRadius: 8, fontSize: 13, border: "1px solid #bbf7d0", lineHeight: 1.5, marginBottom: 12 }}>
                <div style={{ whiteSpace: "pre-wrap", color: '#166534' }}>
                  {getPreviewText(templateDetails.components?.find(c => c.type === 'BODY')?.text || templateDetails.body)}
                </div>
              </div>

              {vars.length > 0 && (
                <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: 10 }}>
                  <label className="sg2-inline-label" style={{ marginBottom: 8 }}>Fill Variables</label>
                  {vars.map((v) => (
                    <div key={v} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", minWidth: 30 }}>Var {v}:</span>
                      <input
                        className="sg2-inline-select"
                        placeholder={`Value for {{${v}}}`}
                        value={variableValues[v] || ""}
                        onChange={(e) => handleVarChange(v, e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="sg2-inline-footer">
          <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
          <button className="sg2-primary-btn" style={{ background: "#16a34a" }} disabled={!selected} onClick={() => onSend(selected, variableValues)}>Send</button>        </div>
      </div>
    </div>
  );
};

const SGSmsModal = ({ open, templates, onClose, onSend }) => {
  const [page, setPage] = useState(0);
  const itemsPerPage = 12;

  useEffect(() => { setPage(0); }, [open]);

  if (!open) return null;

  const totalPages = Math.ceil(templates.length / itemsPerPage);
  const currentTemplates = templates.slice(page * itemsPerPage, (page + 1) * itemsPerPage);

  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal sg2-sms-modal-container" style={{ background: "linear-gradient(135deg, #e0e8f5, #c6e4ec)" }}>
        <div className="sg2-inline-header" style={{ background: "transparent", borderBottom: "1px solid rgba(255,255,255,0.4)" }}>
          <span>Select SMS Template</span>
          <button className="sg2-inline-close" onClick={onClose}>✕</button>
        </div>
        <div className="sg2-inline-body" style={{ maxHeight: "75vh", overflowY: "auto", paddingBottom: "20px" }}>
          <div className="sg2-sms-grid">
            {currentTemplates.map((t) => (
              <button
                key={t.messageId}
                className="sg2-sms-glass-card"
                onClick={() => onSend(t.messageId, [])}
              >
                <div className="sg2-sms-card-title">{t.templateType || t.templateName || t.messageId}</div>
                <div className="sg2-sms-card-preview">{t.templateText}</div>
              </button>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="sg2-pagination">
              <button disabled={page === 0} onClick={() => setPage((p) => p - 1)}>Prev</button>
              <span>Page {page + 1} of {totalPages}</span>
              <button disabled={page === totalPages - 1} onClick={() => setPage((p) => p + 1)}>Next</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const SGEmailModal = ({ open, templates, onClose, onSend, sendingEmailId }) => {
  const [page, setPage] = useState(0);
  const itemsPerPage = 12;

  useEffect(() => { setPage(0); }, [open]);

  if (!open) return null;

  const totalPages = Math.ceil(templates.length / itemsPerPage);
  const currentTemplates = templates.slice(page * itemsPerPage, (page + 1) * itemsPerPage);

  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal sg2-sms-modal-container" style={{ background: "linear-gradient(135deg, #e0e8f5, #c6e4ec)" }}>
        <div className="sg2-inline-header" style={{ background: "transparent", borderBottom: "1px solid rgba(255,255,255,0.4)" }}>
          <span>Select Email Template</span>
          <button className="sg2-inline-close" onClick={onClose} disabled={sendingEmailId !== null}>✕</button>
        </div>
        <div className="sg2-inline-body" style={{ maxHeight: "75vh", overflowY: "auto", paddingBottom: "20px" }}>
          <div className="sg2-sms-grid">
            {currentTemplates.map((t) => {
              const tId = t.emailTemplateId || t.id;
              const isSending = sendingEmailId === tId;

              return (
                <button
                  key={tId}
                  className="sg2-sms-glass-card"
                  onClick={() => !isSending && onSend(tId, [])}
                  disabled={isSending}
                  style={{ position: 'relative', cursor: isSending ? 'not-allowed' : 'pointer' }}
                >
                  {isSending && (
                    <div className="sg2-card-loader-overlay">
                      <div className="sg2-spinner"></div>
                    </div>
                  )}
                  <div style={{ opacity: isSending ? 0.3 : 1, transition: 'opacity 0.2s' }}>
                    <div className="sg2-sms-card-title">{t.title || t.subject}</div>
                    <div className="sg2-sms-card-preview">{t.subject || "No Subject"}</div>
                  </div>
                </button>
              );
            })}
          </div>

          {totalPages > 1 && (
            <div className="sg2-pagination">
              <button disabled={page === 0} onClick={() => setPage((p) => p - 1)}>Prev</button>
              <span>Page {page + 1} of {totalPages}</span>
              <button disabled={page === totalPages - 1} onClick={() => setPage((p) => p + 1)}>Next</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const SGHistoryModal = ({ open, lead, historyData, loading, onClose }) => {
  if (!open) return null;

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const strHours = String(hours).padStart(2, "0");
    return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
  };

  const renderChange = (item, idx) => {
    if (item.changeType === "lead created") {
      return (
        <div key={idx} className="sg2-history-row">
          <span className="sg2-history-dot sg2-history-dot--green" />
          <span className="sg2-history-created-text">Lead was created</span>
        </div>
      );
    }

    if (item.changeType && item.changeType.includes("UPDATED_FIELDS")) {
      const changeText = item.changeType.replace("UPDATED_FIELDS: ", "");
      const changes = [];
      const fieldRegex = /([^:]+?)\s*\[From:\s*([^,]+),\s*To:\s*([^\]]+)\]/g;
      let match;
      while ((match = fieldRegex.exec(changeText)) !== null) {
        const field = match[1].trim();
        const from = match[2].trim() || "Empty";
        const to = match[3].trim();
        if (field.toLowerCase().includes("color")) continue;
        changes.push({ field, from, to });
      }

      if (changes.length === 0) {
        const filteredLines = changeText
          .split(",")
          .filter((line) => !line.toLowerCase().includes("color"));
        return filteredLines.map((line, i) => (
          <div key={i} className="sg2-history-row">
            <span className="sg2-history-dot" />
            <span className="sg2-history-created-text">{line.trim()}</span>
          </div>
        ));
      }

      return changes.map((c, i) => (
        <div key={i} className="sg2-history-change">
          <div className="sg2-history-change-field">{c.field}</div>
          <div className="sg2-history-change-values">
            <span className="sg2-history-from">{c.from}</span>
            <span className="sg2-history-arrow">→</span>
            <span className="sg2-history-to">{c.to}</span>
          </div>
        </div>
      ));
    }

    return (
      <div key={idx} className="sg2-history-row">
        <span className="sg2-history-dot" />
        <span className="sg2-history-created-text">{item.changeType}</span>
      </div>
    );
  };

  const sorted = [...(historyData || [])].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal sg2-history-modal-container">
        <div className="sg2-inline-header">
          <span>Lead History</span>
          <button className="sg2-inline-close" onClick={onClose}>✕</button>
        </div>

        <div className="sg2-history-lead-strip">
          <SGAvatar name={lead?.name || "?"} size={36} />
          <div className="sg2-history-lead-meta">
            <span className="sg2-history-lead-name">{lead?.name}</span>
            <div className="sg2-history-lead-sub">
              {lead?.phone && <span>📞 {lead.phone}</span>}
              {lead?.email && <span>✉️ {lead.email}</span>}
              {lead?.companyName && <span>🏢 {lead.companyName}</span>}
            </div>
          </div>
        </div>

        <div className="sg2-inline-body sg2-history-body-wrap">
          {loading ? (
            <div className="sg2-centered" style={{ padding: "30px 0" }}>
              <div className="sg2-spinner" />
            </div>
          ) : sorted.length === 0 ? (
            <p className="sg2-history-empty">No history available for this lead.</p>
          ) : (
            sorted.map((item, idx) => (
              <div key={item.historyId || idx} className="sg2-history-card">
                <div className="sg2-history-card-top">
                  <div className="sg2-history-avatar">
                    {(item.changedByName || "U").charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div className="sg2-history-changer">{item.changedByName || "Unknown User"}</div>
                    <div className="sg2-history-time">{formatDateTime(item.createdAt)}</div>
                  </div>
                </div>
                <div className="sg2-history-card-body">{renderChange(item, idx)}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};


const SGCallHistoryModal = ({ open, lead, data, loading, onClose }) => {
  if (!open) return null;

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleString("en-IN", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true
    });
  };

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal sg2-history-modal-container">
        <div className="sg2-inline-header">
          <span>Call History</span>
          <button className="sg2-inline-close" onClick={onClose}>✕</button>
        </div>

        <div className="sg2-history-lead-strip">
          <SGAvatar name={lead?.name || "?"} size={36} />
          <div className="sg2-history-lead-meta">
            <span className="sg2-history-lead-name">{lead?.name}</span>
            <div className="sg2-history-lead-sub">
              {lead?.phone && <span>📞 {lead.phone}</span>}
            </div>
          </div>
        </div>

        <div className="sg2-inline-body sg2-history-body-wrap">
          {loading ? (
            <div className="sg2-centered" style={{ padding: "30px 0" }}>
              <div className="sg2-spinner" />
            </div>
          ) : data.length === 0 ? (
            <p className="sg2-history-empty">No call recordings found.</p>
          ) : (
            data.map((item, idx) => (
              <div key={item.callSessionId || idx} className="sg2-history-card">
                <div className="sg2-history-card-top" style={{ justifyContent: "space-between" }}>
                  <div>
                    <div className="sg2-history-changer">Session: {item.callSessionId}</div>
                    <div className="sg2-history-time">{formatDateTime(item.startTime)}</div>
                  </div>
                  <span className="sg2-status-pill" style={{ background: item.status === 'answered' ? '#16a34a' : '#F46653' }}>
                    {item.status}
                  </span>
                </div>
                <div className="sg2-history-card-body" style={{ borderLeftColor: "#0C4550" }}>
                  <div className="sg2-history-row">
                    <span className="sg2-history-created-text">Duration: <b>{formatDuration(item.callDuration)}</b></span>
                  </div>
                  {item.resourceURL && (
                    <div style={{ marginTop: "10px" }}>
                      <audio src={item.resourceURL} controls style={{ width: "100%", height: "35px" }} />
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};


// ─── Call Transcription (Gemini) Modal ───────────────────────────────────────
const isZeroDurationClip = (duration) => {
  if (duration === null || duration === undefined || duration === "") return true;
  const asNumber = Number(duration);
  if (!Number.isNaN(asNumber)) return asNumber <= 0;
  // clock-style fallback, e.g. "0:00" / "00:00:00"
  return /^[0:.\s]+$/.test(String(duration));
};

const SGStarRating = ({ value = 0 }) => (
  <span style={{ letterSpacing: "2px" }}>
    {[1, 2, 3, 4, 5].map((n) => (
      <span key={n} style={{ color: n <= value ? "#f5a623" : "#d8d8d8", fontSize: "16px" }}>★</span>
    ))}
  </span>
);

const SG_INTENT_CATEGORIES = [
  { value: "INTERESTED", label: "Interested" },
  { value: "PRICE_INQUIRY", label: "Price inquiry" },
  { value: "INFORMATION_REQUEST", label: "Information request" },
  { value: "CALLBACK_REQUESTED", label: "Callback requested" },
  { value: "SITE_VISIT_OR_DEMO", label: "Site visit / demo" },
  { value: "NOT_INTERESTED", label: "Not interested" },
  { value: "WRONG_NUMBER", label: "Wrong number" },
  { value: "OTHER", label: "Other" },
];

const SG_EXTRACTION_FIELDS = [
  { key: "name", label: "Name", placeholder: "Client name" },
  { key: "email", label: "Email", placeholder: "client@example.com" },
  { key: "phone", label: "Phone (saved as alt. contact)", placeholder: "10-digit mobile number" },
];

const SG_EXTRACTION_STATUS = {
  PENDING_REVIEW: { label: "Pending review", bg: "#f5a623" },
  APPROVED: { label: "Approved", bg: "#16a34a" },
  REJECTED: { label: "Rejected", bg: "#9a9a9a" },
};

const sgExtractionToDraft = (ex) => ({
  name: ex?.reviewed?.name || "",
  email: ex?.reviewed?.email || "",
  phone: ex?.reviewed?.phone || "",
  intent: ex?.reviewed?.intent || "",
  intentCategory: ex?.reviewed?.intentCategory || "",
});

const SGTranscribeModal = ({ open, lead, companyId, onClose, onLeadUpdated }) => {
  const [recordings, setRecordings] = useState([]);
  const [loadingRecordings, setLoadingRecordings] = useState(false);
  const [activeIdx, setActiveIdx] = useState(0);
  const [results, setResults] = useState({});     // callSessionId -> transcription result
  const [transcribingId, setTranscribingId] = useState(null);
  const [extractions, setExtractions] = useState({});
  const [drafts, setDrafts] = useState({});
  const [extractionBusy, setExtractionBusy] = useState(null);

  useEffect(() => {
    if (!open || !lead?.leadId) return;

    const load = async () => {
      setLoadingRecordings(true);
      setActiveIdx(0);
      try {
        const [recRes, existingRes, extractionRes] = await Promise.all([
          axios.get(`${API_URL}/api/leads/${lead.leadId}/call-recordings`, { headers: authHeader() }),
          axios.get(`${API_URL}/api/transcription/lead/${lead.leadId}`, { headers: authHeader() }).catch(() => ({ data: [] })),
          axios.get(`${API_URL}/api/lead-extractions/lead/${lead.leadId}`, { headers: authHeader() }).catch(() => ({ data: [] })),
        ]);

        setRecordings(recRes.data || []);

        const cacheMap = {};
        (existingRes.data || []).forEach((t) => {
          if (t.callSessionId) cacheMap[t.callSessionId] = t;
        });
        setResults(cacheMap);

        const extractionMap = {};
        const draftMap = {};
        (extractionRes.data || []).forEach((ex) => {
          if (ex.callSessionId) {
            extractionMap[ex.callSessionId] = ex;
            draftMap[ex.callSessionId] = sgExtractionToDraft(ex);
          }
        });
        setExtractions(extractionMap);
        setDrafts(draftMap);
      } catch (err) {
        console.error("Error fetching recordings for transcription", err);
        toast.error("Failed to fetch call recordings");
        setRecordings([]);
      } finally {
        setLoadingRecordings(false);
      }
    };
    load();
  }, [open, lead?.leadId]);

  if (!open) return null;

  const current = recordings[activeIdx] ?? null;
  const currentResult = current ? results[current.callSessionId] : null;
  const currentIsZero = current ? isZeroDurationClip(current.callDuration) : false;

  const formatDuration = (seconds) => {
    const n = Number(seconds) || 0;
    const mins = Math.floor(n / 60);
    const secs = Math.floor(n % 60);
    return `${mins}m ${secs}s`;
  };

  const fetchExtraction = async (callSessionId) => {
    try {
      const res = await axios.get(`${API_URL}/api/lead-extractions/session/${callSessionId}`, { headers: authHeader() });
      setExtractions((prev) => ({ ...prev, [callSessionId]: res.data }));
      setDrafts((prev) => ({ ...prev, [callSessionId]: sgExtractionToDraft(res.data) }));
    } catch (err) {
      if (err?.response?.status !== 404) console.error("Error fetching extracted details", err);
    }
  };

  const updateDraft = (callSessionId, field, value) => {
    setDrafts((prev) => ({ ...prev, [callSessionId]: { ...(prev[callSessionId] || {}), [field]: value } }));
  };

  const buildLeadPatch = (fields) => {
    const patch = {};
    if (fields.name) patch.name = fields.name;
    if (fields.email) patch.email = fields.email;
    const leadDigits = String(lead?.phone || "").replace(/\D/g, "");
    if (fields.phone && !leadDigits.endsWith(fields.phone)) patch.otherContactNo = fields.phone;
    if (fields.intent || fields.intentCategory) {
      patch.customFields = {
        ...(lead?.customFields || {}),
        ...(fields.intent ? { callIntent: fields.intent } : {}),
        ...(fields.intentCategory ? { callIntentCategory: fields.intentCategory } : {}),
      };
    }
    return patch;
  };

  const handleExtractionAction = async (callSessionId, action) => {
    const ex = extractions[callSessionId];
    if (!ex) return;
    const draft = drafts[callSessionId] || sgExtractionToDraft(ex);
    setExtractionBusy(ex.id);
    try {
      let res;
      if (action === "save") {
        res = await axios.put(`${API_URL}/api/lead-extractions/${ex.id}`, draft, { headers: authHeader() });
        toast.success("Changes saved");
      } else if (action === "approve") {
        res = await axios.post(`${API_URL}/api/lead-extractions/${ex.id}/approve`, draft, { headers: authHeader() });
        toast.success("Approved and saved to lead");
        if (onLeadUpdated) onLeadUpdated(lead.leadId, buildLeadPatch(res.data.reviewed || {}));
      } else {
        res = await axios.post(`${API_URL}/api/lead-extractions/${ex.id}/reject`, null, { headers: authHeader() });
        toast.success("Extraction rejected");
      }
      setExtractions((prev) => ({ ...prev, [callSessionId]: res.data }));
      setDrafts((prev) => ({ ...prev, [callSessionId]: sgExtractionToDraft(res.data) }));
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setExtractionBusy(null);
    }
  };

  const renderExtractionPanel = (callSessionId) => {
    const ex = extractions[callSessionId];
    if (!ex) {
      return (
        <p style={{ fontSize: "12.5px", color: "#9a9a9a", fontStyle: "italic", margin: "14px 0 0" }}>
          No lead details were extracted from this call.
        </p>
      );
    }
    const draft = drafts[callSessionId] || sgExtractionToDraft(ex);
    const original = sgExtractionToDraft(ex);
    const pending = ex.status === "PENDING_REVIEW";
    const busy = extractionBusy === ex.id;
    const dirty = Object.keys(original).some((k) => (original[k] || "") !== (draft[k] || ""));
    const statusStyle = SG_EXTRACTION_STATUS[ex.status] || SG_EXTRACTION_STATUS.PENDING_REVIEW;

    return (
      <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #e5e5e5" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
          <span style={{ fontSize: "13px", fontWeight: 600 }}>Extracted Lead Details</span>
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {ex.extractionConfidence && (
              <span style={{ fontSize: "11px", color: "#666" }}>AI confidence: {ex.extractionConfidence}</span>
            )}
            <span className="sg2-status-pill" style={{ background: statusStyle.bg }}>{statusStyle.label}</span>
          </span>
        </div>

        {SG_EXTRACTION_FIELDS.map((f) => (
          <div key={f.key} style={{ marginBottom: "8px" }}>
            <label className="sg2-inline-label">{f.label}</label>
            <input
              className="sg2-inline-select"
              type="text"
              placeholder={f.placeholder}
              value={draft[f.key] || ""}
              disabled={!pending || busy}
              onChange={(e) => updateDraft(callSessionId, f.key, e.target.value)}
            />
            {pending && original[f.key] && ex.extracted?.[f.key] && ex.extracted[f.key] !== (draft[f.key] || "") && (
              <div style={{ fontSize: "11px", color: "#9a9a9a", marginTop: "2px" }}>AI heard: {ex.extracted[f.key]}</div>
            )}
          </div>
        ))}

        <div style={{ marginBottom: "8px" }}>
          <label className="sg2-inline-label">Intent category</label>
          <select
            className="sg2-inline-select"
            value={draft.intentCategory || ""}
            disabled={!pending || busy}
            onChange={(e) => updateDraft(callSessionId, "intentCategory", e.target.value)}
          >
            <option value="">Not set</option>
            {SG_INTENT_CATEGORIES.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: "10px" }}>
          <label className="sg2-inline-label">Call intent</label>
          <textarea
            className="sg2-inline-textarea"
            rows={2}
            placeholder="Why the client called"
            value={draft.intent || ""}
            disabled={!pending || busy}
            onChange={(e) => updateDraft(callSessionId, "intent", e.target.value)}
          />
        </div>

        {pending ? (
          <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
            <button className="sg2-ghost-btn" disabled={busy} onClick={() => handleExtractionAction(callSessionId, "reject")}>
              Reject
            </button>
            <button className="sg2-ghost-btn" disabled={busy || !dirty} onClick={() => handleExtractionAction(callSessionId, "save")}>
              Save edits
            </button>
            <button
              className="sg2-primary-btn"
              style={{ background: "#16a34a" }}
              disabled={busy}
              onClick={() => handleExtractionAction(callSessionId, "approve")}
            >
              {busy ? "Working…" : "Approve & save to lead"}
            </button>
          </div>
        ) : (
          ex.reviewedByName && (
            <div style={{ fontSize: "12px", color: "#666" }}>
              {ex.status === "APPROVED" ? "Approved" : "Rejected"} by {ex.reviewedByName}
            </div>
          )
        )}
      </div>
    );
  };

  const handleTranscribe = async () => {
    if (!current || currentIsZero) return;
    setTranscribingId(current.callSessionId);
    try {
      const res = await axios.post(
        `${API_URL}/api/transcription/lead/${lead.leadId}`,
        { companyId, callSessionId: current.callSessionId },
        { headers: authHeader() }
      );
      setResults((prev) => ({ ...prev, [current.callSessionId]: res.data }));
      if (res.data?.status === "SUCCESS") await fetchExtraction(current.callSessionId);
    } catch (err) {
      const msg = err?.response?.data?.message || "Failed to transcribe this recording.";
      toast.error(msg);
    } finally {
      setTranscribingId(null);
    }
  };

  const goPrev = () => setActiveIdx((i) => Math.max(0, i - 1));
  const goNext = () => setActiveIdx((i) => Math.min(recordings.length - 1, i + 1));

  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal sg2-history-modal-container">
        <div className="sg2-inline-header">
          <span>Call Transcription &amp; Rating</span>
          <button className="sg2-inline-close" onClick={onClose}>✕</button>
        </div>

        <div className="sg2-history-lead-strip">
          <SGAvatar name={lead?.name || "?"} size={36} />
          <div className="sg2-history-lead-meta">
            <span className="sg2-history-lead-name">{lead?.name}</span>
            <div className="sg2-history-lead-sub">
              {lead?.phone && <span>📞 {lead.phone}</span>}
            </div>
          </div>
        </div>

        <div className="sg2-inline-body sg2-history-body-wrap">
          {loadingRecordings ? (
            <div className="sg2-centered" style={{ padding: "30px 0" }}>
              <div className="sg2-spinner" />
            </div>
          ) : recordings.length === 0 ? (
            <p className="sg2-history-empty">No call recordings found.</p>
          ) : (
            <>
              {/* Queue navigation */}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                <button className="sg2-history-trigger-btn" onClick={goPrev} disabled={activeIdx === 0} style={{ opacity: activeIdx === 0 ? 0.4 : 1 }}>◀ Prev</button>
                <span style={{ fontSize: "13px", fontWeight: 600, color: "#0C4550" }}>
                  Recording {activeIdx + 1} of {recordings.length}
                </span>
                <button className="sg2-history-trigger-btn" onClick={goNext} disabled={activeIdx === recordings.length - 1} style={{ opacity: activeIdx === recordings.length - 1 ? 0.4 : 1 }}>Next ▶</button>
              </div>

              {current && (
                <div className="sg2-history-card">
                  <div className="sg2-history-card-top" style={{ justifyContent: "space-between" }}>
                    <div>
                      <div className="sg2-history-changer">Session: {current.callSessionId}</div>
                      <div className="sg2-history-time">Duration: <b>{formatDuration(current.callDuration)}</b></div>
                    </div>
                    <span className="sg2-status-pill" style={{ background: current.status === "answered" ? "#16a34a" : "#F46653" }}>
                      {current.status}
                    </span>
                  </div>

                  <div className="sg2-history-card-body" style={{ borderLeftColor: "#0C4550" }}>
                    {current.resourceURL && (
                      <audio src={current.resourceURL} controls style={{ width: "100%", height: "35px", marginBottom: "10px" }} />
                    )}

                    {currentIsZero ? (
                      <p style={{ fontSize: "13px", color: "#9a9a9a", fontStyle: "italic", margin: 0 }}>
                        This recording is 0:00 - there's no audio to transcribe, so it's skipped automatically.
                      </p>
                    ) : currentResult ? (
                      <div>
                        {currentResult.status === "FAILED" ? (
                          <p style={{ color: "#F46653", fontSize: "13px" }}>
                            Transcription failed: {currentResult.errorMessage || "Unknown error"}
                          </p>
                        ) : (
                          <>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                              <span style={{ fontSize: "13px", fontWeight: 600 }}>Executive Rating:</span>
                              <SGStarRating value={currentResult.executiveRating} />
                              <span style={{ fontSize: "12px", color: "#666" }}>({currentResult.executiveRating}/5)</span>
                            </div>

                            {currentResult.ratingRemarks && (
                              <p style={{ fontSize: "13px", color: "#333", margin: "0 0 10px" }}>{currentResult.ratingRemarks}</p>
                            )}

                            {Array.isArray(currentResult.improvementSuggestions) && currentResult.improvementSuggestions.length > 0 && (
                              <div style={{ marginBottom: "12px" }}>
                                <span style={{ fontSize: "13px", fontWeight: 600 }}>Suggestions to improve:</span>
                                <ul style={{ margin: "6px 0 0", paddingLeft: "18px" }}>
                                  {currentResult.improvementSuggestions.map((s, i) => (
                                    <li key={i} style={{ fontSize: "12.5px", color: "#333", marginBottom: "4px" }}>{s}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {currentResult.overallSummary && (
                              <p style={{ fontSize: "12.5px", color: "#555", fontStyle: "italic", marginBottom: "12px" }}>
                                {currentResult.overallSummary}
                              </p>
                            )}

                            <div style={{ fontSize: "13px", fontWeight: 600, marginBottom: "6px" }}>Transcript:</div>
                            <div style={{ maxHeight: "220px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "6px" }}>
                              {(currentResult.transcript || []).map((line, i) => (
                                <div
                                  key={i}
                                  style={{
                                    alignSelf: line.speaker === "EXECUTIVE" ? "flex-end" : "flex-start",
                                    background: line.speaker === "EXECUTIVE" ? "#e8f4f7" : "#f2f2f2",
                                    borderRadius: "10px",
                                    padding: "6px 10px",
                                    maxWidth: "85%",
                                  }}
                                >
                                  <div style={{ fontSize: "10.5px", fontWeight: 700, color: "#0C4550", marginBottom: "2px" }}>
                                    {line.speaker === "EXECUTIVE" ? "Executive" : "Client"}
                                  </div>
                                  <div style={{ fontSize: "13px", color: "#222" }}>{line.text}</div>
                                </div>
                              ))}
                            </div>
                            {renderExtractionPanel(current.callSessionId)}
                          </>
                        )}
                      </div>
                    ) : (
                      <button
                        className="sg2-history-trigger-btn"
                        onClick={handleTranscribe}
                        disabled={transcribingId === current.callSessionId}
                        style={{ padding: "6px 14px" }}
                      >
                        {transcribingId === current.callSessionId ? "Transcribing…" : "🎧 Transcribe & Rate"}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// ─── NEW: Comment Modal ───────────────────────────────────────────────────────
const SGCommentModal = ({ open, value, onChange, onSave, onClose }) => {
  if (!open) return null;
  return (
    <div className="sg2-inline-overlay">
      <div className="sg2-inline-modal">
        <div className="sg2-inline-header">
          <span>Edit Comment</span>
          <button className="sg2-inline-close" onClick={onClose}>✕</button>
        </div>
        <div className="sg2-inline-body">
          <label className="sg2-inline-label">Comment</label>
          <textarea
            autoFocus
            className="sg2-inline-textarea"
            rows={7}
            placeholder="Enter comment…"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
        <div className="sg2-inline-footer">
          <button className="sg2-ghost-btn" onClick={onClose}>Cancel</button>
          <button className="sg2-primary-btn" onClick={onSave}>Save</button>
        </div>
      </div>
    </div>
  );
};


// ──────────────────────────────────────────────────────────────────────────────
//  SALES GOD PAGE — Main component
// ──────────────────────────────────────────────────────────────────────────────
const SalesGod = () => {
  const navigate = useNavigate();
  const { isIncomingModeOn } = useIncomingMode();
  const { user, isAuthenticated, loading: authLoading } = useContext(AuthContext);
  const [showCallHistoryModal, setShowCallHistoryModal] = useState(false);
  const [callHistoryData, setCallHistoryData] = useState([]);
  const [callHistoryLoading, setCallHistoryLoading] = useState(false);
  const [showTranscribeModal, setShowTranscribeModal] = useState(false);

  const [apiPage, setApiPage] = useState(0);
  const [hasMoreApiLeads, setHasMoreApiLeads] = useState(true);
  const [fetchingMore, setFetchingMore] = useState(false);
  const stableUser = useMemo(() => ({
    id: user?.id,
    accountType: user?.accountType,
    companyId: user?.companyId,
  }), [user?.id, user?.accountType, user?.companyId]);

  const companyId = useMemo(() =>
    isOwnerLevel(stableUser.accountType) ? stableUser.id : stableUser.companyId,
    [stableUser]
  );

  const token = localStorage.getItem("token");

  const [splash, setSplash] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setSplash(false), 2000);
    return () => clearTimeout(t);
  }, []);

  const [statuses, setStatuses] = useState([]);
  const [statusCounts, setStatusCounts] = useState({});
  const [activeStatus, setActiveStatus] = useState("");
  const [allLeads, setAllLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const leadsPerPage = 14;
  const [leadPage, setLeadPage] = useState(0);

  const [users, setUsers] = useState([]);
  const [labels, setLabels] = useState([]);
  const [whatsappTemplates, setWhatsappTemplates] = useState([]);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [loginMobileNo, setLoginMobileNo] = useState("");

  const [waApiKey, setWaApiKey] = useState("");

  // NEW: Custom lead fields configured in "Lead Config" page (fetched from lead-fields API)
  const [customFields, setCustomFields] = useState([]);

  const [showStatus, setShowStatus] = useState(false);
  const [showFollowUp, setShowFollowUp] = useState(false);
  const [showAppointment, setShowAppointment] = useState(false);
  const [showLabel, setShowLabel] = useState(false);
  const [showConvert, setShowConvert] = useState(false);
  const [showBan, setShowBan] = useState(false);
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [sendingEmailId, setSendingEmailId] = useState(null);

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  const [showComment, setShowComment] = useState(false);
  const [commentDraft, setCommentDraft] = useState("");

  const [showCommInfo, setShowCommInfo] = useState(false);
  const [showLeadInfo, setShowLeadInfo] = useState(false);
  const commInfoRef = useRef(null);
  const leadInfoRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const searchContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
      if (commInfoRef.current && !commInfoRef.current.contains(event.target)) {
        setShowCommInfo(false);
      }
      if (leadInfoRef.current && !leadInfoRef.current.contains(event.target)) {
        setShowLeadInfo(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (authLoading || !isAuthenticated) return;
    const fetchAll = async () => {
      setLoading(true);
      try {
        const usersUrl = isOwnerLevel(stableUser.accountType)
          ? `${API_URL}/api/companyuser/getByUserId?userId=${stableUser.id}&accountType=${stableUser.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${stableUser.id}&accountType=${stableUser.accountType}`;

        const [statusRes, leadsRes, usersRes, labelsRes, waConfigRes, countsRes, customFieldsRes] = await Promise.all([
          axios.get(`${API_URL}/api/leadStatus/company/${companyId}`, { headers: authHeader() }),
          axios.get(
            `${API_URL}/api/leads/company/${companyId}/status-wise?limit=200&userId=${stableUser.id}`,
            { headers: authHeader() }
          ),
          axios.get(usersUrl, { headers: authHeader() }),
          axios.get(`${API_URL}/api/projectName/company/${companyId}`, { headers: authHeader() }),
          axios.get(`${API_URL}/api/whatsappConfig/${companyId}`, { headers: authHeader() }).catch(err => {
            console.warn("WhatsApp config not found or error fetching:", err.message);
            return null;
          }),
          axios.get(`${API_URL}/api/leads/status-wise-leads`, {
            params: { companyId, userId: stableUser.id },
            headers: authHeader()
          }).catch(err => {
            console.warn("Status counts fetch error", err.message);
            return { data: [] };
          }),
          // NEW: fetch active custom lead fields configured on the "Lead Config" page
          axios.get(`${API_URL}/api/lead-fields/company/${companyId}?activeOnly=true`, { headers: authHeader() }).catch(err => {
            console.warn("Custom lead fields fetch error", err.message);
            return { data: [] };
          })
        ]);
        const active = (statusRes.data || [])
          .filter((s) => s.active !== false)
          .map((s) => ({ ...s, name: (s.name || "").trim() }));
        setStatuses(active);

        const countsMap = {};
        if (countsRes && countsRes.data) {
          countsRes.data.forEach(item => {
            countsMap[(item.statusName || "").trim()] = item.totalLeads;
          });
        }
        active.forEach((s) => {
          if (!(s.name in countsMap)) countsMap[s.name] = 0;
        });
        setStatusCounts(countsMap);

        const statusesData = leadsRes.data?.statuses || [];
        const flattenedLeads = [];
        statusesData.forEach((statusItem) => {
          if (statusItem.leads) {
            flattenedLeads.push(...statusItem.leads);
          }
        });
        setAllLeads(flattenedLeads);

        const anyStatusHasMore = statusesData.some((s) => s.hasMore);
        setHasMoreApiLeads(anyStatusHasMore);
        setApiPage(0);

        setUsers(usersRes.data || []);
        setLabels(labelsRes.data || []);

        // NEW: keep only active custom fields (in case the endpoint ignores activeOnly)
        const fetchedCustomFields = Array.isArray(customFieldsRes?.data) ? customFieldsRes.data : [];
        setCustomFields(fetchedCustomFields.filter((f) => f.active !== false));

        if (active.length > 0) {
          const savedStatus = sessionStorage.getItem("sg_activeStatus");
          const isValid = active.some(s => s.name === savedStatus);
          setActiveStatus(isValid ? savedStatus : active[0].name);
        }
        const userData = (usersRes.data || []).find((u) => u.id === stableUser.id);
        if (userData) setLoginMobileNo(userData.mobileNumber || "");

        if (waConfigRes && waConfigRes.data && waConfigRes.data.status === "success") {
          setWaApiKey(waConfigRes.data.data.apiKey);
        }

      } catch (err) {
        console.error("Sales God fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, [companyId, stableUser, authLoading, isAuthenticated]);

  useEffect(() => {
    if (activeStatus) {
      const normalizedActiveStatus = (activeStatus || "").trim();
      const newFiltered = allLeads.filter(
        (l) => ((l.statusName || l.status || "").trim()) === normalizedActiveStatus
      );

      const uniqueMap = new Map();
      newFiltered.forEach(l => {
        if (l.leadId) uniqueMap.set(String(l.leadId), l);
      });
      const uniqueFiltered = Array.from(uniqueMap.values());

      setFilteredLeads(uniqueFiltered);

      const savedLeadId = sessionStorage.getItem("sg_activeLeadId");
      let foundIndex = 0;

      if (savedLeadId) {
        const idx = uniqueFiltered.findIndex((l) => String(l.leadId) === String(savedLeadId));
        if (idx !== -1) foundIndex = idx;
      }

      setActiveIndex(foundIndex);
      setLeadPage(Math.floor(foundIndex / leadsPerPage));
    }
  }, [activeStatus, allLeads]);

  useEffect(() => {
    if (filteredLeads[activeIndex]) {
      sessionStorage.setItem("sg_activeLeadId", filteredLeads[activeIndex].leadId);
    }
  }, [activeIndex, filteredLeads]);

  useEffect(() => {
    if (activeStatus) {
      sessionStorage.setItem("sg_activeStatus", activeStatus);
    }
  }, [activeStatus]);

  useEffect(() => {
    setLeadPage(Math.floor(activeIndex / leadsPerPage));
  }, [activeIndex]);

  const anyModalOpen = showStatus || showFollowUp || showAppointment || showLabel || showConvert || showBan || showWhatsApp || showSms || showEmail || showSearchDropdown || showHistoryModal || showTranscribeModal || showComment;

  const currentLead = filteredLeads[activeIndex] ?? null;

  const handleOpenCallHistory = async () => {
    if (!currentLead) return;
    setCallHistoryLoading(true);
    setShowCallHistoryModal(true);
    try {
      const res = await axios.get(`${API_URL}/api/leads/${currentLead.leadId}/call-recordings`, {
        headers: authHeader(),
      });
      setCallHistoryData(res.data || []);
    } catch (err) {
      console.error("Error fetching call history", err);
      toast.error("Failed to fetch call history");
      setCallHistoryData([]);
    } finally {
      setCallHistoryLoading(false);
    }
  };

  const handleCall = async () => {
    if (!currentLead) return;

    try {
      let loginEmail = "";
      let loginAccountType = stableUser.accountType;

      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          loginEmail = payload.email || payload.sub || "";
          if (payload.accountType) loginAccountType = payload.accountType;
        } catch (e) {
          console.error("Token payload extraction error:", e);
        }
      }

      await axios.post(
        `${API_URL}/api/leads/${currentLead.leadId}/click-to-call`,
        {
          loginAccountType: loginAccountType,
          loginEmail: loginEmail,
          loginMobileNo: loginMobileNo
        },
        { headers: { ...authHeader(), "Content-Type": "application/json" } }
      );
      toast.success("Call initiated!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to initiate call.");
    }
  };

  const handleOpenSms = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/smsTemplates/company/${companyId}`, { headers: authHeader() });
      setSmsTemplates(res.data?.smsTemplates || res.data || []);
    } catch (err) { console.error("Failed to fetch SMS templates:", err); }
    setShowSms(true);
  };

  const handleOpenEmail = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/emailTemplates/company/${companyId}`, { headers: authHeader() });
      setEmailTemplates(res.data?.emailTemplates || res.data || []);
    } catch (err) { console.error("Failed to fetch Email templates:", err); }
    setShowEmail(true);
  };

  const handleOpenWhatsApp = async () => {
    if (!waApiKey) {
      toast.error("WhatsApp API Key is not configured for this company.");
      return;
    }

    try {
      const res = await axios.get(`https://waapi.deetyasoft.com/api/lms/whatsapp-config/getTemplate?apiKey=${waApiKey}`);
      setWhatsappTemplates(res.data?.templates || res.data?.data || res.data || []);
      setShowWhatsApp(true);
    } catch (err) {
      console.error("Failed to fetch WhatsApp templates:", err);
      toast.error("Failed to load WhatsApp templates.");
    }
  };

  const handleOpenHistory = async () => {
    if (!currentLead) return;
    setHistoryLoading(true);
    setShowHistoryModal(true);
    try {
      const res = await axios.get(`${API_URL}/api/leadHistory/${currentLead.leadId}`, {
        headers: authHeader(),
      });
      setHistoryData(res.data?.content || []);
    } catch (err) {
      console.error("Error fetching lead history", err);
      toast.error("Failed to fetch lead history");
      setHistoryData([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "x") {
        if (anyModalOpen) {
          setShowStatus(false);
          setShowFollowUp(false);
          setShowAppointment(false);
          setShowLabel(false);
          setShowConvert(false);
          setShowBan(false);
          setShowWhatsApp(false);
          setShowSms(false);
          setShowEmail(false);
          setShowSearchDropdown(false);
          setShowHistoryModal(false);
          return;
        }
      }

      if (anyModalOpen) return;

      const tag = e.target.tagName;
      const isInput = tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";

      if (isInput) return;

      if (e.key === "ArrowRight") setActiveIndex((i) => Math.min(i + 1, filteredLeads.length - 1));
      if (e.key === "ArrowLeft") setActiveIndex((i) => Math.max(i - 1, 0));
      if (e.key === "1") handleCall();
      if (e.key === "2") handleOpenSms();
      if (e.key === "3") handleOpenWhatsApp();
      if (e.key === "4") handleOpenEmail();

      const key = e.key.toLowerCase();
      if (key === "s") setShowStatus(true);
      if (key === "f") setShowFollowUp(true);
      if (key === "a") setShowAppointment(true);
      if (key === "p") setShowLabel(true);
      if (key === "c") {
        if (!currentLead?.isConvertedLead) setShowConvert(true);
      }
      if (key === "b") setShowBan(true);
    };

    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, [filteredLeads.length, anyModalOpen, currentLead, loginMobileNo, stableUser, companyId]);

  const handleStatusChange = async (statusName, reason) => {
    if (!currentLead) return;
    const status = statuses.find((s) => s.name === statusName);
    try {
      await axios.put(
        `${API_URL}/api/leads/update/${currentLead.leadId}/changedBy/${stableUser.id}`,
        { statusName, statusColor: status?.color, reason },
        { headers: authHeader() }
      );

      setStatusCounts(prev => ({
        ...prev,
        [currentLead.statusName]: Math.max(0, (prev[currentLead.statusName] || 0) - 1),
        [statusName]: (prev[statusName] || 0) + 1
      }));

      setAllLeads((prev) => prev.map((l) => String(l.leadId) === String(currentLead.leadId) ? { ...l, statusName, statusColor: status?.color } : l));
      setShowStatus(false);
    } catch (err) { console.error(err); }
  };

  const handleFollowUpSubmit = async (data) => {
    if (!currentLead) return;
    try {
      await fetch(`${API_URL}/api/leads/${currentLead.leadId}/followups`, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, createdById: stableUser.id, companyId }),
      });
      setShowFollowUp(false);
    } catch (err) { console.error(err); }
  };

  const handleAssign = async (userId) => {
    if (!currentLead) return;
    try {
      await axios.put(`${API_URL}/api/leads/assign/${userId}/${stableUser.id}`, [currentLead.leadId], { headers: authHeader() });
      const assignedUser = users.find((u) => String(u.id) === String(userId));
      updateLeadInQueue(currentLead.leadId, {
        assignedToId: userId,
        assignedToName: assignedUser ? `${assignedUser.fname} ${assignedUser.lname}` : currentLead.assignedToName,
      });
      toast.success("Lead assigned successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to assign lead.");
    }
  };

  const handleLabel = async (labelId) => {
    if (!currentLead) return;
    try {
      await axios.put(`${API_URL}/api/leads/assignProjectName/${labelId}/${stableUser.id}`, [currentLead.leadId], { headers: authHeader() });
      setShowLabel(false);
    } catch (err) { console.error(err); }
  };

  const handleConvert = async () => {
    if (!currentLead) return;
    try {
      await axios.post(`${API_URL}/api/convertedLeads`, { ...currentLead, companyId, convertedById: stableUser.id }, { headers: authHeader() });
      setShowConvert(false);
    } catch (err) { console.error(err); }
  };

  const handleBan = async (reason) => {
    if (!currentLead) return;
    try {
      await axios.post(`${API_URL}/api/blacklist`, { createdById: stableUser.id, leadId: currentLead.leadId, reason, companyId }, { headers: authHeader() });
      setAllLeads((prev) => prev.filter((l) => String(l.leadId) !== String(currentLead.leadId)));

      setStatusCounts(prev => ({
        ...prev,
        [currentLead.statusName]: Math.max(0, (prev[currentLead.statusName] || 0) - 1)
      }));

      setShowBan(false);
    } catch (err) { console.error(err); }
  };

  const handleSendWhatsApp = async (templateName, variableValues = {}) => {
    if (!waApiKey) {
      toast.error("WhatsApp API Key is missing!");
      return;
    }

    if (!currentLead?.phone) {
      toast.error("Lead has no phone number");
      return;
    }
    const cleaned = currentLead.phone.replace(/\D/g, "");
    const phone = cleaned.startsWith("91") && cleaned.length === 12 ? cleaned : cleaned.length === 10 ? `91${cleaned}` : cleaned;

    const fd = new FormData();
    fd.append("apiKey", waApiKey);
    fd.append("templateName", templateName);
    fd.append("to", phone);

    const varKeys = Object.keys(variableValues).sort((a, b) => parseInt(a) - parseInt(b));
    if (varKeys.length > 0) {
      const manualVars = varKeys.map(key => variableValues[key] || "").join(",");
      fd.append("manualVars", manualVars);
    }

    try {
      await axios.post(`https://waapi.deetyasoft.com/api/lms/whatsapp-config/sendVerifiedTemplates`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("WhatsApp message sent!");
      setShowWhatsApp(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to send WhatsApp message.");
    }
  };

  const handleSendSms = async (messageId, variables) => {
    if (!currentLead?.phone) return toast.error("Lead has no phone number");
    try {
      await axios.post(
        `${API_URL}/api/smsConfig/send/${companyId}?createdById=${stableUser.id}`,
        {
          clientNumber: [currentLead.phone],
          messageId: messageId,
          variables: variables
        },
        { headers: { ...authHeader(), "Content-Type": "application/json" } }
      );
      toast.success("SMS sent successfully!");
      setShowSms(false);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to send SMS message.");
    }
  };

  const handleSendEmail = async (templateId, variables) => {
    if (!currentLead?.email) return toast.error("Lead has no email address");

    setSendingEmailId(templateId);

    try {
      const response = await fetch(`${API_URL}/api/leads/${templateId}/sendEmail/${companyId}/${stableUser.id}/${currentLead.email}`, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(variables)
      });

      if (response.ok) {
        toast.success("Email sent successfully!");
        setShowEmail(false);
      } else {
        toast.error("Failed to send Email.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to send Email message.");
    } finally {
      setSendingEmailId(null);
    }
  };

  const updateLeadInQueue = (leadId, updatedFields) => {
    setAllLeads((prev) =>
      prev.map((l) => (String(l.leadId) === String(leadId) ? { ...l, ...updatedFields } : l))
    );
  };

  const handleInlineEdit = async (field, value) => {
    if (!currentLead) return;
    try {
      await axios.put(
        `${API_URL}/api/leads/update/${currentLead.leadId}/changedBy/${stableUser.id}`,
        { [field]: value },
        { headers: authHeader() }
      );
      updateLeadInQueue(currentLead.leadId, { [field]: value });

      if (showHistoryModal) {
        handleOpenHistory();
      }
    } catch (err) {
      if (err.response?.status === 409) {
        toast.error(err.response.data.message || "A lead with this number already exists");
      } else {
        toast.error("Failed to update lead details.");
      }
      console.error("Failed to update field", err);
    }
  };


  const handleCustomFieldEdit = async (field, value) => {
    if (!currentLead) return;
    try {
      // Backend ke hisaab se nested customFields object banayenge
      const updatedCustomFields = {
        ...(currentLead.customFields || {}),
        [field]: value,
      };

      await axios.put(
        `${API_URL}/api/leads/update/${currentLead.leadId}/changedBy/${stableUser.id}`,
        { 
          [field]: value, // Flat field mapping
          customFields: updatedCustomFields // Nested object mapping
        },
        { headers: authHeader() }
      );
      
      // UI queue me state update karo
      updateLeadInQueue(currentLead.leadId, { 
        [field]: value,
        customFields: updatedCustomFields
      });

      if (showHistoryModal) {
        handleOpenHistory();
      }
    } catch (err) {
      if (err.response?.status === 409) {
        toast.error(err.response.data.message || "A lead with this number already exists");
      } else {
        toast.error("Failed to update custom field.");
      }
      console.error("Failed to update custom field", err);
    }
  };
  const handleAssignedToChange = (field, value) => {
    if (!value) return;
    const matchedUser = users.find((u) => `${u.fname} ${u.lname}` === value);
    if (matchedUser) handleAssign(matchedUser.id);
  };

  const openCommentModal = () => {
    setCommentDraft(currentLead?.comment || "");
    setShowComment(true);
  };

  const handleCommentSave = async () => {
    const raw = commentDraft || "";
    const trimmed = raw.trim();

    if (raw.length > 0 && trimmed === "") {
      toast.error("Comment cannot contain only spaces.");
      return;
    }

    const original = (currentLead?.comment || "").trim();
    if (trimmed !== original) {
      await handleInlineEdit("comment", trimmed);
    }
    setShowComment(false);
  };

  const availableActions = [
    { label: "Call", icon: "📞", onClick: handleCall },
    { label: "SMS", icon: "💬", onClick: handleOpenSms },
    { label: "WhatsApp", icon: <SGWhatsAppIcon />, onClick: handleOpenWhatsApp },
    { label: "Email", icon: "✉️", onClick: handleOpenEmail },
    { label: "Change Status", icon: "🔄", onClick: () => setShowStatus(true) },
    { label: "Add Follow-up", icon: "📅", onClick: () => setShowFollowUp(true) },
    { label: "Appointment", icon: "🗓️", onClick: () => setShowAppointment(true) },
    { label: "Assign Project", icon: "🏷️", onClick: () => setShowLabel(true) },
    { label: "Convert to Customer", icon: "✅", onClick: () => setShowConvert(true), disabled: currentLead?.isConvertedLead },
    { label: "Block Lead", icon: "🚫", onClick: () => setShowBan(true) }
  ];

  const lowerQuery = searchQuery.toLowerCase();
  const matchedLeads = searchQuery ? allLeads.filter(l =>
    (l.name && l.name.toLowerCase().includes(lowerQuery)) ||
    (l.phone && l.phone.includes(lowerQuery))
  ).slice(0, 5) : [];

  const matchedActions = searchQuery ? availableActions.filter(a =>
    a.label.toLowerCase().includes(lowerQuery) && !a.disabled
  ) : [];

  const handleSearchSelectLead = (lead) => {
    setActiveStatus((lead.statusName || "").trim());
    const leadsInStatus = allLeads.filter((l) => l.statusName === lead.statusName);
    const idx = leadsInStatus.findIndex((l) => String(l.leadId) === String(lead.leadId));
    if (idx !== -1) setActiveIndex(idx);
    setSearchQuery("");
    setShowSearchDropdown(false);
  };

  const handleSearchSelectAction = (action) => {
    action.onClick();
    setSearchQuery("");
    setShowSearchDropdown(false);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      if (matchedLeads.length > 0) handleSearchSelectLead(matchedLeads[0]);
      else if (matchedActions.length > 0) handleSearchSelectAction(matchedActions[0]);
    }
  };

  const fetchMoreLeads = useCallback(async () => {
    if (!hasMoreApiLeads || fetchingMore) return;
    setFetchingMore(true);
    try {
      const nextApiPage = apiPage + 1;
      const url = isOwnerLevel(stableUser.accountType)
        ? `${API_URL}/api/leads/company/${companyId}?pageNumber=${nextApiPage}&pageSize=200`
        : `${API_URL}/api/leads/assigned/${stableUser.id}?pageNumber=${nextApiPage}&pageSize=200`;

      const res = await axios.get(url, { headers: authHeader() });
      const newLeads = res.data?.leads || [];

      if (newLeads.length < 200) {
        setHasMoreApiLeads(false);
      }

      setAllLeads((prev) => {
        const existingIds = new Set(prev.map(l => String(l.leadId)));
        const uniqueNewLeads = newLeads.filter(l => l.leadId && !existingIds.has(String(l.leadId)));
        return [...prev, ...uniqueNewLeads];
      });

      setApiPage(nextApiPage);
    } catch (err) {
      console.error("Failed to auto fetch more leads.", err);
    } finally {
      setFetchingMore(false);
    }
  }, [apiPage, hasMoreApiLeads, fetchingMore, companyId, stableUser]);

  const totalLeadPages = Math.ceil(filteredLeads.length / leadsPerPage);

  useEffect(() => {
    if (leadPage > 0 && totalLeadPages > 0 && leadPage >= totalLeadPages - 2 && hasMoreApiLeads && !fetchingMore) {
      fetchMoreLeads();
    }
  }, [leadPage, totalLeadPages, hasMoreApiLeads, fetchingMore, fetchMoreLeads]);

  if (authLoading || !isAuthenticated) return null;

  if (splash) {
    return (
      <>
        <style>{SG_CSS}</style>
        <div className="sg2-splash">
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100, damping: 20 }}
            className="sg2-splash-text"
          >
            Sales God
          </motion.div>
        </div>
      </>
    );
  }

  const nextFollowUp = currentLead?.followUps?.[0];
  const paginatedLeads = filteredLeads.slice(leadPage * leadsPerPage, (leadPage + 1) * leadsPerPage);

  const handleNextLeadPage = async () => {
    const nextPage = leadPage + 1;
    const currentTotalPages = Math.ceil(filteredLeads.length / leadsPerPage);

    if (nextPage < currentTotalPages) {
      setActiveIndex(nextPage * leadsPerPage);
    } else if (hasMoreApiLeads && !fetchingMore) {
      fetchMoreLeads();
    }
  };

  const handlePrevLeadPage = () => {
    const prevPage = leadPage - 1;
    if (prevPage >= 0) {
      setActiveIndex(prevPage * leadsPerPage);
    }
  };

  return (
    <>
      <style>{SG_CSS}</style>
      <div className="sg2-overlay">

        {/* ── HEADER ─────────────────────────────────────────────────────────── */}
        <div className="sg2-header">
          {/* Left: Title + count */}
          <div className="sg2-header-title">
            <span className="sg2-header-brand">Sales God</span>
            {currentLead && (
              <span className="sg2-header-count">{activeIndex + 1} / {statusCounts[activeStatus] || filteredLeads.length}</span>
            )}
          </div>

          {/* Center: Status bar */}
          <div className="sg2-status-bar">
            {statuses.map((s) => (
              <button
                key={s.leadStatusId || s.name}
                onClick={() => setActiveStatus(s.name)}
                className={`sg2-status-btn ${activeStatus === s.name ? "sg2-status-btn--active" : "sg2-status-btn--inactive"}`}
              >
                {s.name}
                <span className="sg2-status-count">{statusCounts[s.name] || 0}</span>
              </button>
            ))}
          </div>

          {/* Right: Search + close */}
          <div className="sg2-header-right">

            <div className="sg2-search-container" ref={searchContainerRef}>
              <span className="sg2-search-icon">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#673AB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </span>
              <input
                type="text"
                placeholder="Search leads or actions..."
                className="sg2-search-input"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setShowSearchDropdown(true);
                }}
                onKeyDown={handleSearchKeyDown}
                onFocus={() => setShowSearchDropdown(true)}
              />
              <AnimatePresence>
                {showSearchDropdown && searchQuery && (matchedLeads.length > 0 || matchedActions.length > 0) && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.15 }}
                    className="sg2-search-dropdown"
                  >
                    {matchedLeads.length > 0 && (
                      <div className="sg2-search-group">
                        <div className="sg2-search-group-title">Leads</div>
                        {matchedLeads.map((l) => (
                          <div key={l.leadId} className="sg2-search-item" onClick={() => handleSearchSelectLead(l)}>
                            <SGAvatar name={l.name || "?"} size={24} />
                            <div className="sg2-search-item-info">
                              <span className="sg2-search-item-name">{l.name}</span>
                              <span className="sg2-search-item-phone">{l.phone}</span>
                            </div>
                            <span className="sg2-status-pill sg2-search-pill" style={{ background: l.statusColor || "#0C4550" }}>{l.statusName}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {matchedActions.length > 0 && (
                      <div className="sg2-search-group">
                        <div className="sg2-search-group-title">Actions</div>
                        {matchedActions.map((a) => (
                          <div key={a.label} className="sg2-search-item" onClick={() => handleSearchSelectAction(a)}>
                            <span className="sg2-search-item-icon">{a.icon}</span>
                            <span className="sg2-search-item-name">{a.label}</span>
                            <span className="sg2-search-hint">↵ Enter</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {isIncomingModeOn && (
              <button
                onClick={() => navigate("/dashboard/incoming-mode")}
                className="sg2-incoming-btn"
                title="Open live incoming-call feed"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                Incoming Mode
              </button>
            )}

            <button onClick={() => navigate(-1)} className="sg2-close-btn">✕</button>
          </div>
        </div>

        {/* ── BODY ───────────────────────────────────────────────────────────── */}
        <div className="sg2-body">
          {loading ? (
            <div className="sg2-centered"><div className="sg2-spinner sg2-spinner--lg" /></div>
          ) : filteredLeads.length === 0 ? (
            <div className="sg2-centered"><p className="sg2-empty">No leads in this status.</p></div>
          ) : (
            <>
              {/* ── WORKSPACE ──────────────────────────────────────────────── */}
              <div className="sg2-workspace">

                {/* LEFT: Lead detail */}
                <div className="sg2-detail-panel">
                  <AnimatePresence mode="wait">
                    {currentLead && (
                      <motion.div
                        key={currentLead.leadId}
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -20 }}
                        transition={{ duration: 0.18 }}
                        style={{ display: "flex", flexDirection: "column", gap: 20, height: "100%" }}
                      >
                        {/* Identity - Top Row Structure */}
                        <div className="sg2-lead-identity-top">
                          <SGAvatar name={currentLead.name || "?"} size={56} />
                          <div className="sg2-lead-top-details" style={{ width: "100%" }}>
                            <SGEditableField className="sg2-lead-name" value={currentLead.name} onSave={(v) => handleInlineEdit('name', v)} label="Name" />

                            <div className="sg2-lead-top-row-info" style={{ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap", gap: "10px" }}>

                              {/* LEFT SIDE: Contact Info */}
                              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                <span className="sg2-contact-badge">
                                  <span className="sg2-badge-icon">📞</span>
                                  {isPhoneMasked(currentLead.phone) ? (
                                    <span className="sg2-header-inline" title="Phone number is hidden">{currentLead.phone}</span>
                                  ) : (
                                    <SGEditableField className="sg2-header-inline" value={currentLead.phone} onSave={(v) => handleInlineEdit('phone', v)} label="Phone" />
                                  )}
                                </span>
                                <span className="sg2-contact-badge">
                                  <span className="sg2-badge-icon">✉️</span>
                                  <SGEditableField className="sg2-header-inline" value={currentLead.email} onSave={(v) => handleInlineEdit('email', v)} label="Email" />
                                </span>
                                <span className="sg2-contact-badge">
                                  <span className="sg2-badge-icon">🏢</span>
                                  <SGEditableField className="sg2-header-inline" value={currentLead.companyName} onSave={(v) => handleInlineEdit('companyName', v)} label="Company" />
                                </span>
                              </div>

                              {/* RIGHT SIDE: Call History -> Lead History -> Status */}
                              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                                <button
                                  className="sg2-history-trigger-btn"
                                  onClick={handleOpenCallHistory}
                                  title="Call History"
                                  style={{ padding: "4px 10px", marginLeft: 0 }}
                                >
                                  <span className="sg2-badge-icon">🎙️</span>
                                  <span>Call History</span>
                                </button>

                                <button
                                  className="sg2-history-trigger-btn"
                                  onClick={() => setShowTranscribeModal(true)}
                                  title="Transcribe & Rate Calls"
                                  style={{ padding: "4px 10px", marginLeft: 0 }}
                                >
                                  <span className="sg2-badge-icon">📝</span>
                                  <span>Transcribe</span>
                                </button>

                                <button
                                  className="sg2-history-trigger-btn"
                                  onClick={handleOpenHistory}
                                  title="Lead History"
                                  style={{ padding: "4px 10px", marginLeft: 0 }}
                                >
                                  <span className="sg2-badge-icon">🕘</span>
                                  <span>Lead History</span>
                                </button>

                                <span className="sg2-status-pill" style={{ background: currentLead.statusColor || "#0C4550", marginLeft: 0, padding: "4px 12px" }}>
                                  {currentLead.statusName}
                                </span>
                              </div>

                            </div>
                          </div>
                        </div>

                        {/* Info grid - Modernized Cards */}
                        <div className="sg2-info-grid">
                          <SGInfoRow icon="📋" label="Project" value={currentLead.projectName} field="projectName" onSave={handleInlineEdit} options={labels} />
                          <SGInfoRow icon="🔗" label="Source" value={currentLead.sourceName} field="sourceName" onSave={handleInlineEdit} />
                          <SGInfoRow
                            icon="👤"
                            label="Assigned to"
                            value={currentLead.assignedToName}
                            field="assignedToName"
                            onSave={handleAssignedToChange}
                            options={users.map((u) => ({ name: `${u.fname} ${u.lname}` }))}
                          />
                          <SGInfoRow icon="👤" label="Created by" value={currentLead.createdByName} />
                          <SGInfoRow icon="📍" label="City" value={currentLead.city} field="city" onSave={handleInlineEdit} />
                          <SGInfoRow icon="📍" label="State" value={currentLead.state} field="state" onSave={handleInlineEdit} />
                          <SGInfoRow icon="🏠" label="Address" value={currentLead.address} field="address" onSave={handleInlineEdit} />
                          {nextFollowUp?.nextFollowUpDate && (
                            <SGInfoRow icon="⏰" label="Next follow-up" value={`${nextFollowUp.nextFollowUpDate}${nextFollowUp.nextFollowUpTime ? " " + nextFollowUp.nextFollowUpTime.substring(0, 5) : ""}`} />
                          )}
                          <SGInfoRow icon="📅" label="Added on" value={currentLead.createdAt ? new Date(currentLead.createdAt).toLocaleDateString("en-IN") : ""} />
                          <SGInfoRow icon="📱" label="Alt. contact" value={currentLead.otherContactNo} field="otherContactNo" onSave={handleInlineEdit} />
                          {currentLead.leadDate && (
                            <SGInfoRow icon="📆" label="Lead date" value={new Date(currentLead.leadDate).toLocaleDateString("en-IN")} />
                          )}
                          {nextFollowUp?.lastFollowUpDate && (
                            <SGInfoRow icon="🕓" label="Last follow-up" value={new Date(nextFollowUp.lastFollowUpDate).toLocaleDateString("en-IN")} />
                          )}
                          <SGInfoRow icon="✅" label="Converted" value={currentLead.isConvertedLead ? "Yes" : "No"} />

                          <SGCommentRow value={currentLead.comment} onClick={openCommentModal} />
                        </div>
{/* Additional fields configured on the Lead Config page (fetched via GET API) */}
{customFields.length > 0 && (
  <div className="sg2-custom-fields-section">
    <div className="sg2-section-title">Additional fields</div>
    <div className="sg2-custom-fields-scroll">
      <div className="sg2-info-grid">
        {customFields.map((field) => {
          const val = currentLead?.customFields?.[field.fieldKey] ?? currentLead?.[field.fieldKey];

          let fieldOptions = undefined;
          let inputType = "text";
          
          if (field.fieldType === "DROPDOWN") {
            inputType = "DROPDOWN";
            fieldOptions = (typeof field.options === 'string' ? field.options.split(',') : (field.options || [])).map((o) => ({ name: typeof o === 'string' ? o.trim() : o }));
          } else if (field.fieldType === "YES_NO" || field.fieldType === "BOOLEAN") {
            inputType = field.fieldType;
          }

          return (
            <SGInfoRow
              key={field.id || field.fieldKey}
              icon="🧩"
              label={field.label}
              value={val}
              field={field.fieldKey}
              type={inputType}
              onSave={handleCustomFieldEdit} 
              options={fieldOptions}
            />
          );
        })}
      </div>
    </div>
  </div>
)}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                {/* RIGHT: Actions */}
                <div className="sg2-actions-panel">

                  {/* Communication hub */}
                  <div className="sg2-section">
                    <div className="sg2-section-title-wrap">
                      <div className="sg2-section-title">Communication</div>
                      <div className="sg2-comm-info-container" ref={commInfoRef}>
                        <button
                          className="sg2-comm-info-btn"
                          onClick={() => setShowCommInfo(!showCommInfo)}
                          title="Shortcuts Info"
                        >
                          ⋮
                        </button>
                        <AnimatePresence>
                          {showCommInfo && (
                            <motion.div
                              initial={{ opacity: 0, y: 5 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: 5 }}
                              transition={{ duration: 0.15 }}
                              className="sg2-comm-info-popover"
                            >
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">1</span> for Call</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">2</span> for SMS</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">3</span> for WhatsApp</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">4</span> for Email</div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>
                    <div className="sg2-comm-grid">
                      <SGCommBtn icon="📞" label="Call" shortcut="1" color="#16a34a" onClick={handleCall} />
                      <SGCommBtn icon="💬" label="SMS" shortcut="2" color="#2563eb" onClick={handleOpenSms} />
                      <SGCommBtn icon={<SGWhatsAppIcon />} label="WhatsApp" shortcut="3" color="#16a34a" onClick={handleOpenWhatsApp} />
                      <SGCommBtn icon="✉️" label="Email" shortcut="4" color="#dc2626" onClick={handleOpenEmail} />
                    </div>
                  </div>

                  {/* Lead management */}
                  <div className="sg2-section">
                    <div className="sg2-section-title-wrap">
                      <div className="sg2-section-title">Lead management</div>
                      <div className="sg2-comm-info-container" ref={leadInfoRef}>
                        <button
                          className="sg2-comm-info-btn"
                          onClick={() => setShowLeadInfo(!showLeadInfo)}
                          title="Shortcuts Info"
                        >
                          ⋮
                        </button>
                        <AnimatePresence>
                          {showLeadInfo && (
                            <motion.div
                              initial={{ opacity: 0, y: 5 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: 5 }}
                              transition={{ duration: 0.15 }}
                              className="sg2-comm-info-popover"
                            >
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">S</span> for Status</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">F</span> for Follow-up</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">A</span> for Appointment</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">P</span> for Project</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">C</span> for Convert</div>
                              <div className="sg2-comm-info-row">Press <span className="sg2-red-dotted-box">B</span> for Block</div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>
                    <div className="sg2-actions-grid">
                      <SGActionBtn icon="🔄" label="Status" shortcut="S" onClick={() => setShowStatus(true)} />
                      <SGActionBtn icon="📅" label="Follow-up" shortcut="F" onClick={() => setShowFollowUp(true)} />
                      <SGActionBtn icon="🗓️" label="Appointment" shortcut="A" onClick={() => setShowAppointment(true)} />
                      <SGActionBtn icon="🏷️" label="Project" shortcut="P" onClick={() => setShowLabel(true)} />
                      <SGActionBtn icon="✅" label="Convert" shortcut="C" onClick={() => setShowConvert(true)} variant="success" disabled={currentLead?.isConvertedLead} />
                      <SGActionBtn icon="🚫" label="Block" shortcut="B" onClick={() => setShowBan(true)} variant="danger" />
                    </div>
                  </div>

                  {/* Tags */}
                  {currentLead?.tag && (
                    <div className="sg2-section">
                      <div className="sg2-section-title">Tags</div>
                      <div className="sg2-tags">
                        {(Array.isArray(currentLead.tag) ? currentLead.tag : [currentLead.tag]).map((t, i) => (
                          <span key={i} className="sg2-tag">{t}</span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* ── LEAD QUEUE ─────────────────────────────────────────────── */}
              <div className="sg2-queue-wrap">
                <button className="sg2-queue-nav" disabled={leadPage === 0} onClick={handlePrevLeadPage}>←</button>
                <div className="sg2-queue-track">
                  {paginatedLeads.map((lead, i) => {
                    const actualIndex = leadPage * leadsPerPage + i;
                    return (
                      <SGQueueCard
                        key={String(lead.leadId || actualIndex)}
                        lead={lead}
                        index={actualIndex}
                        isActive={actualIndex === activeIndex}
                        onClick={() => setActiveIndex(actualIndex)}
                      />
                    );
                  })}
                </div>
                <button
                  className="sg2-queue-nav"
                  disabled={(leadPage >= Math.ceil(filteredLeads.length / leadsPerPage) - 1 && !hasMoreApiLeads) || fetchingMore}
                  onClick={handleNextLeadPage}
                >
                  {fetchingMore ? "..." : "→"}
                </button>
              </div>
            </>
          )}
        </div>

        {/* ── INLINE SUB-MODALS ──────────────────────────────────────────────── */}
        <SGStatusModal open={showStatus} statuses={statuses} currentStatus={currentLead?.statusName} onConfirm={handleStatusChange} onClose={() => setShowStatus(false)} />
        <SGFollowUpModal open={showFollowUp} users={users} onClose={() => setShowFollowUp(false)} onSubmit={handleFollowUpSubmit} loggedInUser={stableUser} />
        <SGAppointmentModal open={showAppointment} lead={currentLead} companyId={companyId} stableUser={stableUser} users={users} onClose={() => setShowAppointment(false)} onScheduled={() => { }} />
        <SGLabelModal open={showLabel} labels={labels} onClose={() => setShowLabel(false)} onConfirm={handleLabel} />
        <SGConvertModal open={showConvert} onClose={() => setShowConvert(false)} onConfirm={handleConvert} />
        <SGBanModal open={showBan} onClose={() => setShowBan(false)} onConfirm={handleBan} />
        <SGWhatsAppModal open={showWhatsApp} templates={whatsappTemplates} onClose={() => setShowWhatsApp(false)} onSend={handleSendWhatsApp} />
        <SGSmsModal open={showSms} templates={smsTemplates} onClose={() => setShowSms(false)} onSend={handleSendSms} />
        <SGEmailModal open={showEmail} templates={emailTemplates} onClose={() => setShowEmail(false)} onSend={handleSendEmail} sendingEmailId={sendingEmailId} />
        <SGHistoryModal open={showHistoryModal} lead={currentLead} historyData={historyData} loading={historyLoading} onClose={() => setShowHistoryModal(false)} />
        <SGCallHistoryModal open={showCallHistoryModal} lead={currentLead} data={callHistoryData} loading={callHistoryLoading} onClose={() => setShowCallHistoryModal(false)} />
        <SGTranscribeModal open={showTranscribeModal} lead={currentLead} companyId={companyId} onClose={() => setShowTranscribeModal(false)} onLeadUpdated={updateLeadInQueue} />
        <SGCommentModal open={showComment} value={commentDraft} onChange={setCommentDraft} onSave={handleCommentSave} onClose={() => setShowComment(false)} />
      </div>
    </>
  );
};

// ──────────────────────────────────────────────────────────────────────────────
//  CSS
// ──────────────────────────────────────────────────────────────────────────────
const SG_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

  /* Loading Spinner for SG */
  .sg2-spinner { width: 24px; height: 24px; border: 2.5px solid #e5e9f0; border-top-color: #0C4550; border-radius: 50%; animation: sg-spin .7s linear infinite; }
  .sg2-spinner--lg { width: 40px; height: 40px; border-width: 3.5px; }
  @keyframes sg-spin { to { transform: rotate(360deg); } }

  .sg2-splash {
    position: fixed; inset: 0; z-index: 9999;
    background-color: #EEF2FC;
    background-image:
      radial-gradient(circle at 50% 50%, rgba(103,58,183,0.06) 0%, rgba(238,242,252,0) 60%),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='220' height='220' viewBox='0 0 220 220'%3E%3Cg fill='none' stroke='%23673AB7' stroke-width='1.4' opacity='0.09'%3E%3Cpath d='M30 40c0-4 3-7 7-7h10l4 8-5 5c2 6 6 10 12 12l5-5 8 4v10c0 4-3 7-7 7-19 0-34-15-34-34z'/%3E%3Crect x='120' y='20' width='26' height='20' rx='4'/%3E%3Cpath d='M120 40l13 8 13-8'/%3E%3Ccircle cx='180' cy='90' r='11'/%3E%3Cpath d='M172 106c0-6 5-10 11-10h6c6 0 11 4 11 10'/%3E%3Cpath d='M20 120h24M20 128h16M20 136h20'/%3E%3Cpath d='M60 150l6 6 12-13'/%3E%3Ccircle cx='60' cy='150' r='16'/%3E%3Cpath d='M140 130v30M130 150h20'/%3E%3Crect x='125' y='125' width='30' height='30' rx='6'/%3E%3Cpath d='M20 190h12l4-10 6 20 6-15 4 5h10'/%3E%3C/g%3E%3C/svg%3E");
    background-repeat: repeat, repeat;
    background-size: auto, 220px 220px;
    display: flex; align-items: center; justify-content: center;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  
  .sg2-splash-text {
    font-size: 64px; font-weight: 700;
    color: #673AB7; letter-spacing: -1.5px;
  }

  .sg2-overlay {
    position: fixed; inset: 0; z-index: 9998;
    background: #f0f4f8;
    display: flex; flex-direction: column;
    font-family: 'Plus Jakarta Sans', sans-serif;
    overflow: hidden;
  }

  /* Header */
  .sg2-header {
    background: #fff;
    border-bottom: 1px solid #e5e9f0;
    padding: 10px 24px;
    min-height: 60px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px 16px;
    box-shadow: 0 1px 4px rgba(0,0,0,.05);
    flex-shrink: 0;
    z-index: 10;
  }
  .sg2-header-title {
    display: flex; align-items: baseline; gap: 10px;
    flex-shrink: 0; min-width: 140px;
  }
  .sg2-header-brand { font-size: 20px; font-weight: 700; color: #0C4550; letter-spacing: -0.4px; }
  .sg2-header-count { font-size: 12px; color: #9ca3af; font-weight: 500; }

  .sg2-status-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 8px;
    flex: 1 1 320px; justify-content: center;
    padding: 4px 8px;
    max-height: 96px; overflow-y: auto;
  }
  .sg2-status-bar::-webkit-scrollbar { width: 4px; }
  .sg2-status-bar::-webkit-scrollbar-thumb { background: #d8dee8; border-radius: 4px; }
  .sg2-status-btn {
    display: inline-flex; align-items: center; gap: 6px;
    height: 34px; padding: 0 16px; border-radius: 20px;
    font-size: 13px; font-weight: 600; white-space: nowrap;
    cursor: pointer; border: none; transition: all .15s;
    font-family: inherit; flex-shrink: 0;
  }
  .sg2-status-btn--active { background: #0C4550; color: #fff; }
  .sg2-status-btn--inactive { background: #f1f5f9; color: #4b5563; }
  .sg2-status-btn--inactive:hover { background: #e2e8f0; color: #1a1f36; }
  .sg2-status-count {
    background: rgba(255,255,255,0.25); font-size: 11px;
    padding: 1px 6px; border-radius: 10px; font-weight: 700;
  }
  .sg2-status-btn--inactive .sg2-status-count { background: #e2e8f0; color: #6b7280; }

  .sg2-header-right {
    display: flex; align-items: center; gap: 14px;
    flex-shrink: 0; justify-content: flex-end;
  }

  @media (max-width: 900px) {
    .sg2-header { padding: 10px 16px; }
    .sg2-status-bar { flex-basis: 100%; order: 3; max-height: 84px; }
    .sg2-header-title { order: 1; }
    .sg2-header-right { order: 2; }
  }
  @media (max-width: 520px) {
    .sg2-header-brand { font-size: 17px; }
    .sg2-status-btn { height: 30px; padding: 0 12px; font-size: 12px; }
  }
  
  /* NEW SEARCH BAR CSS */
  .sg2-search-container {
    position: relative;
    display: flex;
    align-items: center;
    background: #f8fafc;
    border: 1px solid #e5e9f0;
    border-radius: 20px;
    padding: 6px 14px;
    transition: all 0.2s;
  }
  .sg2-search-container:focus-within {
    background: #fff;
    border-color: #673AB7;
    box-shadow: 0 0 0 3px rgba(103, 58, 183, 0.15);
  }
  .sg2-search-icon {
    display: flex; align-items: center; justify-content: center; margin-right: 8px;
  }
  .sg2-search-input {
    border: none; background: transparent; outline: none;
    font-size: 13px; font-family: inherit; color: #1a1f36; width: 220px;
    transition: width 0.2s;
  }
  .sg2-search-input::placeholder { color: #9ca3af; font-weight: 500; }
  
  .sg2-search-dropdown {
    position: absolute; top: calc(100% + 10px); right: 0; width: 340px;
    background: #fff; border: 1px solid #e5e9f0; border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.1); overflow: hidden; z-index: 100;
    display: flex; flex-direction: column; max-height: 400px; overflow-y: auto;
  }
  .sg2-search-group { display: flex; flex-direction: column; }
  .sg2-search-group:not(:last-child) { border-bottom: 1px solid #f1f5f9; }
  .sg2-search-group-title {
    font-size: 10px; font-weight: 700; color: #9ca3af; text-transform: uppercase;
    padding: 8px 14px; background: #f8fafc; letter-spacing: 0.05em;
  }
  .sg2-search-item {
    display: flex; align-items: center; gap: 12px; padding: 10px 14px;
    cursor: pointer; transition: background 0.15s;
  }
  .sg2-search-item:hover { background: #f1f5f9; }
  .sg2-search-item-info { display: flex; flex-direction: column; flex: 1; min-width: 0; }
  .sg2-search-item-name { font-size: 13px; font-weight: 600; color: #1a1f36; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .sg2-search-item-phone { font-size: 11px; color: #6b7280; margin-top: 2px;}
  .sg2-search-pill { font-size: 10px; padding: 3px 8px; margin-left: auto; border-radius: 10px;}
  .sg2-search-item-icon { font-size: 16px; width: 24px; text-align: center; }
  .sg2-search-hint { font-size: 10px; color: #9ca3af; margin-left: auto; font-weight: 600; background: #f1f5f9; padding: 2px 6px; border-radius: 4px;}

  /* Incoming Mode button */
  .sg2-incoming-btn {
    display: flex; align-items: center; gap: 6px;
    background: #0C4550; color: #fff; border: none;
    height: 32px; padding: 0 14px; border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 12.5px; font-weight: 600;
    cursor: pointer; white-space: nowrap; transition: background 0.15s ease;
  }
  .sg2-incoming-btn:hover { background: #0a3840; }

  .sg2-close-btn {
    background: none !important; border: none; font-size: 20px; color:black !important;
    cursor: pointer; width: 32px; height: 32px; border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
  }

  .sg2-inline-close {
    background: none !important; border: none; font-size: 16px; color: black !important;
    cursor: pointer; width: 28px; height: 28px; border-radius: 6px;
    display: flex; align-items: center; justify-content: center;
  }

  /* Body */
  .sg2-body {
    flex: 1; display: flex; flex-direction: column;
    overflow: hidden; padding: 20px 24px 16px; gap: 16px;
  }
  .sg2-centered { flex: 1; display: flex; align-items: center; justify-content: center; }
  .sg2-empty { color: #9ca3af; font-size: 15px; }

  /* Workspace */
  .sg2-workspace {
    display: grid; grid-template-columns: 1fr 320px;
    gap: 16px; flex: 1; min-height: 0; overflow: hidden;
  }
  @media (max-width: 900px) {
    .sg2-workspace { grid-template-columns: 1fr; overflow-y: auto; }
  }

  /* Detail panel */
  .sg2-detail-panel {
    background: #fff; border: 1px solid #e5e9f0; border-radius: 16px;
    padding: 24px; display: flex; flex-direction: column; gap: 20px;
    overflow-y: auto; box-shadow: 0 1px 4px rgba(0,0,0,.04);
  }

  /* NEW: Top row identity styling */
  .sg2-lead-identity-top {
    display: flex; align-items: center; gap: 18px; flex-wrap: wrap;
    padding-bottom: 20px; border-bottom: 1px solid #f1f5f9;
  }
  .sg2-lead-top-details {
    display: flex; flex-direction: column; gap: 8px; flex: 1; min-width: 250px;
  }
  .sg2-lead-top-row-info {
    display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
  }
  .sg2-contact-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: #f8fafc; border: 1px solid #e2e8f0; padding: 5px 12px; border-radius: 20px;
    transition: background 0.15s;
  }
  .sg2-contact-badge:hover { background: #f1f5f9; }
  .sg2-badge-icon { font-size: 14px; }
  .sg2-status-pill {
    color: #fff; font-size: 12px; font-weight: 600; padding: 6px 16px; 
    border-radius: 20px; white-space: nowrap; flex-shrink: 0; margin-left: auto;
  }

  .sg2-history-trigger-btn {
    display: inline-flex; align-items: center; gap: 6px;
    margin-left: auto;
    background: #f3e8ff; border: 1px solid #e4d3fb; color: #673AB7;
    font-size: 12px; font-weight: 700; padding: 6px 14px; border-radius: 20px;
    cursor: pointer; font-family: inherit; transition: all .15s;
  }
  .sg2-history-trigger-btn:hover { background: #ecdcff; border-color: #d9bffb; transform: translateY(-1px); }

  /* Info Grid */
  .sg2-info-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 12px;
  }
  .sg2-info-row {
    display: flex; align-items: center; gap: 12px;
    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px;
    padding: 12px 16px; transition: all 0.2s;
  }
  .sg2-info-row:hover { background: #f1f5f9; border-color: #cbd5e1; }
  
  .sg2-info-icon {
    font-size: 18px; flex-shrink: 0; background: #fff;
    width: 36px; height: 36px; border-radius: 8px; border: 1px solid #e2e8f0;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 1px 2px rgba(0,0,0,0.03);
  }
  
  .sg2-info-content { display: flex; flex-direction: column; min-width: 0; flex: 1; }
  .sg2-info-label {
    font-size: 11px; color: #4b5563; font-weight: 700; text-transform: uppercase; 
    letter-spacing: .05em; margin-bottom: 2px;
  }
  .sg2-info-value {
    font-size: 14px; color: #111827; font-weight: 600; 
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .sg2-link { color: #0C4550; text-decoration: none; }
  .sg2-link:hover { text-decoration: underline; }

  /* Comment row now sits inline like every other field (small, single-line, click to open editor) */
  .sg2-info-row--comment { cursor: pointer; }

  /* Additional (custom) lead fields configured on the Lead Config page */
  .sg2-custom-fields-section { margin-top: 4px; padding-bottom: 24px; }
  .sg2-custom-fields-scroll {
    /* Removed max-height and overflow-y to let the parent detail panel handle the scrolling properly */
    padding-right: 6px;
    margin-right: -6px;
  }

  /* Actions panel */
  .sg2-actions-panel {
    background: #fff; border: 1px solid #e5e9f0; border-radius: 16px;
    padding: 20px; display: flex; flex-direction: column; gap: 20px;
    overflow-y: auto; box-shadow: 0 1px 4px rgba(0,0,0,.04);
  }
  
  .sg2-section-title-wrap { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
  .sg2-section-title-wrap .sg2-section-title { margin-bottom: 0; }
  .sg2-section-title { font-size: 11px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: .06em; margin-bottom: 10px; }

  .sg2-comm-info-container { position: relative; display: flex; align-items: center; }
  .sg2-comm-info-btn { 
    background: none; border: none; cursor: pointer; font-size: 18px; font-weight: 700;
    color: #9ca3af; padding: 0 4px; line-height: 1; border-radius: 4px; transition: all 0.15s;
  }
  .sg2-comm-info-btn:hover { color: #4b5563; background: #f1f5f9; }
  
  .sg2-comm-info-popover {
    position: absolute; top: 100%; right: 0; margin-top: 6px; background: #fff;
    border: 1px solid #e5e9f0; border-radius: 8px; padding: 12px 14px;
    width: 170px; box-shadow: 0 10px 25px rgba(0,0,0,0.1); z-index: 50;
  }
  .sg2-comm-info-row { font-size: 11px; font-weight: 600; color: #4b5563; margin-bottom: 8px; display: flex; align-items: center; gap: 8px; }
  .sg2-comm-info-row:last-child { margin-bottom: 0; }
  
  .sg2-red-dotted-box {
    border: 1.5px dotted #dc2626; color: #dc2626; font-weight: 700; font-size: 10px;
    width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;
    border-radius: 4px; flex-shrink: 0;
  }

  /* Communication hub */
  .sg2-comm-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  .sg2-comm-btn {
    position: relative;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 6px; padding: 14px 8px; border-radius: 12px;
    border: 1.5px solid color-mix(in srgb, var(--comm-color) 30%, transparent);
    background: color-mix(in srgb, var(--comm-color) 8%, #fff);
    cursor: pointer; transition: background .15s, transform .1s; font-family: inherit;
  }
  .sg2-comm-btn:hover { background: color-mix(in srgb, var(--comm-color) 16%, #fff); transform: translateY(-1px); }
  .sg2-comm-icon { font-size: 22px; display: flex; align-items: center; justify-content: center; }
  .sg2-comm-label { font-size: 12px; font-weight: 600; color: #374151; }

  .sg2-comm-shortcut {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 18px;
    height: 18px;
    border: 1.5px dotted #dc2626;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 700;
    color: #dc2626;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.7);
  }

  /* Management action buttons */
  .sg2-actions-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  .sg2-action-btn {
    position: relative;
    display: flex; flex-direction: column; align-items: center; gap: 5px;
    padding: 12px 8px; border-radius: 10px; border: 1px solid #e5e9f0;
    background: #f8fafc; cursor: pointer; font-family: inherit;
    transition: background .12s, border-color .12s, transform .1s;
  }
  .sg2-action-btn:hover:not(:disabled) { background: #eef2f9; border-color: #c7d2e8; transform: translateY(-1px); }
  .sg2-action-btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .sg2-action-btn--success { border-color: #bbf7d0; background: #f0fdf4; }
  .sg2-action-btn--success:hover:not(:disabled) { background: #dcfce7; }
  .sg2-action-btn--danger { border-color: #fecaca; background: #fff5f5; }
  .sg2-action-btn--danger:hover:not(:disabled) { background: #fee2e2; }
  .sg2-action-icon { font-size: 18px; }
  .sg2-action-label { font-size: 11px; font-weight: 600; color: #374151; text-align: center; }

  /* Tags */
  .sg2-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .sg2-tag { background: #f3e8ff; color: #673AB7; font-size: 12px; font-weight: 600; padding: 4px 10px; border-radius: 20px; }

  /* Lead queue carousel */
  .sg2-queue-wrap {
    display: flex; align-items: center; gap: 10px;
    background: #fff; border: 1px solid #e5e9f0; border-radius: 14px;
    padding: 10px 14px; flex-shrink: 0; box-shadow: 0 1px 3px rgba(0,0,0,.04);
  }
  .sg2-queue-track {
    display: grid; 
    grid-template-columns: repeat(14, minmax(0, 1fr)); 
    gap: 8px; 
    flex: 1; 
    overflow: hidden; 
    padding: 2px 0;
  }

  /* Queue cards (the #1, #2 ... blocks at the bottom).
     !important is used so global button styles (hover / focus / active)
     can never turn the card's text invisible. */
  .sg2-queue-card {
    display: flex; flex-direction: column; align-items: center; gap: 3px;
    padding: 8px 14px; border-radius: 10px;
    border: 1.5px solid #e5e9f0 !important;
    background: #f8fafc !important;
    cursor: pointer; font-family: inherit; outline: none;
    width: 100%; min-width: 0; flex-shrink: 0; transition: all .15s;
  }

  /* inactive card: stays light + readable while hovered / focused / pressed */
  .sg2-queue-card:not(.sg2-queue-card--active):hover,
  .sg2-queue-card:not(.sg2-queue-card--active):focus,
  .sg2-queue-card:not(.sg2-queue-card--active):active {
    background: #eef2f9 !important;
    border-color: #c7d2e8 !important;
  }
  .sg2-queue-card:not(.sg2-queue-card--active) .sg2-queue-num    { color: #9ca3af !important; }
  .sg2-queue-card:not(.sg2-queue-card--active) .sg2-queue-name   { color: #1a1f36 !important; }
  .sg2-queue-card:not(.sg2-queue-card--active) .sg2-queue-status { color: #6b7280 !important; }

  /* active (selected) card: always dark with white text, in every state */
  .sg2-queue-card.sg2-queue-card--active,
  .sg2-queue-card.sg2-queue-card--active:hover,
  .sg2-queue-card.sg2-queue-card--active:focus,
  .sg2-queue-card.sg2-queue-card--active:active {
    background: #0C4550 !important;
    border-color: #0C4550 !important;
    box-shadow: 0 3px 10px rgba(12,69,80,.2);
  }
  .sg2-queue-card--active .sg2-queue-num    { color: rgba(255,255,255,0.7) !important; }
  .sg2-queue-card--active .sg2-queue-name   { color: #ffffff !important; }
  .sg2-queue-card--active .sg2-queue-status { color: rgba(255,255,255,0.8) !important; }

  .sg2-queue-num { font-size: 10px; font-weight: 600; }
  .sg2-queue-name { font-size: 13px; font-weight: 600; white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }
  .sg2-queue-status { font-size: 10px; white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }

  .sg2-queue-nav {
    background: none; border: 1px solid #e5e9f0; border-radius: 8px;
    width: 34px; height: 34px; display: flex; align-items: center; justify-content: center;
    font-size: 16px; cursor: pointer; color: #4b5563;
    transition: background .1s; flex-shrink: 0;
  }
  .sg2-queue-nav:hover:not(:disabled) { background: #f1f5f9; }
  .sg2-queue-nav:disabled { opacity: 0.3; cursor: not-allowed; }

  /* Inline sub-modals */
  .sg2-inline-overlay {
    position: fixed; inset: 0; z-index: 9999;
    background: rgba(0,0,0,.4);
    display: flex; align-items: center; justify-content: center;
    backdrop-filter: blur(2px);
  }
  .sg2-inline-modal {
    background: #fff; border-radius: 16px; width: 100%; max-width: 420px;
    box-shadow: 0 20px 60px rgba(0,0,0,.18); overflow: hidden; margin: 0 16px;
    max-height: 90vh; overflow-y: auto;
  }
  .sg2-sms-modal-container {
    max-width: 750px;
  }
  .sg2-inline-header {
    padding: 16px 20px; border-bottom: 1px solid #f1f5f9;
    display: flex; align-items: center; justify-content: space-between;
    font-size: 15px; font-weight: 700; color: #0C4550;
    position: sticky; top: 0; background: inherit; z-index: 1;
  }
  .sg2-inline-body { padding: 16px 20px; display: flex; flex-direction: column; gap: 2px; }
  .sg2-inline-label { font-size: 12px; font-weight: 600; color: #4b5563; display: block; margin-bottom: 4px; }
  .sg2-inline-select {
    width: 100%; background: #f8fafc; border: 1px solid #e5e9f0; border-radius: 8px;
    padding: 8px 12px; font-size: 13px; color: #1a1f36; font-family: inherit;
    outline: none; transition: border-color .15s; box-sizing: border-box;
  }
  .sg2-inline-select:focus { border-color: #0C4550; background: #fff; }
  .sg2-inline-textarea {
    width: 100%; background: #f8fafc; border: 1px solid #e5e9f0; border-radius: 8px;
    padding: 8px 12px; font-size: 13px; color: #1a1f36; font-family: inherit;
    resize: vertical; outline: none; transition: border-color .15s; box-sizing: border-box;
  }
  .sg2-inline-textarea:focus { border-color: #0C4550; background: #fff; }
  .sg2-inline-footer {
    padding: 12px 20px; border-top: 1px solid #f1f5f9;
    display: flex; gap: 8px; justify-content: flex-end;
    position: sticky; bottom: 0; background: #fff;
  }
  .sg2-ghost-btn {
    background: #f8fafc; color: #4b5563; border: 1px solid #e5e9f0;
    border-radius: 8px; padding: 8px 16px; font-size: 13px; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: background .1s;
  }
  .sg2-ghost-btn:hover { background: #f1f5f9; }
  .sg2-primary-btn {
    background: #0C4550; color: #fff; border: none; border-radius: 8px;
    padding: 8px 20px; font-size: 13px; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: opacity .15s;
  }
  .sg2-primary-btn:hover:not(:disabled) { opacity: 0.88; }
  .sg2-primary-btn:disabled { opacity: 0.4; cursor: not-allowed; }

  /* Inline Editing Styles - Updated with sleek highlights */
  .sg2-editable-text { cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: color 0.15s; border-bottom: 1px dashed transparent; }
  .sg2-editable-text:hover { color: #0C4550; border-bottom-color: #0C4550; }
  .sg2-editable-empty { color: #9ca3af; font-style: italic; }
  .sg2-edit-icon { font-size: 11px; opacity: 0; color: #0C4550; transition: opacity 0.2s; }
  .sg2-editable-text:hover .sg2-edit-icon { opacity: 1; }
  
  .sg2-inline-edit-input { 
    background: #fff; 
    border: 1px solid #0C4550; 
    border-radius: 6px; 
    padding: 4px 8px; 
    font-family: inherit; 
    font-size: inherit; 
    color: #111827; 
    width: 100%; 
    box-shadow: 0 0 0 3px rgba(12,69,80,0.15); 
    outline: none; 
    transition: all 0.2s ease;
  }
  .sg2-inline-edit-input:focus {
    border-color: #0C4550;
    box-shadow: 0 0 0 4px rgba(12, 69, 80, 0.25);
  }

  /* Custom Instant Dropdown CSS */
  .sg2-custom-dropdown-list {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    min-width: 100%;
    background: #fff;
    border: 1px solid #e5e9f0;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    z-index: 9999;
    max-height: 220px;
    overflow-y: auto;
    padding: 4px 0;
  }
  .sg2-custom-dropdown-item {
    padding: 8px 12px;
    font-size: 13px;
    color: #111827;
    cursor: pointer;
    transition: background 0.15s;
    white-space: nowrap;
  }
  .sg2-custom-dropdown-item:hover {
    background: #f1f5f9;
  }

  /* Lead info box (left panel) only: black professional edit state */
  .sg2-detail-panel .sg2-inline-edit-input {
    background: #111111;
    border: 1px solid #111111;
    color: #ffffff;
    box-shadow: 0 0 0 3px rgba(0,0,0,0.18);
  }
  .sg2-detail-panel .sg2-inline-edit-input:focus {
    border-color: #000000;
    box-shadow: 0 0 0 4px rgba(0,0,0,0.28);
  }
  .sg2-detail-panel .sg2-inline-edit-input::placeholder {
    color: #bbbbbb;
  }
  /* Dark mode support for instant dropdown */
  .sg2-detail-panel .sg2-custom-dropdown-list {
    background: #111111;
    border-color: #000;
  }
  .sg2-detail-panel .sg2-custom-dropdown-item {
    color: #fff;
  }
  .sg2-detail-panel .sg2-custom-dropdown-item:hover {
    background: #222;
  }
  /* Keep native dropdown options readable on black background (for backwards compatibility if any native selects remain) */
  .sg2-detail-panel select.sg2-inline-edit-input option {
    background: #111111;
    color: #ffffff;
  }
  
  .sg2-header-inline { font-size: 13px; font-weight: 600; color: #111827; }
  .sg2-editable-text.sg2-lead-name { font-size: 22px; font-weight: 700; color: #1a1f36; line-height: 1.2; display: inline-flex; }

  /* SMS Glassmorphism Grid and Pagination */
  .sg2-sms-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    gap: 12px;
    padding: 8px 0;
  }
  .sg2-sms-glass-card {
    aspect-ratio: 1;
    background: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.2s;
    text-align: left;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
    font-family: inherit;
  }
  .sg2-sms-glass-card:hover {
    transform: translateY(-3px);
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0 6px 20px rgba(0,0,0,0.1);
  }
  .sg2-sms-card-title {
    font-size: 13px;
    font-weight: 700;
    color: #0C4550;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .sg2-sms-card-preview {
    font-size: 11px;
    color: #4b5563;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .sg2-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding: 4px 8px;
    font-size: 13px;
    font-weight: 600;
    color: #0C4550;
  }
  .sg2-pagination button {
    background: #0C4550;
    color: #fff;
    border: none;
    padding: 6px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
    transition: opacity 0.2s;
  }
  .sg2-pagination button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Appointment modal pagination — Prev/Next kept close to the "Page X of Y" text */
  .sg2-apt-pagination {
    justify-content: center;
    gap: 16px;
    background: #f8fafc;
    border: 1px solid #e5e9f0;
    border-radius: 10px;
    padding: 8px 14px;
  }
  .sg2-apt-pagination-btns {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .sg2-apt-pagination-btns button {
    padding: 5px 12px;
    font-size: 11.5px;
  }

  /* Email/SMS Card Loader Overlay */
  .sg2-card-loader-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    border-radius: 12px;
    z-index: 10;
  }

  /* ── Chat History Modal ─────────────────────────────────────────── */
  .sg2-history-modal-container {
    max-width: 560px;
  }
  .sg2-history-lead-strip {
    display: flex; align-items: center; gap: 12px;
    padding: 14px 20px; border-bottom: 1px solid #f1f5f9;
    background: #f8fafc;
  }
  .sg2-history-lead-meta { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
  .sg2-history-lead-name { font-size: 14px; font-weight: 700; color: #1a1f36; }
  .sg2-history-lead-sub {
    display: flex; flex-wrap: wrap; gap: 10px;
    font-size: 12px; color: #6b7280; font-weight: 500;
  }
  .sg2-history-body-wrap {
    max-height: 60vh; overflow-y: auto; gap: 12px;
  }
  .sg2-history-empty {
    text-align: center; color: #9ca3af; font-size: 13px; padding: 24px 0; margin: 0;
  }
  .sg2-history-card {
    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px;
    padding: 14px 16px; margin-bottom: 10px;
  }
  .sg2-history-card-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; margin-bottom: 10px; }
  .sg2-history-avatar {
    width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
    background: #e0e8f5; color: #0C4550; font-weight: 700; font-size: 13px;
    display: flex; align-items: center; justify-content: center;
  }
  .sg2-history-changer { font-size: 13px; font-weight: 700; color: #1a1f36; }
  .sg2-history-time { font-size: 11px; color: #9ca3af; font-weight: 500; }
  .sg2-history-card-body { border-left: 2px solid #673AB7; padding-left: 12px; margin-left: 3px; }
  .sg2-history-row { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
  .sg2-history-row:last-child { margin-bottom: 0; }
  .sg2-history-dot { width: 6px; height: 6px; border-radius: 50%; background: #673AB7; flex-shrink: 0; }
  .sg2-history-dot--green { background: #16a34a; }
  .sg2-history-created-text { font-size: 12.5px; color: #374151; font-weight: 500; }
  .sg2-history-change { margin-bottom: 10px; }
  .sg2-history-change:last-child { margin-bottom: 0; }
  .sg2-history-change-field {
    font-size: 11px; font-weight: 700; color: #4b5563; text-transform: uppercase;
    letter-spacing: .03em; margin-bottom: 4px;
  }
  .sg2-history-change-values { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
  .sg2-history-from {
    font-size: 11.5px; padding: 2px 8px; border-radius: 6px;
    background: #fef2f2; color: #dc2626; font-weight: 600;
  }
  .sg2-history-to {
    font-size: 11.5px; padding: 2px 8px; border-radius: 6px;
    background: #f0fdf4; color: #16a34a; font-weight: 600;
  }
  .sg2-history-arrow { color: #9ca3af; font-size: 12px; }

  /* ── Appointment wizard modal ───────────────────────────────────── */
  .sg2-apt-modal-container { max-width: 640px; }
  .sg2-apt-steps {
    display: flex; align-items: center; gap: 8px;
    padding: 12px 20px 0; font-size: 12px; font-weight: 600; color: #9ca3af;
  }
  .sg2-apt-step { padding: 4px 10px; border-radius: 20px; background: #f1f5f9; }
  .sg2-apt-step--active { background: #0C4550; color: #fff; }
  .sg2-apt-step-sep { color: #cbd5e1; }
  .sg2-apt-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;
    padding: 6px 0 8px;
  }
  .sg2-apt-card {
    position: relative; text-align: left; cursor: pointer; font-family: inherit;
    background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 12px;
    padding: 14px 14px 12px; transition: all .15s;
  }
  .sg2-apt-card:hover { background: #f1f5f9; border-color: #c7d2e8; transform: translateY(-1px); }
  .sg2-apt-card--selected { background: #e8f4f7; border-color: #0C4550; box-shadow: 0 0 0 2px rgba(12,69,80,.12); }
  .sg2-apt-card-title { font-size: 13px; font-weight: 700; color: #1a1f36; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .sg2-apt-card-sub { font-size: 11.5px; color: #6b7280; margin-top: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .sg2-apt-check {
    position: absolute; top: 8px; right: 8px; width: 18px; height: 18px; border-radius: 50%;
    background: #0C4550; color: #fff; font-size: 11px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
  }
  .sg2-apt-summary {
    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px;
    padding: 10px 14px; font-size: 12.5px; color: #374151;
    display: flex; flex-direction: column; gap: 4px;
  }
  .sg2-apt-summary-label { font-weight: 700; color: #0C4550; margin-right: 4px; }
  @media (max-width: 640px) {
    .sg2-apt-grid { grid-template-columns: repeat(2, 1fr); }
  }

  /* ── Appointment search bar + "See All Departments" ──────────────── */
  .sg2-apt-search-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .sg2-apt-search-icon {
    position: absolute;
    left: 10px;
    pointer-events: none;
  }
  .sg2-apt-search-input {
    width: 260px !important;
    padding: 7px 12px 7px 32px !important;
    font-size: 12.5px !important;
    margin: 0 !important;
    min-height: auto !important;
    border-radius: 20px !important;
  }
  @media (max-width: 640px) {
    .sg2-apt-search-input { width: 160px !important; }
  }
  .sg2-apt-alldept-btn {
    white-space: nowrap;
    background: #f3e8ff;
    border: 1px solid #e4d3fb;
    color: #673AB7;
    font-size: 12px;
    font-weight: 700;
    padding: 7px 14px;
    border-radius: 20px;
    cursor: pointer;
    font-family: inherit;
    transition: all .15s;
  }
  .sg2-apt-alldept-btn:hover { background: #ecdcff; border-color: #d9bffb; }
  .sg2-apt-alldept-btn--active { background: #0C4550; border-color: #0C4550; color: #fff; }

  /* ── "See All Departments" combined browsable list ────────────────── */
  .sg2-apt-alldept-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 4px 0 8px;
  }
  .sg2-apt-alldept-group {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
  }
  .sg2-apt-alldept-dept-name {
    display: block;
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    font-size: 13px;
    font-weight: 700;
    color: #0C4550;
    margin-bottom: 8px;
    padding: 0 0 6px;
    border-bottom: 1px solid #e5e9f0;
  }
  .sg2-apt-alldept-dept-name--static {
    cursor: default;
  }
  .sg2-apt-alldept-dept-loc {
    font-size: 11.5px;
    font-weight: 600;
    color: #6b7280;
  }
  .sg2-apt-alldept-empty {
    font-size: 12px;
    color: #9ca3af;
    margin: 0;
    font-style: italic;
  }
  .sg2-apt-alldept-persons {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 8px;
  }
  .sg2-apt-alldept-person-btn {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    text-align: left;
    background: #fff;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    padding: 8px 10px;
    cursor: pointer;
    font-family: inherit;
    transition: all .15s;
  }
  .sg2-apt-alldept-person-btn:hover {
    border-color: #c7d2e8;
    background: #f1f5f9;
    transform: translateY(-1px);
  }
  .sg2-apt-alldept-person-btn--selected {
    background: #e8f4f7;
    border-color: #0C4550;
    box-shadow: 0 0 0 2px rgba(12,69,80,.12);
  }
  .sg2-apt-alldept-person-name {
    font-size: 12.5px;
    font-weight: 700;
    color: #1a1f36;
  }
  .sg2-apt-alldept-person-pos {
    font-size: 11px;
    color: #6b7280;
  }

  /* ── Appointment history list ──────────────────────── */
  .sg2-apt-new-btn {
    display: inline-flex; align-items: center; gap: 6px;
    background: #0C4550; color: #fff; border: none; border-radius: 8px;
    padding: 9px 16px; font-size: 13px; font-weight: 600; cursor: pointer;
    font-family: inherit; margin-bottom: 14px; transition: opacity .15s;
  }
  .sg2-apt-new-btn:hover { opacity: .9; }
  .sg2-apt-hist-list { display: flex; flex-direction: column; gap: 10px; }
  .sg2-apt-hist-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 14px 16px; }
  .sg2-apt-hist-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
  .sg2-apt-hist-dept { font-size: 13px; font-weight: 700; color: #1a1f36; }
  .sg2-apt-hist-person { font-size: 12px; color: #6b7280; margin-top: 2px; }
  .sg2-apt-hist-meta { display: flex; gap: 14px; font-size: 12px; color: #4b5563; margin-top: 8px; font-weight: 500; }
  .sg2-apt-hist-notes { font-size: 12px; color: #374151; margin-top: 8px; background: #fff; border: 1px solid #e5e9f0; border-radius: 8px; padding: 8px 10px; }
  .sg2-apt-status-badge {
    font-size: 10.5px; font-weight: 700; padding: 3px 10px; border-radius: 20px;
    text-transform: uppercase; letter-spacing: .03em; white-space: nowrap; flex-shrink: 0;
    background: #e2e8f0; color: #475569;
  }
  .sg2-apt-status-badge--scheduled { background: #dbeafe; color: #1d4ed8; }
  .sg2-apt-status-badge--completed { background: #dcfce7; color: #16a34a; }
  .sg2-apt-status-badge--cancelled { background: #fee2e2; color: #dc2626; }
  .sg2-apt-status-badge--rescheduled { background: #fef3c7; color: #b45309; }
  .sg2-apt-status-badge--no_show { background: #f1f5f9; color: #64748b; }

  /* Toggle Switch for Boolean Fields */
  .sg2-toggle-switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 18px;
    flex-shrink: 0;
  }
  .sg2-toggle-switch input { opacity: 0; width: 0; height: 0; }
  .sg2-toggle-slider {
    position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;
    background-color: #cbd5e1; transition: .3s; border-radius: 20px;
  }
  .sg2-toggle-slider:before {
    position: absolute; content: ""; height: 12px; width: 12px; left: 3px; bottom: 3px;
    background-color: white; transition: .3s; border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  }
  .sg2-toggle-switch input:checked + .sg2-toggle-slider { background-color: #0C4550; }
  .sg2-toggle-switch input:checked + .sg2-toggle-slider:before { transform: translateX(16px); }

`;

export default SalesGod;